/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateUserInput = {
  id?: string | null,
  userName: string,
  dynamoId?: string | null,
  cognitoId: string,
  title?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  email: string,
  password?: string | null,
  gamesMade?: number | null,
  gamesUsed?: number | null,
  questionsMade?: number | null,
  frontIdPath?: string | null,
  backIdPath?: string | null,
  profilePicPath?: string | null,
  favoriteGameTemplateIds?: string | null,
  favoriteQuestionTemplateIds?: string | null,
};

export type ModelUserConditionInput = {
  userName?: ModelStringInput | null,
  dynamoId?: ModelStringInput | null,
  cognitoId?: ModelStringInput | null,
  title?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  email?: ModelStringInput | null,
  password?: ModelStringInput | null,
  gamesMade?: ModelIntInput | null,
  gamesUsed?: ModelIntInput | null,
  questionsMade?: ModelIntInput | null,
  frontIdPath?: ModelStringInput | null,
  backIdPath?: ModelStringInput | null,
  profilePicPath?: ModelStringInput | null,
  favoriteGameTemplateIds?: ModelStringInput | null,
  favoriteQuestionTemplateIds?: ModelStringInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type User = {
  __typename: "User",
  id: string,
  userName: string,
  dynamoId?: string | null,
  cognitoId: string,
  title?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  email: string,
  password?: string | null,
  gamesMade?: number | null,
  gamesUsed?: number | null,
  questionsMade?: number | null,
  frontIdPath?: string | null,
  backIdPath?: string | null,
  profilePicPath?: string | null,
  favoriteGameTemplateIds?: string | null,
  favoriteQuestionTemplateIds?: string | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateUserInput = {
  id: string,
  userName?: string | null,
  dynamoId?: string | null,
  cognitoId?: string | null,
  title?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  password?: string | null,
  gamesMade?: number | null,
  gamesUsed?: number | null,
  questionsMade?: number | null,
  frontIdPath?: string | null,
  backIdPath?: string | null,
  profilePicPath?: string | null,
  favoriteGameTemplateIds?: string | null,
  favoriteQuestionTemplateIds?: string | null,
};

export type DeleteUserInput = {
  id: string,
};

export type CreatePublicGameTemplateInput = {
  id?: string | null,
  userId?: string | null,
  publicPrivateType?: string | null,
  title: string,
  lowerCaseTitle: string,
  version: number,
  description: string,
  lowerCaseDescription: string,
  ccss?: string | null,
  ccssDescription?: string | null,
  domain?: string | null,
  cluster?: string | null,
  grade?: string | null,
  gradeFilter?: string | null,
  standard?: string | null,
  phaseOneTime?: number | null,
  phaseTwoTime?: number | null,
  imageUrl?: string | null,
  timesPlayed?: number | null,
  questionTemplatesCount: number,
  questionTemplatesOrder?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  featuredGroup?: string | null,
  featuredOrder?: number | null,
  type?: string | null,
};

export type ModelPublicGameTemplateConditionInput = {
  userId?: ModelStringInput | null,
  publicPrivateType?: ModelStringInput | null,
  title?: ModelStringInput | null,
  lowerCaseTitle?: ModelStringInput | null,
  version?: ModelIntInput | null,
  description?: ModelStringInput | null,
  lowerCaseDescription?: ModelStringInput | null,
  ccss?: ModelStringInput | null,
  ccssDescription?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  cluster?: ModelStringInput | null,
  grade?: ModelStringInput | null,
  gradeFilter?: ModelStringInput | null,
  standard?: ModelStringInput | null,
  phaseOneTime?: ModelIntInput | null,
  phaseTwoTime?: ModelIntInput | null,
  imageUrl?: ModelStringInput | null,
  timesPlayed?: ModelIntInput | null,
  questionTemplatesCount?: ModelIntInput | null,
  questionTemplatesOrder?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  featuredGroup?: ModelStringInput | null,
  featuredOrder?: ModelIntInput | null,
  type?: ModelStringInput | null,
  and?: Array< ModelPublicGameTemplateConditionInput | null > | null,
  or?: Array< ModelPublicGameTemplateConditionInput | null > | null,
  not?: ModelPublicGameTemplateConditionInput | null,
};

export type PublicGameTemplate = {
  __typename: "PublicGameTemplate",
  id: string,
  userId?: string | null,
  publicPrivateType?: string | null,
  title: string,
  lowerCaseTitle: string,
  version: number,
  description: string,
  lowerCaseDescription: string,
  ccss?: string | null,
  ccssDescription?: string | null,
  domain?: string | null,
  cluster?: string | null,
  grade?: string | null,
  gradeFilter?: string | null,
  standard?: string | null,
  phaseOneTime?: number | null,
  phaseTwoTime?: number | null,
  imageUrl?: string | null,
  timesPlayed?: number | null,
  questionTemplates?: ModelPublicGameQuestionsConnection | null,
  questionTemplatesCount: number,
  questionTemplatesOrder?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  featuredGroup?: string | null,
  featuredOrder?: number | null,
  type?: string | null,
  owner?: string | null,
};

export type ModelPublicGameQuestionsConnection = {
  __typename: "ModelPublicGameQuestionsConnection",
  items:  Array<PublicGameQuestions | null >,
  nextToken?: string | null,
};

export type PublicGameQuestions = {
  __typename: "PublicGameQuestions",
  id: string,
  publicGameTemplateID: string,
  publicQuestionTemplateID: string,
  publicGameTemplate: PublicGameTemplate,
  publicQuestionTemplate: PublicQuestionTemplate,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type PublicQuestionTemplate = {
  __typename: "PublicQuestionTemplate",
  id: string,
  userId?: string | null,
  publicPrivateType?: string | null,
  title: string,
  lowerCaseTitle: string,
  version: number,
  choices?: string | null,
  instructions?: string | null,
  answerSettings?: string | null,
  ccss?: string | null,
  ccssDescription?: string | null,
  domain?: string | null,
  cluster?: string | null,
  grade?: string | null,
  gradeFilter?: string | null,
  standard?: string | null,
  imageUrl?: string | null,
  timesPlayed?: number | null,
  gameTemplates?: ModelPublicGameQuestionsConnection | null,
  gameTemplatesCount: number,
  createdAt?: string | null,
  updatedAt?: string | null,
  type?: string | null,
  owner?: string | null,
};

export type UpdatePublicGameTemplateInput = {
  id: string,
  userId?: string | null,
  publicPrivateType?: string | null,
  title?: string | null,
  lowerCaseTitle?: string | null,
  version?: number | null,
  description?: string | null,
  lowerCaseDescription?: string | null,
  ccss?: string | null,
  ccssDescription?: string | null,
  domain?: string | null,
  cluster?: string | null,
  grade?: string | null,
  gradeFilter?: string | null,
  standard?: string | null,
  phaseOneTime?: number | null,
  phaseTwoTime?: number | null,
  imageUrl?: string | null,
  timesPlayed?: number | null,
  questionTemplatesCount?: number | null,
  questionTemplatesOrder?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  featuredGroup?: string | null,
  featuredOrder?: number | null,
  type?: string | null,
};

export type DeletePublicGameTemplateInput = {
  id: string,
};

export type CreatePrivateGameTemplateInput = {
  id?: string | null,
  userId?: string | null,
  publicPrivateType?: string | null,
  title: string,
  lowerCaseTitle: string,
  version: number,
  description: string,
  lowerCaseDescription: string,
  ccss?: string | null,
  ccssDescription?: string | null,
  domain?: string | null,
  cluster?: string | null,
  grade?: string | null,
  gradeFilter?: string | null,
  standard?: string | null,
  phaseOneTime?: number | null,
  phaseTwoTime?: number | null,
  imageUrl?: string | null,
  timesPlayed?: number | null,
  questionTemplatesCount: number,
  questionTemplatesOrder?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  type?: string | null,
};

export type ModelPrivateGameTemplateConditionInput = {
  userId?: ModelStringInput | null,
  publicPrivateType?: ModelStringInput | null,
  title?: ModelStringInput | null,
  lowerCaseTitle?: ModelStringInput | null,
  version?: ModelIntInput | null,
  description?: ModelStringInput | null,
  lowerCaseDescription?: ModelStringInput | null,
  ccss?: ModelStringInput | null,
  ccssDescription?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  cluster?: ModelStringInput | null,
  grade?: ModelStringInput | null,
  gradeFilter?: ModelStringInput | null,
  standard?: ModelStringInput | null,
  phaseOneTime?: ModelIntInput | null,
  phaseTwoTime?: ModelIntInput | null,
  imageUrl?: ModelStringInput | null,
  timesPlayed?: ModelIntInput | null,
  questionTemplatesCount?: ModelIntInput | null,
  questionTemplatesOrder?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  type?: ModelStringInput | null,
  and?: Array< ModelPrivateGameTemplateConditionInput | null > | null,
  or?: Array< ModelPrivateGameTemplateConditionInput | null > | null,
  not?: ModelPrivateGameTemplateConditionInput | null,
};

export type PrivateGameTemplate = {
  __typename: "PrivateGameTemplate",
  id: string,
  userId?: string | null,
  publicPrivateType?: string | null,
  title: string,
  lowerCaseTitle: string,
  version: number,
  description: string,
  lowerCaseDescription: string,
  ccss?: string | null,
  ccssDescription?: string | null,
  domain?: string | null,
  cluster?: string | null,
  grade?: string | null,
  gradeFilter?: string | null,
  standard?: string | null,
  phaseOneTime?: number | null,
  phaseTwoTime?: number | null,
  imageUrl?: string | null,
  timesPlayed?: number | null,
  questionTemplates?: ModelPrivateGameQuestionsConnection | null,
  questionTemplatesCount: number,
  questionTemplatesOrder?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  type?: string | null,
  owner?: string | null,
};

export type ModelPrivateGameQuestionsConnection = {
  __typename: "ModelPrivateGameQuestionsConnection",
  items:  Array<PrivateGameQuestions | null >,
  nextToken?: string | null,
};

export type PrivateGameQuestions = {
  __typename: "PrivateGameQuestions",
  id: string,
  privateGameTemplateID: string,
  privateQuestionTemplateID: string,
  privateGameTemplate: PrivateGameTemplate,
  privateQuestionTemplate: PrivateQuestionTemplate,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type PrivateQuestionTemplate = {
  __typename: "PrivateQuestionTemplate",
  id: string,
  userId?: string | null,
  publicPrivateType?: string | null,
  title: string,
  lowerCaseTitle: string,
  version: number,
  choices?: string | null,
  instructions?: string | null,
  answerSettings?: string | null,
  ccss?: string | null,
  ccssDescription?: string | null,
  domain?: string | null,
  cluster?: string | null,
  grade?: string | null,
  gradeFilter?: string | null,
  standard?: string | null,
  imageUrl?: string | null,
  timesPlayed?: number | null,
  gameTemplates?: ModelPrivateGameQuestionsConnection | null,
  gameTemplatesCount: number,
  createdAt?: string | null,
  updatedAt?: string | null,
  type?: string | null,
  owner?: string | null,
};

export type UpdatePrivateGameTemplateInput = {
  id: string,
  userId?: string | null,
  publicPrivateType?: string | null,
  title?: string | null,
  lowerCaseTitle?: string | null,
  version?: number | null,
  description?: string | null,
  lowerCaseDescription?: string | null,
  ccss?: string | null,
  ccssDescription?: string | null,
  domain?: string | null,
  cluster?: string | null,
  grade?: string | null,
  gradeFilter?: string | null,
  standard?: string | null,
  phaseOneTime?: number | null,
  phaseTwoTime?: number | null,
  imageUrl?: string | null,
  timesPlayed?: number | null,
  questionTemplatesCount?: number | null,
  questionTemplatesOrder?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  type?: string | null,
};

export type DeletePrivateGameTemplateInput = {
  id: string,
};

export type CreateDraftGameTemplateInput = {
  id?: string | null,
  userId?: string | null,
  publicPrivateType?: string | null,
  title?: string | null,
  lowerCaseTitle?: string | null,
  version?: number | null,
  description?: string | null,
  lowerCaseDescription?: string | null,
  ccss?: string | null,
  ccssDescription?: string | null,
  domain?: string | null,
  cluster?: string | null,
  grade?: string | null,
  gradeFilter?: string | null,
  standard?: string | null,
  phaseOneTime?: number | null,
  phaseTwoTime?: number | null,
  imageUrl?: string | null,
  timesPlayed?: number | null,
  questionTemplatesCount: number,
  questionTemplatesOrder?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  type?: string | null,
};

export type ModelDraftGameTemplateConditionInput = {
  userId?: ModelStringInput | null,
  publicPrivateType?: ModelStringInput | null,
  title?: ModelStringInput | null,
  lowerCaseTitle?: ModelStringInput | null,
  version?: ModelIntInput | null,
  description?: ModelStringInput | null,
  lowerCaseDescription?: ModelStringInput | null,
  ccss?: ModelStringInput | null,
  ccssDescription?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  cluster?: ModelStringInput | null,
  grade?: ModelStringInput | null,
  gradeFilter?: ModelStringInput | null,
  standard?: ModelStringInput | null,
  phaseOneTime?: ModelIntInput | null,
  phaseTwoTime?: ModelIntInput | null,
  imageUrl?: ModelStringInput | null,
  timesPlayed?: ModelIntInput | null,
  questionTemplatesCount?: ModelIntInput | null,
  questionTemplatesOrder?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  type?: ModelStringInput | null,
  and?: Array< ModelDraftGameTemplateConditionInput | null > | null,
  or?: Array< ModelDraftGameTemplateConditionInput | null > | null,
  not?: ModelDraftGameTemplateConditionInput | null,
};

export type DraftGameTemplate = {
  __typename: "DraftGameTemplate",
  id: string,
  userId?: string | null,
  publicPrivateType?: string | null,
  title?: string | null,
  lowerCaseTitle?: string | null,
  version?: number | null,
  description?: string | null,
  lowerCaseDescription?: string | null,
  ccss?: string | null,
  ccssDescription?: string | null,
  domain?: string | null,
  cluster?: string | null,
  grade?: string | null,
  gradeFilter?: string | null,
  standard?: string | null,
  phaseOneTime?: number | null,
  phaseTwoTime?: number | null,
  imageUrl?: string | null,
  timesPlayed?: number | null,
  questionTemplates?: ModelDraftGameQuestionsConnection | null,
  questionTemplatesCount: number,
  questionTemplatesOrder?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  type?: string | null,
  owner?: string | null,
};

export type ModelDraftGameQuestionsConnection = {
  __typename: "ModelDraftGameQuestionsConnection",
  items:  Array<DraftGameQuestions | null >,
  nextToken?: string | null,
};

export type DraftGameQuestions = {
  __typename: "DraftGameQuestions",
  id: string,
  draftGameTemplateID: string,
  draftQuestionTemplateID: string,
  draftGameTemplate: DraftGameTemplate,
  draftQuestionTemplate: DraftQuestionTemplate,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type DraftQuestionTemplate = {
  __typename: "DraftQuestionTemplate",
  id?: string | null,
  userId?: string | null,
  publicPrivateType?: string | null,
  title?: string | null,
  lowerCaseTitle?: string | null,
  version?: number | null,
  choices?: string | null,
  instructions?: string | null,
  answerSettings?: string | null,
  ccss?: string | null,
  ccssDescription?: string | null,
  domain?: string | null,
  cluster?: string | null,
  grade?: string | null,
  gradeFilter?: string | null,
  standard?: string | null,
  imageUrl?: string | null,
  timesPlayed?: number | null,
  gameTemplates?: ModelDraftGameQuestionsConnection | null,
  gameTemplatesCount: number,
  createdAt?: string | null,
  updatedAt?: string | null,
  type?: string | null,
  owner?: string | null,
};

export type UpdateDraftGameTemplateInput = {
  id: string,
  userId?: string | null,
  publicPrivateType?: string | null,
  title?: string | null,
  lowerCaseTitle?: string | null,
  version?: number | null,
  description?: string | null,
  lowerCaseDescription?: string | null,
  ccss?: string | null,
  ccssDescription?: string | null,
  domain?: string | null,
  cluster?: string | null,
  grade?: string | null,
  gradeFilter?: string | null,
  standard?: string | null,
  phaseOneTime?: number | null,
  phaseTwoTime?: number | null,
  imageUrl?: string | null,
  timesPlayed?: number | null,
  questionTemplatesCount?: number | null,
  questionTemplatesOrder?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  type?: string | null,
};

export type DeleteDraftGameTemplateInput = {
  id: string,
};

export type CreatePublicQuestionTemplateInput = {
  id?: string | null,
  userId?: string | null,
  publicPrivateType?: string | null,
  title: string,
  lowerCaseTitle: string,
  version: number,
  choices?: string | null,
  instructions?: string | null,
  answerSettings?: string | null,
  ccss?: string | null,
  ccssDescription?: string | null,
  domain?: string | null,
  cluster?: string | null,
  grade?: string | null,
  gradeFilter?: string | null,
  standard?: string | null,
  imageUrl?: string | null,
  timesPlayed?: number | null,
  gameTemplatesCount: number,
  createdAt?: string | null,
  updatedAt?: string | null,
  type?: string | null,
};

export type ModelPublicQuestionTemplateConditionInput = {
  userId?: ModelStringInput | null,
  publicPrivateType?: ModelStringInput | null,
  title?: ModelStringInput | null,
  lowerCaseTitle?: ModelStringInput | null,
  version?: ModelIntInput | null,
  choices?: ModelStringInput | null,
  instructions?: ModelStringInput | null,
  answerSettings?: ModelStringInput | null,
  ccss?: ModelStringInput | null,
  ccssDescription?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  cluster?: ModelStringInput | null,
  grade?: ModelStringInput | null,
  gradeFilter?: ModelStringInput | null,
  standard?: ModelStringInput | null,
  imageUrl?: ModelStringInput | null,
  timesPlayed?: ModelIntInput | null,
  gameTemplatesCount?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  type?: ModelStringInput | null,
  and?: Array< ModelPublicQuestionTemplateConditionInput | null > | null,
  or?: Array< ModelPublicQuestionTemplateConditionInput | null > | null,
  not?: ModelPublicQuestionTemplateConditionInput | null,
};

export type UpdatePublicQuestionTemplateInput = {
  id: string,
  userId?: string | null,
  publicPrivateType?: string | null,
  title?: string | null,
  lowerCaseTitle?: string | null,
  version?: number | null,
  choices?: string | null,
  instructions?: string | null,
  answerSettings?: string | null,
  ccss?: string | null,
  ccssDescription?: string | null,
  domain?: string | null,
  cluster?: string | null,
  grade?: string | null,
  gradeFilter?: string | null,
  standard?: string | null,
  imageUrl?: string | null,
  timesPlayed?: number | null,
  gameTemplatesCount?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  type?: string | null,
};

export type DeletePublicQuestionTemplateInput = {
  id: string,
};

export type CreatePrivateQuestionTemplateInput = {
  id?: string | null,
  userId?: string | null,
  publicPrivateType?: string | null,
  title: string,
  lowerCaseTitle: string,
  version: number,
  choices?: string | null,
  instructions?: string | null,
  answerSettings?: string | null,
  ccss?: string | null,
  ccssDescription?: string | null,
  domain?: string | null,
  cluster?: string | null,
  grade?: string | null,
  gradeFilter?: string | null,
  standard?: string | null,
  imageUrl?: string | null,
  timesPlayed?: number | null,
  gameTemplatesCount: number,
  createdAt?: string | null,
  updatedAt?: string | null,
  type?: string | null,
};

export type ModelPrivateQuestionTemplateConditionInput = {
  userId?: ModelStringInput | null,
  publicPrivateType?: ModelStringInput | null,
  title?: ModelStringInput | null,
  lowerCaseTitle?: ModelStringInput | null,
  version?: ModelIntInput | null,
  choices?: ModelStringInput | null,
  instructions?: ModelStringInput | null,
  answerSettings?: ModelStringInput | null,
  ccss?: ModelStringInput | null,
  ccssDescription?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  cluster?: ModelStringInput | null,
  grade?: ModelStringInput | null,
  gradeFilter?: ModelStringInput | null,
  standard?: ModelStringInput | null,
  imageUrl?: ModelStringInput | null,
  timesPlayed?: ModelIntInput | null,
  gameTemplatesCount?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  type?: ModelStringInput | null,
  and?: Array< ModelPrivateQuestionTemplateConditionInput | null > | null,
  or?: Array< ModelPrivateQuestionTemplateConditionInput | null > | null,
  not?: ModelPrivateQuestionTemplateConditionInput | null,
};

export type UpdatePrivateQuestionTemplateInput = {
  id: string,
  userId?: string | null,
  publicPrivateType?: string | null,
  title?: string | null,
  lowerCaseTitle?: string | null,
  version?: number | null,
  choices?: string | null,
  instructions?: string | null,
  answerSettings?: string | null,
  ccss?: string | null,
  ccssDescription?: string | null,
  domain?: string | null,
  cluster?: string | null,
  grade?: string | null,
  gradeFilter?: string | null,
  standard?: string | null,
  imageUrl?: string | null,
  timesPlayed?: number | null,
  gameTemplatesCount?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  type?: string | null,
};

export type DeletePrivateQuestionTemplateInput = {
  id: string,
};

export type CreateDraftQuestionTemplateInput = {
  id?: string | null,
  userId?: string | null,
  publicPrivateType?: string | null,
  title?: string | null,
  lowerCaseTitle?: string | null,
  version?: number | null,
  choices?: string | null,
  instructions?: string | null,
  answerSettings?: string | null,
  ccss?: string | null,
  ccssDescription?: string | null,
  domain?: string | null,
  cluster?: string | null,
  grade?: string | null,
  gradeFilter?: string | null,
  standard?: string | null,
  imageUrl?: string | null,
  timesPlayed?: number | null,
  gameTemplatesCount: number,
  createdAt?: string | null,
  updatedAt?: string | null,
  type?: string | null,
};

export type ModelDraftQuestionTemplateConditionInput = {
  userId?: ModelStringInput | null,
  publicPrivateType?: ModelStringInput | null,
  title?: ModelStringInput | null,
  lowerCaseTitle?: ModelStringInput | null,
  version?: ModelIntInput | null,
  choices?: ModelStringInput | null,
  instructions?: ModelStringInput | null,
  answerSettings?: ModelStringInput | null,
  ccss?: ModelStringInput | null,
  ccssDescription?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  cluster?: ModelStringInput | null,
  grade?: ModelStringInput | null,
  gradeFilter?: ModelStringInput | null,
  standard?: ModelStringInput | null,
  imageUrl?: ModelStringInput | null,
  timesPlayed?: ModelIntInput | null,
  gameTemplatesCount?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  type?: ModelStringInput | null,
  and?: Array< ModelDraftQuestionTemplateConditionInput | null > | null,
  or?: Array< ModelDraftQuestionTemplateConditionInput | null > | null,
  not?: ModelDraftQuestionTemplateConditionInput | null,
};

export type UpdateDraftQuestionTemplateInput = {
  id: string,
  userId?: string | null,
  publicPrivateType?: string | null,
  title?: string | null,
  lowerCaseTitle?: string | null,
  version?: number | null,
  choices?: string | null,
  instructions?: string | null,
  answerSettings?: string | null,
  ccss?: string | null,
  ccssDescription?: string | null,
  domain?: string | null,
  cluster?: string | null,
  grade?: string | null,
  gradeFilter?: string | null,
  standard?: string | null,
  imageUrl?: string | null,
  timesPlayed?: number | null,
  gameTemplatesCount?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  type?: string | null,
};

export type DeleteDraftQuestionTemplateInput = {
  id: string,
};

export type CreateGameSessionInput = {
  id?: string | null,
  classroomId?: string | null,
  gameId: string,
  startTime?: string | null,
  phaseOneTime: number,
  phaseTwoTime: number,
  currentQuestionIndex?: number | null,
  currentState: GameSessionState,
  gameCode: number,
  isAdvancedMode: boolean,
  imageUrl?: string | null,
  description?: string | null,
  title?: string | null,
  currentTimer?: number | null,
  studentID?: number | null,
  sessionData?: string | null,
};

export enum GameSessionState {
  NOT_STARTED = "NOT_STARTED",
  TEAMS_JOINING = "TEAMS_JOINING",
  CHOOSE_CORRECT_ANSWER = "CHOOSE_CORRECT_ANSWER",
  PHASE_1_DISCUSS = "PHASE_1_DISCUSS",
  PHASE_2_START = "PHASE_2_START",
  CHOOSE_TRICKIEST_ANSWER = "CHOOSE_TRICKIEST_ANSWER",
  PHASE_2_DISCUSS = "PHASE_2_DISCUSS",
  FINAL_RESULTS = "FINAL_RESULTS",
  FINISHED = "FINISHED",
}


export type ModelGameSessionConditionInput = {
  classroomId?: ModelStringInput | null,
  gameId?: ModelIDInput | null,
  startTime?: ModelStringInput | null,
  phaseOneTime?: ModelIntInput | null,
  phaseTwoTime?: ModelIntInput | null,
  currentQuestionIndex?: ModelIntInput | null,
  currentState?: ModelGameSessionStateInput | null,
  gameCode?: ModelIntInput | null,
  isAdvancedMode?: ModelBooleanInput | null,
  imageUrl?: ModelStringInput | null,
  description?: ModelStringInput | null,
  title?: ModelStringInput | null,
  currentTimer?: ModelIntInput | null,
  studentID?: ModelIntInput | null,
  sessionData?: ModelStringInput | null,
  and?: Array< ModelGameSessionConditionInput | null > | null,
  or?: Array< ModelGameSessionConditionInput | null > | null,
  not?: ModelGameSessionConditionInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelGameSessionStateInput = {
  eq?: GameSessionState | null,
  ne?: GameSessionState | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type GameSession = {
  __typename: "GameSession",
  id: string,
  classroomId?: string | null,
  gameId: string,
  startTime?: string | null,
  phaseOneTime: number,
  phaseTwoTime: number,
  teams?: ModelTeamConnection | null,
  currentQuestionIndex?: number | null,
  currentState: GameSessionState,
  gameCode: number,
  isAdvancedMode: boolean,
  imageUrl?: string | null,
  description?: string | null,
  title?: string | null,
  currentTimer?: number | null,
  studentID?: number | null,
  sessionData?: string | null,
  questions?: ModelQuestionConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelTeamConnection = {
  __typename: "ModelTeamConnection",
  items:  Array<Team | null >,
  nextToken?: string | null,
};

export type Team = {
  __typename: "Team",
  id: string,
  globalStudentId?: string | null,
  name: string,
  question?: Question | null,
  teamMembers?: ModelTeamMemberConnection | null,
  score: number,
  selectedAvatarIndex: number,
  createdAt: string,
  updatedAt: string,
  gameSessionTeamsId?: string | null,
  teamQuestionId?: string | null,
  teamQuestionOrder?: number | null,
  teamQuestionGameSessionId?: string | null,
};

export type Question = {
  __typename: "Question",
  id: string,
  text: string,
  choices?: string | null,
  answerSettings?: string | null,
  answerData?: string | null,
  hints?: string | null,
  imageUrl?: string | null,
  instructions?: string | null,
  standard?: string | null,
  cluster?: string | null,
  domain?: string | null,
  grade?: string | null,
  order: number,
  isConfidenceEnabled: boolean,
  isShortAnswerEnabled: boolean,
  isHintEnabled: boolean,
  gameSessionId: string,
};

export type ModelTeamMemberConnection = {
  __typename: "ModelTeamMemberConnection",
  items:  Array<TeamMember | null >,
  nextToken?: string | null,
};

export type TeamMember = {
  __typename: "TeamMember",
  id: string,
  isFacilitator?: boolean | null,
  answers?: ModelTeamAnswerConnection | null,
  deviceId: string,
  createdAt: string,
  updatedAt: string,
  teamTeamMembersId?: string | null,
};

export type ModelTeamAnswerConnection = {
  __typename: "ModelTeamAnswerConnection",
  items:  Array<TeamAnswer | null >,
  nextToken?: string | null,
};

export type TeamAnswer = {
  __typename: "TeamAnswer",
  id: string,
  isCorrect?: boolean | null,
  isSubmitted: boolean,
  isShortAnswerEnabled: boolean,
  currentState: GameSessionState,
  currentQuestionIndex: number,
  questionId: string,
  teamMemberAnswersId: string,
  teamAnswersId: string,
  teamName?: string | null,
  text: string,
  answer: string,
  confidenceLevel?: ConfidenceLevel | null,
  hint?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum ConfidenceLevel {
  NOT_RATED = "NOT_RATED",
  NOT_AT_ALL = "NOT_AT_ALL",
  KINDA = "KINDA",
  QUITE = "QUITE",
  VERY = "VERY",
  TOTALLY = "TOTALLY",
}


export type ModelQuestionConnection = {
  __typename: "ModelQuestionConnection",
  items:  Array<Question | null >,
  nextToken?: string | null,
};

export type UpdateGameSessionInput = {
  id: string,
  classroomId?: string | null,
  gameId?: string | null,
  startTime?: string | null,
  phaseOneTime?: number | null,
  phaseTwoTime?: number | null,
  currentQuestionIndex?: number | null,
  currentState?: GameSessionState | null,
  gameCode?: number | null,
  isAdvancedMode?: boolean | null,
  imageUrl?: string | null,
  description?: string | null,
  title?: string | null,
  currentTimer?: number | null,
  studentID?: number | null,
  sessionData?: string | null,
};

export type DeleteGameSessionInput = {
  id: string,
};

export type CreateQuestionInput = {
  id?: string | null,
  text: string,
  choices?: string | null,
  answerSettings?: string | null,
  answerData?: string | null,
  hints?: string | null,
  imageUrl?: string | null,
  instructions?: string | null,
  standard?: string | null,
  cluster?: string | null,
  domain?: string | null,
  grade?: string | null,
  order: number,
  isConfidenceEnabled: boolean,
  isShortAnswerEnabled: boolean,
  isHintEnabled: boolean,
  gameSessionId: string,
};

export type ModelQuestionConditionInput = {
  text?: ModelStringInput | null,
  choices?: ModelStringInput | null,
  answerSettings?: ModelStringInput | null,
  answerData?: ModelStringInput | null,
  hints?: ModelStringInput | null,
  imageUrl?: ModelStringInput | null,
  instructions?: ModelStringInput | null,
  standard?: ModelStringInput | null,
  cluster?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  grade?: ModelStringInput | null,
  isConfidenceEnabled?: ModelBooleanInput | null,
  isShortAnswerEnabled?: ModelBooleanInput | null,
  isHintEnabled?: ModelBooleanInput | null,
  and?: Array< ModelQuestionConditionInput | null > | null,
  or?: Array< ModelQuestionConditionInput | null > | null,
  not?: ModelQuestionConditionInput | null,
};

export type UpdateQuestionInput = {
  id: string,
  text?: string | null,
  choices?: string | null,
  answerSettings?: string | null,
  answerData?: string | null,
  hints?: string | null,
  imageUrl?: string | null,
  instructions?: string | null,
  standard?: string | null,
  cluster?: string | null,
  domain?: string | null,
  grade?: string | null,
  order: number,
  isConfidenceEnabled?: boolean | null,
  isShortAnswerEnabled?: boolean | null,
  isHintEnabled?: boolean | null,
  gameSessionId: string,
};

export type DeleteQuestionInput = {
  id: string,
  order: number,
  gameSessionId: string,
};

export type CreateTeamInput = {
  id?: string | null,
  globalStudentId?: string | null,
  name: string,
  score: number,
  selectedAvatarIndex: number,
  gameSessionTeamsId?: string | null,
  teamQuestionId?: string | null,
  teamQuestionOrder?: number | null,
  teamQuestionGameSessionId?: string | null,
};

export type ModelTeamConditionInput = {
  globalStudentId?: ModelStringInput | null,
  name?: ModelStringInput | null,
  score?: ModelIntInput | null,
  selectedAvatarIndex?: ModelIntInput | null,
  and?: Array< ModelTeamConditionInput | null > | null,
  or?: Array< ModelTeamConditionInput | null > | null,
  not?: ModelTeamConditionInput | null,
  gameSessionTeamsId?: ModelIDInput | null,
  teamQuestionId?: ModelIDInput | null,
  teamQuestionOrder?: ModelIntInput | null,
  teamQuestionGameSessionId?: ModelIDInput | null,
};

export type UpdateTeamInput = {
  id: string,
  globalStudentId?: string | null,
  name?: string | null,
  score?: number | null,
  selectedAvatarIndex?: number | null,
  gameSessionTeamsId?: string | null,
  teamQuestionId?: string | null,
  teamQuestionOrder?: number | null,
  teamQuestionGameSessionId?: string | null,
};

export type DeleteTeamInput = {
  id: string,
};

export type CreateTeamMemberInput = {
  id?: string | null,
  isFacilitator?: boolean | null,
  deviceId: string,
  teamTeamMembersId?: string | null,
};

export type ModelTeamMemberConditionInput = {
  isFacilitator?: ModelBooleanInput | null,
  deviceId?: ModelIDInput | null,
  and?: Array< ModelTeamMemberConditionInput | null > | null,
  or?: Array< ModelTeamMemberConditionInput | null > | null,
  not?: ModelTeamMemberConditionInput | null,
  teamTeamMembersId?: ModelIDInput | null,
};

export type UpdateTeamMemberInput = {
  id: string,
  isFacilitator?: boolean | null,
  deviceId?: string | null,
  teamTeamMembersId?: string | null,
};

export type DeleteTeamMemberInput = {
  id: string,
};

export type CreateTeamAnswerInput = {
  id?: string | null,
  isCorrect?: boolean | null,
  isSubmitted: boolean,
  isShortAnswerEnabled: boolean,
  currentState: GameSessionState,
  currentQuestionIndex: number,
  questionId: string,
  teamMemberAnswersId: string,
  teamAnswersId: string,
  teamName?: string | null,
  text: string,
  answer: string,
  confidenceLevel?: ConfidenceLevel | null,
  hint?: string | null,
};

export type ModelTeamAnswerConditionInput = {
  isCorrect?: ModelBooleanInput | null,
  isSubmitted?: ModelBooleanInput | null,
  isShortAnswerEnabled?: ModelBooleanInput | null,
  currentState?: ModelGameSessionStateInput | null,
  currentQuestionIndex?: ModelIntInput | null,
  questionId?: ModelIDInput | null,
  teamMemberAnswersId?: ModelIDInput | null,
  teamAnswersId?: ModelIDInput | null,
  teamName?: ModelStringInput | null,
  text?: ModelStringInput | null,
  answer?: ModelStringInput | null,
  confidenceLevel?: ModelConfidenceLevelInput | null,
  hint?: ModelStringInput | null,
  and?: Array< ModelTeamAnswerConditionInput | null > | null,
  or?: Array< ModelTeamAnswerConditionInput | null > | null,
  not?: ModelTeamAnswerConditionInput | null,
};

export type ModelConfidenceLevelInput = {
  eq?: ConfidenceLevel | null,
  ne?: ConfidenceLevel | null,
};

export type UpdateTeamAnswerInput = {
  id: string,
  isCorrect?: boolean | null,
  isSubmitted?: boolean | null,
  isShortAnswerEnabled?: boolean | null,
  currentState?: GameSessionState | null,
  currentQuestionIndex?: number | null,
  questionId?: string | null,
  teamMemberAnswersId?: string | null,
  teamAnswersId?: string | null,
  teamName?: string | null,
  text?: string | null,
  answer?: string | null,
  confidenceLevel?: ConfidenceLevel | null,
  hint?: string | null,
};

export type DeleteTeamAnswerInput = {
  id: string,
};

export type CreatePublicGameQuestionsInput = {
  id?: string | null,
  publicGameTemplateID: string,
  publicQuestionTemplateID: string,
};

export type ModelPublicGameQuestionsConditionInput = {
  publicGameTemplateID?: ModelIDInput | null,
  publicQuestionTemplateID?: ModelIDInput | null,
  and?: Array< ModelPublicGameQuestionsConditionInput | null > | null,
  or?: Array< ModelPublicGameQuestionsConditionInput | null > | null,
  not?: ModelPublicGameQuestionsConditionInput | null,
};

export type UpdatePublicGameQuestionsInput = {
  id: string,
  publicGameTemplateID?: string | null,
  publicQuestionTemplateID?: string | null,
};

export type DeletePublicGameQuestionsInput = {
  id: string,
};

export type CreatePrivateGameQuestionsInput = {
  id?: string | null,
  privateGameTemplateID: string,
  privateQuestionTemplateID: string,
};

export type ModelPrivateGameQuestionsConditionInput = {
  privateGameTemplateID?: ModelIDInput | null,
  privateQuestionTemplateID?: ModelIDInput | null,
  and?: Array< ModelPrivateGameQuestionsConditionInput | null > | null,
  or?: Array< ModelPrivateGameQuestionsConditionInput | null > | null,
  not?: ModelPrivateGameQuestionsConditionInput | null,
};

export type UpdatePrivateGameQuestionsInput = {
  id: string,
  privateGameTemplateID?: string | null,
  privateQuestionTemplateID?: string | null,
};

export type DeletePrivateGameQuestionsInput = {
  id: string,
};

export type CreateDraftGameQuestionsInput = {
  id?: string | null,
  draftGameTemplateID: string,
  draftQuestionTemplateID: string,
};

export type ModelDraftGameQuestionsConditionInput = {
  draftGameTemplateID?: ModelIDInput | null,
  draftQuestionTemplateID?: ModelIDInput | null,
  and?: Array< ModelDraftGameQuestionsConditionInput | null > | null,
  or?: Array< ModelDraftGameQuestionsConditionInput | null > | null,
  not?: ModelDraftGameQuestionsConditionInput | null,
};

export type UpdateDraftGameQuestionsInput = {
  id: string,
  draftGameTemplateID?: string | null,
  draftQuestionTemplateID?: string | null,
};

export type DeleteDraftGameQuestionsInput = {
  id: string,
};

export type CreateGameSessionFromTemplateInput = {
  gameTemplateId: string,
  publicPrivate: string,
};

export type TeacherIdAuthInput = {
  teacherImage: string,
  fileName: string,
  fileType: string,
};

export type UploadExternalImageToS3Input = {
  imageUrl: string,
};

export type WaeGenInput = {
  question: string,
  correctAnswer: string,
  wrongAnswer: string,
  discardedExplanations: string,
};

export type WaeRegenInput = {
  question: string,
  correctAnswer: string,
  wrongAnswer: string,
  currentExplanation: string,
  currentPrompt?: string | null,
  incorrectMath?: boolean | null,
  toneClarity?: boolean | null,
  other?: boolean | null,
  discardedExplanations?: string | null,
};

export type DeleteUnverifiedUserInput = {
  email: string,
};

export type UpdateUserPassInput = {
  email: string,
  pass: string,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  userName?: ModelStringInput | null,
  dynamoId?: ModelStringInput | null,
  cognitoId?: ModelStringInput | null,
  title?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  email?: ModelStringInput | null,
  password?: ModelStringInput | null,
  gamesMade?: ModelIntInput | null,
  gamesUsed?: ModelIntInput | null,
  questionsMade?: ModelIntInput | null,
  frontIdPath?: ModelStringInput | null,
  backIdPath?: ModelStringInput | null,
  profilePicPath?: ModelStringInput | null,
  favoriteGameTemplateIds?: ModelStringInput | null,
  favoriteQuestionTemplateIds?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type ModelPublicGameTemplateFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelStringInput | null,
  publicPrivateType?: ModelStringInput | null,
  title?: ModelStringInput | null,
  lowerCaseTitle?: ModelStringInput | null,
  version?: ModelIntInput | null,
  description?: ModelStringInput | null,
  lowerCaseDescription?: ModelStringInput | null,
  ccss?: ModelStringInput | null,
  ccssDescription?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  cluster?: ModelStringInput | null,
  grade?: ModelStringInput | null,
  gradeFilter?: ModelStringInput | null,
  standard?: ModelStringInput | null,
  phaseOneTime?: ModelIntInput | null,
  phaseTwoTime?: ModelIntInput | null,
  imageUrl?: ModelStringInput | null,
  timesPlayed?: ModelIntInput | null,
  questionTemplatesCount?: ModelIntInput | null,
  questionTemplatesOrder?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  featuredGroup?: ModelStringInput | null,
  featuredOrder?: ModelIntInput | null,
  type?: ModelStringInput | null,
  and?: Array< ModelPublicGameTemplateFilterInput | null > | null,
  or?: Array< ModelPublicGameTemplateFilterInput | null > | null,
  not?: ModelPublicGameTemplateFilterInput | null,
};

export type ModelPublicGameTemplateConnection = {
  __typename: "ModelPublicGameTemplateConnection",
  items:  Array<PublicGameTemplate | null >,
  nextToken?: string | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelIntKeyConditionInput = {
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelPrivateGameTemplateFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelStringInput | null,
  publicPrivateType?: ModelStringInput | null,
  title?: ModelStringInput | null,
  lowerCaseTitle?: ModelStringInput | null,
  version?: ModelIntInput | null,
  description?: ModelStringInput | null,
  lowerCaseDescription?: ModelStringInput | null,
  ccss?: ModelStringInput | null,
  ccssDescription?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  cluster?: ModelStringInput | null,
  grade?: ModelStringInput | null,
  gradeFilter?: ModelStringInput | null,
  standard?: ModelStringInput | null,
  phaseOneTime?: ModelIntInput | null,
  phaseTwoTime?: ModelIntInput | null,
  imageUrl?: ModelStringInput | null,
  timesPlayed?: ModelIntInput | null,
  questionTemplatesCount?: ModelIntInput | null,
  questionTemplatesOrder?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  type?: ModelStringInput | null,
  and?: Array< ModelPrivateGameTemplateFilterInput | null > | null,
  or?: Array< ModelPrivateGameTemplateFilterInput | null > | null,
  not?: ModelPrivateGameTemplateFilterInput | null,
};

export type ModelPrivateGameTemplateConnection = {
  __typename: "ModelPrivateGameTemplateConnection",
  items:  Array<PrivateGameTemplate | null >,
  nextToken?: string | null,
};

export type ModelDraftGameTemplateFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelStringInput | null,
  publicPrivateType?: ModelStringInput | null,
  title?: ModelStringInput | null,
  lowerCaseTitle?: ModelStringInput | null,
  version?: ModelIntInput | null,
  description?: ModelStringInput | null,
  lowerCaseDescription?: ModelStringInput | null,
  ccss?: ModelStringInput | null,
  ccssDescription?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  cluster?: ModelStringInput | null,
  grade?: ModelStringInput | null,
  gradeFilter?: ModelStringInput | null,
  standard?: ModelStringInput | null,
  phaseOneTime?: ModelIntInput | null,
  phaseTwoTime?: ModelIntInput | null,
  imageUrl?: ModelStringInput | null,
  timesPlayed?: ModelIntInput | null,
  questionTemplatesCount?: ModelIntInput | null,
  questionTemplatesOrder?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  type?: ModelStringInput | null,
  and?: Array< ModelDraftGameTemplateFilterInput | null > | null,
  or?: Array< ModelDraftGameTemplateFilterInput | null > | null,
  not?: ModelDraftGameTemplateFilterInput | null,
};

export type ModelDraftGameTemplateConnection = {
  __typename: "ModelDraftGameTemplateConnection",
  items:  Array<DraftGameTemplate | null >,
  nextToken?: string | null,
};

export type ModelPublicQuestionTemplateFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelStringInput | null,
  publicPrivateType?: ModelStringInput | null,
  title?: ModelStringInput | null,
  lowerCaseTitle?: ModelStringInput | null,
  version?: ModelIntInput | null,
  choices?: ModelStringInput | null,
  instructions?: ModelStringInput | null,
  answerSettings?: ModelStringInput | null,
  ccss?: ModelStringInput | null,
  ccssDescription?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  cluster?: ModelStringInput | null,
  grade?: ModelStringInput | null,
  gradeFilter?: ModelStringInput | null,
  standard?: ModelStringInput | null,
  imageUrl?: ModelStringInput | null,
  timesPlayed?: ModelIntInput | null,
  gameTemplatesCount?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  type?: ModelStringInput | null,
  and?: Array< ModelPublicQuestionTemplateFilterInput | null > | null,
  or?: Array< ModelPublicQuestionTemplateFilterInput | null > | null,
  not?: ModelPublicQuestionTemplateFilterInput | null,
};

export type ModelPublicQuestionTemplateConnection = {
  __typename: "ModelPublicQuestionTemplateConnection",
  items:  Array<PublicQuestionTemplate | null >,
  nextToken?: string | null,
};

export type ModelPrivateQuestionTemplateFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelStringInput | null,
  publicPrivateType?: ModelStringInput | null,
  title?: ModelStringInput | null,
  lowerCaseTitle?: ModelStringInput | null,
  version?: ModelIntInput | null,
  choices?: ModelStringInput | null,
  instructions?: ModelStringInput | null,
  answerSettings?: ModelStringInput | null,
  ccss?: ModelStringInput | null,
  ccssDescription?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  cluster?: ModelStringInput | null,
  grade?: ModelStringInput | null,
  gradeFilter?: ModelStringInput | null,
  standard?: ModelStringInput | null,
  imageUrl?: ModelStringInput | null,
  timesPlayed?: ModelIntInput | null,
  gameTemplatesCount?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  type?: ModelStringInput | null,
  and?: Array< ModelPrivateQuestionTemplateFilterInput | null > | null,
  or?: Array< ModelPrivateQuestionTemplateFilterInput | null > | null,
  not?: ModelPrivateQuestionTemplateFilterInput | null,
};

export type ModelPrivateQuestionTemplateConnection = {
  __typename: "ModelPrivateQuestionTemplateConnection",
  items:  Array<PrivateQuestionTemplate | null >,
  nextToken?: string | null,
};

export type ModelDraftQuestionTemplateFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelStringInput | null,
  publicPrivateType?: ModelStringInput | null,
  title?: ModelStringInput | null,
  lowerCaseTitle?: ModelStringInput | null,
  version?: ModelIntInput | null,
  choices?: ModelStringInput | null,
  instructions?: ModelStringInput | null,
  answerSettings?: ModelStringInput | null,
  ccss?: ModelStringInput | null,
  ccssDescription?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  cluster?: ModelStringInput | null,
  grade?: ModelStringInput | null,
  gradeFilter?: ModelStringInput | null,
  standard?: ModelStringInput | null,
  imageUrl?: ModelStringInput | null,
  timesPlayed?: ModelIntInput | null,
  gameTemplatesCount?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  type?: ModelStringInput | null,
  and?: Array< ModelDraftQuestionTemplateFilterInput | null > | null,
  or?: Array< ModelDraftQuestionTemplateFilterInput | null > | null,
  not?: ModelDraftQuestionTemplateFilterInput | null,
};

export type ModelDraftQuestionTemplateConnection = {
  __typename: "ModelDraftQuestionTemplateConnection",
  items:  Array<DraftQuestionTemplate | null >,
  nextToken?: string | null,
};

export type ModelGameSessionFilterInput = {
  id?: ModelIDInput | null,
  classroomId?: ModelStringInput | null,
  gameId?: ModelIDInput | null,
  startTime?: ModelStringInput | null,
  phaseOneTime?: ModelIntInput | null,
  phaseTwoTime?: ModelIntInput | null,
  currentQuestionIndex?: ModelIntInput | null,
  currentState?: ModelGameSessionStateInput | null,
  gameCode?: ModelIntInput | null,
  isAdvancedMode?: ModelBooleanInput | null,
  imageUrl?: ModelStringInput | null,
  description?: ModelStringInput | null,
  title?: ModelStringInput | null,
  currentTimer?: ModelIntInput | null,
  studentID?: ModelIntInput | null,
  sessionData?: ModelStringInput | null,
  and?: Array< ModelGameSessionFilterInput | null > | null,
  or?: Array< ModelGameSessionFilterInput | null > | null,
  not?: ModelGameSessionFilterInput | null,
};

export type ModelGameSessionConnection = {
  __typename: "ModelGameSessionConnection",
  items:  Array<GameSession | null >,
  nextToken?: string | null,
};

export type ModelQuestionPrimaryCompositeKeyConditionInput = {
  eq?: ModelQuestionPrimaryCompositeKeyInput | null,
  le?: ModelQuestionPrimaryCompositeKeyInput | null,
  lt?: ModelQuestionPrimaryCompositeKeyInput | null,
  ge?: ModelQuestionPrimaryCompositeKeyInput | null,
  gt?: ModelQuestionPrimaryCompositeKeyInput | null,
  between?: Array< ModelQuestionPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelQuestionPrimaryCompositeKeyInput | null,
};

export type ModelQuestionPrimaryCompositeKeyInput = {
  order?: number | null,
  gameSessionId?: string | null,
};

export type ModelQuestionFilterInput = {
  id?: ModelIDInput | null,
  text?: ModelStringInput | null,
  choices?: ModelStringInput | null,
  answerSettings?: ModelStringInput | null,
  answerData?: ModelStringInput | null,
  hints?: ModelStringInput | null,
  imageUrl?: ModelStringInput | null,
  instructions?: ModelStringInput | null,
  standard?: ModelStringInput | null,
  cluster?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  grade?: ModelStringInput | null,
  order?: ModelIntInput | null,
  isConfidenceEnabled?: ModelBooleanInput | null,
  isShortAnswerEnabled?: ModelBooleanInput | null,
  isHintEnabled?: ModelBooleanInput | null,
  gameSessionId?: ModelIDInput | null,
  and?: Array< ModelQuestionFilterInput | null > | null,
  or?: Array< ModelQuestionFilterInput | null > | null,
  not?: ModelQuestionFilterInput | null,
};

export type ModelTeamFilterInput = {
  id?: ModelIDInput | null,
  globalStudentId?: ModelStringInput | null,
  name?: ModelStringInput | null,
  score?: ModelIntInput | null,
  selectedAvatarIndex?: ModelIntInput | null,
  and?: Array< ModelTeamFilterInput | null > | null,
  or?: Array< ModelTeamFilterInput | null > | null,
  not?: ModelTeamFilterInput | null,
  gameSessionTeamsId?: ModelIDInput | null,
  teamQuestionId?: ModelIDInput | null,
  teamQuestionOrder?: ModelIntInput | null,
  teamQuestionGameSessionId?: ModelIDInput | null,
};

export type ModelTeamMemberFilterInput = {
  id?: ModelIDInput | null,
  isFacilitator?: ModelBooleanInput | null,
  deviceId?: ModelIDInput | null,
  and?: Array< ModelTeamMemberFilterInput | null > | null,
  or?: Array< ModelTeamMemberFilterInput | null > | null,
  not?: ModelTeamMemberFilterInput | null,
  teamTeamMembersId?: ModelIDInput | null,
};

export type ModelTeamAnswerFilterInput = {
  id?: ModelIDInput | null,
  isCorrect?: ModelBooleanInput | null,
  isSubmitted?: ModelBooleanInput | null,
  isShortAnswerEnabled?: ModelBooleanInput | null,
  currentState?: ModelGameSessionStateInput | null,
  currentQuestionIndex?: ModelIntInput | null,
  questionId?: ModelIDInput | null,
  teamMemberAnswersId?: ModelIDInput | null,
  teamAnswersId?: ModelIDInput | null,
  teamName?: ModelStringInput | null,
  text?: ModelStringInput | null,
  answer?: ModelStringInput | null,
  confidenceLevel?: ModelConfidenceLevelInput | null,
  hint?: ModelStringInput | null,
  and?: Array< ModelTeamAnswerFilterInput | null > | null,
  or?: Array< ModelTeamAnswerFilterInput | null > | null,
  not?: ModelTeamAnswerFilterInput | null,
};

export type ModelPublicGameQuestionsFilterInput = {
  id?: ModelIDInput | null,
  publicGameTemplateID?: ModelIDInput | null,
  publicQuestionTemplateID?: ModelIDInput | null,
  and?: Array< ModelPublicGameQuestionsFilterInput | null > | null,
  or?: Array< ModelPublicGameQuestionsFilterInput | null > | null,
  not?: ModelPublicGameQuestionsFilterInput | null,
};

export type ModelPrivateGameQuestionsFilterInput = {
  id?: ModelIDInput | null,
  privateGameTemplateID?: ModelIDInput | null,
  privateQuestionTemplateID?: ModelIDInput | null,
  and?: Array< ModelPrivateGameQuestionsFilterInput | null > | null,
  or?: Array< ModelPrivateGameQuestionsFilterInput | null > | null,
  not?: ModelPrivateGameQuestionsFilterInput | null,
};

export type ModelDraftGameQuestionsFilterInput = {
  id?: ModelIDInput | null,
  draftGameTemplateID?: ModelIDInput | null,
  draftQuestionTemplateID?: ModelIDInput | null,
  and?: Array< ModelDraftGameQuestionsFilterInput | null > | null,
  or?: Array< ModelDraftGameQuestionsFilterInput | null > | null,
  not?: ModelDraftGameQuestionsFilterInput | null,
};

export type ModelSubscriptionUserFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userName?: ModelSubscriptionStringInput | null,
  dynamoId?: ModelSubscriptionStringInput | null,
  cognitoId?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  password?: ModelSubscriptionStringInput | null,
  gamesMade?: ModelSubscriptionIntInput | null,
  gamesUsed?: ModelSubscriptionIntInput | null,
  questionsMade?: ModelSubscriptionIntInput | null,
  frontIdPath?: ModelSubscriptionStringInput | null,
  backIdPath?: ModelSubscriptionStringInput | null,
  profilePicPath?: ModelSubscriptionStringInput | null,
  favoriteGameTemplateIds?: ModelSubscriptionStringInput | null,
  favoriteQuestionTemplateIds?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFilterInput | null > | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionPublicGameTemplateFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionStringInput | null,
  publicPrivateType?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  lowerCaseTitle?: ModelSubscriptionStringInput | null,
  version?: ModelSubscriptionIntInput | null,
  description?: ModelSubscriptionStringInput | null,
  lowerCaseDescription?: ModelSubscriptionStringInput | null,
  ccss?: ModelSubscriptionStringInput | null,
  ccssDescription?: ModelSubscriptionStringInput | null,
  domain?: ModelSubscriptionStringInput | null,
  cluster?: ModelSubscriptionStringInput | null,
  grade?: ModelSubscriptionStringInput | null,
  gradeFilter?: ModelSubscriptionStringInput | null,
  standard?: ModelSubscriptionStringInput | null,
  phaseOneTime?: ModelSubscriptionIntInput | null,
  phaseTwoTime?: ModelSubscriptionIntInput | null,
  imageUrl?: ModelSubscriptionStringInput | null,
  timesPlayed?: ModelSubscriptionIntInput | null,
  questionTemplatesCount?: ModelSubscriptionIntInput | null,
  questionTemplatesOrder?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  featuredGroup?: ModelSubscriptionStringInput | null,
  featuredOrder?: ModelSubscriptionIntInput | null,
  type?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPublicGameTemplateFilterInput | null > | null,
  or?: Array< ModelSubscriptionPublicGameTemplateFilterInput | null > | null,
};

export type ModelSubscriptionPrivateGameTemplateFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionStringInput | null,
  publicPrivateType?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  lowerCaseTitle?: ModelSubscriptionStringInput | null,
  version?: ModelSubscriptionIntInput | null,
  description?: ModelSubscriptionStringInput | null,
  lowerCaseDescription?: ModelSubscriptionStringInput | null,
  ccss?: ModelSubscriptionStringInput | null,
  ccssDescription?: ModelSubscriptionStringInput | null,
  domain?: ModelSubscriptionStringInput | null,
  cluster?: ModelSubscriptionStringInput | null,
  grade?: ModelSubscriptionStringInput | null,
  gradeFilter?: ModelSubscriptionStringInput | null,
  standard?: ModelSubscriptionStringInput | null,
  phaseOneTime?: ModelSubscriptionIntInput | null,
  phaseTwoTime?: ModelSubscriptionIntInput | null,
  imageUrl?: ModelSubscriptionStringInput | null,
  timesPlayed?: ModelSubscriptionIntInput | null,
  questionTemplatesCount?: ModelSubscriptionIntInput | null,
  questionTemplatesOrder?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPrivateGameTemplateFilterInput | null > | null,
  or?: Array< ModelSubscriptionPrivateGameTemplateFilterInput | null > | null,
};

export type ModelSubscriptionDraftGameTemplateFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionStringInput | null,
  publicPrivateType?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  lowerCaseTitle?: ModelSubscriptionStringInput | null,
  version?: ModelSubscriptionIntInput | null,
  description?: ModelSubscriptionStringInput | null,
  lowerCaseDescription?: ModelSubscriptionStringInput | null,
  ccss?: ModelSubscriptionStringInput | null,
  ccssDescription?: ModelSubscriptionStringInput | null,
  domain?: ModelSubscriptionStringInput | null,
  cluster?: ModelSubscriptionStringInput | null,
  grade?: ModelSubscriptionStringInput | null,
  gradeFilter?: ModelSubscriptionStringInput | null,
  standard?: ModelSubscriptionStringInput | null,
  phaseOneTime?: ModelSubscriptionIntInput | null,
  phaseTwoTime?: ModelSubscriptionIntInput | null,
  imageUrl?: ModelSubscriptionStringInput | null,
  timesPlayed?: ModelSubscriptionIntInput | null,
  questionTemplatesCount?: ModelSubscriptionIntInput | null,
  questionTemplatesOrder?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDraftGameTemplateFilterInput | null > | null,
  or?: Array< ModelSubscriptionDraftGameTemplateFilterInput | null > | null,
};

export type ModelSubscriptionPublicQuestionTemplateFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionStringInput | null,
  publicPrivateType?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  lowerCaseTitle?: ModelSubscriptionStringInput | null,
  version?: ModelSubscriptionIntInput | null,
  choices?: ModelSubscriptionStringInput | null,
  instructions?: ModelSubscriptionStringInput | null,
  answerSettings?: ModelSubscriptionStringInput | null,
  ccss?: ModelSubscriptionStringInput | null,
  ccssDescription?: ModelSubscriptionStringInput | null,
  domain?: ModelSubscriptionStringInput | null,
  cluster?: ModelSubscriptionStringInput | null,
  grade?: ModelSubscriptionStringInput | null,
  gradeFilter?: ModelSubscriptionStringInput | null,
  standard?: ModelSubscriptionStringInput | null,
  imageUrl?: ModelSubscriptionStringInput | null,
  timesPlayed?: ModelSubscriptionIntInput | null,
  gameTemplatesCount?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPublicQuestionTemplateFilterInput | null > | null,
  or?: Array< ModelSubscriptionPublicQuestionTemplateFilterInput | null > | null,
};

export type ModelSubscriptionPrivateQuestionTemplateFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionStringInput | null,
  publicPrivateType?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  lowerCaseTitle?: ModelSubscriptionStringInput | null,
  version?: ModelSubscriptionIntInput | null,
  choices?: ModelSubscriptionStringInput | null,
  instructions?: ModelSubscriptionStringInput | null,
  answerSettings?: ModelSubscriptionStringInput | null,
  ccss?: ModelSubscriptionStringInput | null,
  ccssDescription?: ModelSubscriptionStringInput | null,
  domain?: ModelSubscriptionStringInput | null,
  cluster?: ModelSubscriptionStringInput | null,
  grade?: ModelSubscriptionStringInput | null,
  gradeFilter?: ModelSubscriptionStringInput | null,
  standard?: ModelSubscriptionStringInput | null,
  imageUrl?: ModelSubscriptionStringInput | null,
  timesPlayed?: ModelSubscriptionIntInput | null,
  gameTemplatesCount?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPrivateQuestionTemplateFilterInput | null > | null,
  or?: Array< ModelSubscriptionPrivateQuestionTemplateFilterInput | null > | null,
};

export type ModelSubscriptionDraftQuestionTemplateFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionStringInput | null,
  publicPrivateType?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  lowerCaseTitle?: ModelSubscriptionStringInput | null,
  version?: ModelSubscriptionIntInput | null,
  choices?: ModelSubscriptionStringInput | null,
  instructions?: ModelSubscriptionStringInput | null,
  answerSettings?: ModelSubscriptionStringInput | null,
  ccss?: ModelSubscriptionStringInput | null,
  ccssDescription?: ModelSubscriptionStringInput | null,
  domain?: ModelSubscriptionStringInput | null,
  cluster?: ModelSubscriptionStringInput | null,
  grade?: ModelSubscriptionStringInput | null,
  gradeFilter?: ModelSubscriptionStringInput | null,
  standard?: ModelSubscriptionStringInput | null,
  imageUrl?: ModelSubscriptionStringInput | null,
  timesPlayed?: ModelSubscriptionIntInput | null,
  gameTemplatesCount?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDraftQuestionTemplateFilterInput | null > | null,
  or?: Array< ModelSubscriptionDraftQuestionTemplateFilterInput | null > | null,
};

export type ModelSubscriptionGameSessionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  classroomId?: ModelSubscriptionStringInput | null,
  gameId?: ModelSubscriptionIDInput | null,
  startTime?: ModelSubscriptionStringInput | null,
  phaseOneTime?: ModelSubscriptionIntInput | null,
  phaseTwoTime?: ModelSubscriptionIntInput | null,
  currentQuestionIndex?: ModelSubscriptionIntInput | null,
  currentState?: ModelSubscriptionStringInput | null,
  gameCode?: ModelSubscriptionIntInput | null,
  isAdvancedMode?: ModelSubscriptionBooleanInput | null,
  imageUrl?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  currentTimer?: ModelSubscriptionIntInput | null,
  studentID?: ModelSubscriptionIntInput | null,
  sessionData?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionGameSessionFilterInput | null > | null,
  or?: Array< ModelSubscriptionGameSessionFilterInput | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionTeamFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  globalStudentId?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  score?: ModelSubscriptionIntInput | null,
  selectedAvatarIndex?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionTeamFilterInput | null > | null,
  or?: Array< ModelSubscriptionTeamFilterInput | null > | null,
};

export type ModelSubscriptionTeamMemberFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  isFacilitator?: ModelSubscriptionBooleanInput | null,
  deviceId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionTeamMemberFilterInput | null > | null,
  or?: Array< ModelSubscriptionTeamMemberFilterInput | null > | null,
};

export type ModelSubscriptionTeamAnswerFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  isCorrect?: ModelSubscriptionBooleanInput | null,
  isSubmitted?: ModelSubscriptionBooleanInput | null,
  isShortAnswerEnabled?: ModelSubscriptionBooleanInput | null,
  currentState?: ModelSubscriptionStringInput | null,
  currentQuestionIndex?: ModelSubscriptionIntInput | null,
  questionId?: ModelSubscriptionIDInput | null,
  teamMemberAnswersId?: ModelSubscriptionIDInput | null,
  teamAnswersId?: ModelSubscriptionIDInput | null,
  teamName?: ModelSubscriptionStringInput | null,
  text?: ModelSubscriptionStringInput | null,
  answer?: ModelSubscriptionStringInput | null,
  confidenceLevel?: ModelSubscriptionStringInput | null,
  hint?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTeamAnswerFilterInput | null > | null,
  or?: Array< ModelSubscriptionTeamAnswerFilterInput | null > | null,
};

export type ModelSubscriptionPublicGameQuestionsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  publicGameTemplateID?: ModelSubscriptionIDInput | null,
  publicQuestionTemplateID?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionPublicGameQuestionsFilterInput | null > | null,
  or?: Array< ModelSubscriptionPublicGameQuestionsFilterInput | null > | null,
};

export type ModelSubscriptionPrivateGameQuestionsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  privateGameTemplateID?: ModelSubscriptionIDInput | null,
  privateQuestionTemplateID?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionPrivateGameQuestionsFilterInput | null > | null,
  or?: Array< ModelSubscriptionPrivateGameQuestionsFilterInput | null > | null,
};

export type ModelSubscriptionDraftGameQuestionsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  draftGameTemplateID?: ModelSubscriptionIDInput | null,
  draftQuestionTemplateID?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionDraftGameQuestionsFilterInput | null > | null,
  or?: Array< ModelSubscriptionDraftGameQuestionsFilterInput | null > | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    userName: string,
    dynamoId?: string | null,
    cognitoId: string,
    title?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    email: string,
    password?: string | null,
    gamesMade?: number | null,
    gamesUsed?: number | null,
    questionsMade?: number | null,
    frontIdPath?: string | null,
    backIdPath?: string | null,
    profilePicPath?: string | null,
    favoriteGameTemplateIds?: string | null,
    favoriteQuestionTemplateIds?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    userName: string,
    dynamoId?: string | null,
    cognitoId: string,
    title?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    email: string,
    password?: string | null,
    gamesMade?: number | null,
    gamesUsed?: number | null,
    questionsMade?: number | null,
    frontIdPath?: string | null,
    backIdPath?: string | null,
    profilePicPath?: string | null,
    favoriteGameTemplateIds?: string | null,
    favoriteQuestionTemplateIds?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    id: string,
    userName: string,
    dynamoId?: string | null,
    cognitoId: string,
    title?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    email: string,
    password?: string | null,
    gamesMade?: number | null,
    gamesUsed?: number | null,
    questionsMade?: number | null,
    frontIdPath?: string | null,
    backIdPath?: string | null,
    profilePicPath?: string | null,
    favoriteGameTemplateIds?: string | null,
    favoriteQuestionTemplateIds?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreatePublicGameTemplateMutationVariables = {
  input: CreatePublicGameTemplateInput,
  condition?: ModelPublicGameTemplateConditionInput | null,
};

export type CreatePublicGameTemplateMutation = {
  createPublicGameTemplate?:  {
    __typename: "PublicGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    description: string,
    lowerCaseDescription: string,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelPublicGameQuestionsConnection",
      items:  Array< {
        __typename: "PublicGameQuestions",
        id: string,
        publicGameTemplateID: string,
        publicQuestionTemplateID: string,
        publicGameTemplate:  {
          __typename: "PublicGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          featuredGroup?: string | null,
          featuredOrder?: number | null,
          type?: string | null,
          owner?: string | null,
        },
        publicQuestionTemplate:  {
          __typename: "PublicQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    featuredGroup?: string | null,
    featuredOrder?: number | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type UpdatePublicGameTemplateMutationVariables = {
  input: UpdatePublicGameTemplateInput,
  condition?: ModelPublicGameTemplateConditionInput | null,
};

export type UpdatePublicGameTemplateMutation = {
  updatePublicGameTemplate?:  {
    __typename: "PublicGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    description: string,
    lowerCaseDescription: string,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelPublicGameQuestionsConnection",
      items:  Array< {
        __typename: "PublicGameQuestions",
        id: string,
        publicGameTemplateID: string,
        publicQuestionTemplateID: string,
        publicGameTemplate:  {
          __typename: "PublicGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          featuredGroup?: string | null,
          featuredOrder?: number | null,
          type?: string | null,
          owner?: string | null,
        },
        publicQuestionTemplate:  {
          __typename: "PublicQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    featuredGroup?: string | null,
    featuredOrder?: number | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type DeletePublicGameTemplateMutationVariables = {
  input: DeletePublicGameTemplateInput,
  condition?: ModelPublicGameTemplateConditionInput | null,
};

export type DeletePublicGameTemplateMutation = {
  deletePublicGameTemplate?:  {
    __typename: "PublicGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    description: string,
    lowerCaseDescription: string,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelPublicGameQuestionsConnection",
      items:  Array< {
        __typename: "PublicGameQuestions",
        id: string,
        publicGameTemplateID: string,
        publicQuestionTemplateID: string,
        publicGameTemplate:  {
          __typename: "PublicGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          featuredGroup?: string | null,
          featuredOrder?: number | null,
          type?: string | null,
          owner?: string | null,
        },
        publicQuestionTemplate:  {
          __typename: "PublicQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    featuredGroup?: string | null,
    featuredOrder?: number | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type CreatePrivateGameTemplateMutationVariables = {
  input: CreatePrivateGameTemplateInput,
  condition?: ModelPrivateGameTemplateConditionInput | null,
};

export type CreatePrivateGameTemplateMutation = {
  createPrivateGameTemplate?:  {
    __typename: "PrivateGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    description: string,
    lowerCaseDescription: string,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelPrivateGameQuestionsConnection",
      items:  Array< {
        __typename: "PrivateGameQuestions",
        id: string,
        privateGameTemplateID: string,
        privateQuestionTemplateID: string,
        privateGameTemplate:  {
          __typename: "PrivateGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        privateQuestionTemplate:  {
          __typename: "PrivateQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type UpdatePrivateGameTemplateMutationVariables = {
  input: UpdatePrivateGameTemplateInput,
  condition?: ModelPrivateGameTemplateConditionInput | null,
};

export type UpdatePrivateGameTemplateMutation = {
  updatePrivateGameTemplate?:  {
    __typename: "PrivateGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    description: string,
    lowerCaseDescription: string,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelPrivateGameQuestionsConnection",
      items:  Array< {
        __typename: "PrivateGameQuestions",
        id: string,
        privateGameTemplateID: string,
        privateQuestionTemplateID: string,
        privateGameTemplate:  {
          __typename: "PrivateGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        privateQuestionTemplate:  {
          __typename: "PrivateQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type DeletePrivateGameTemplateMutationVariables = {
  input: DeletePrivateGameTemplateInput,
  condition?: ModelPrivateGameTemplateConditionInput | null,
};

export type DeletePrivateGameTemplateMutation = {
  deletePrivateGameTemplate?:  {
    __typename: "PrivateGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    description: string,
    lowerCaseDescription: string,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelPrivateGameQuestionsConnection",
      items:  Array< {
        __typename: "PrivateGameQuestions",
        id: string,
        privateGameTemplateID: string,
        privateQuestionTemplateID: string,
        privateGameTemplate:  {
          __typename: "PrivateGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        privateQuestionTemplate:  {
          __typename: "PrivateQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type CreateDraftGameTemplateMutationVariables = {
  input: CreateDraftGameTemplateInput,
  condition?: ModelDraftGameTemplateConditionInput | null,
};

export type CreateDraftGameTemplateMutation = {
  createDraftGameTemplate?:  {
    __typename: "DraftGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title?: string | null,
    lowerCaseTitle?: string | null,
    version?: number | null,
    description?: string | null,
    lowerCaseDescription?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelDraftGameQuestionsConnection",
      items:  Array< {
        __typename: "DraftGameQuestions",
        id: string,
        draftGameTemplateID: string,
        draftQuestionTemplateID: string,
        draftGameTemplate:  {
          __typename: "DraftGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          description?: string | null,
          lowerCaseDescription?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        draftQuestionTemplate:  {
          __typename: "DraftQuestionTemplate",
          id?: string | null,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type UpdateDraftGameTemplateMutationVariables = {
  input: UpdateDraftGameTemplateInput,
  condition?: ModelDraftGameTemplateConditionInput | null,
};

export type UpdateDraftGameTemplateMutation = {
  updateDraftGameTemplate?:  {
    __typename: "DraftGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title?: string | null,
    lowerCaseTitle?: string | null,
    version?: number | null,
    description?: string | null,
    lowerCaseDescription?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelDraftGameQuestionsConnection",
      items:  Array< {
        __typename: "DraftGameQuestions",
        id: string,
        draftGameTemplateID: string,
        draftQuestionTemplateID: string,
        draftGameTemplate:  {
          __typename: "DraftGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          description?: string | null,
          lowerCaseDescription?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        draftQuestionTemplate:  {
          __typename: "DraftQuestionTemplate",
          id?: string | null,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type DeleteDraftGameTemplateMutationVariables = {
  input: DeleteDraftGameTemplateInput,
  condition?: ModelDraftGameTemplateConditionInput | null,
};

export type DeleteDraftGameTemplateMutation = {
  deleteDraftGameTemplate?:  {
    __typename: "DraftGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title?: string | null,
    lowerCaseTitle?: string | null,
    version?: number | null,
    description?: string | null,
    lowerCaseDescription?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelDraftGameQuestionsConnection",
      items:  Array< {
        __typename: "DraftGameQuestions",
        id: string,
        draftGameTemplateID: string,
        draftQuestionTemplateID: string,
        draftGameTemplate:  {
          __typename: "DraftGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          description?: string | null,
          lowerCaseDescription?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        draftQuestionTemplate:  {
          __typename: "DraftQuestionTemplate",
          id?: string | null,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type CreatePublicQuestionTemplateMutationVariables = {
  input: CreatePublicQuestionTemplateInput,
  condition?: ModelPublicQuestionTemplateConditionInput | null,
};

export type CreatePublicQuestionTemplateMutation = {
  createPublicQuestionTemplate?:  {
    __typename: "PublicQuestionTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelPublicGameQuestionsConnection",
      items:  Array< {
        __typename: "PublicGameQuestions",
        id: string,
        publicGameTemplateID: string,
        publicQuestionTemplateID: string,
        publicGameTemplate:  {
          __typename: "PublicGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          featuredGroup?: string | null,
          featuredOrder?: number | null,
          type?: string | null,
          owner?: string | null,
        },
        publicQuestionTemplate:  {
          __typename: "PublicQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type UpdatePublicQuestionTemplateMutationVariables = {
  input: UpdatePublicQuestionTemplateInput,
  condition?: ModelPublicQuestionTemplateConditionInput | null,
};

export type UpdatePublicQuestionTemplateMutation = {
  updatePublicQuestionTemplate?:  {
    __typename: "PublicQuestionTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelPublicGameQuestionsConnection",
      items:  Array< {
        __typename: "PublicGameQuestions",
        id: string,
        publicGameTemplateID: string,
        publicQuestionTemplateID: string,
        publicGameTemplate:  {
          __typename: "PublicGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          featuredGroup?: string | null,
          featuredOrder?: number | null,
          type?: string | null,
          owner?: string | null,
        },
        publicQuestionTemplate:  {
          __typename: "PublicQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type DeletePublicQuestionTemplateMutationVariables = {
  input: DeletePublicQuestionTemplateInput,
  condition?: ModelPublicQuestionTemplateConditionInput | null,
};

export type DeletePublicQuestionTemplateMutation = {
  deletePublicQuestionTemplate?:  {
    __typename: "PublicQuestionTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelPublicGameQuestionsConnection",
      items:  Array< {
        __typename: "PublicGameQuestions",
        id: string,
        publicGameTemplateID: string,
        publicQuestionTemplateID: string,
        publicGameTemplate:  {
          __typename: "PublicGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          featuredGroup?: string | null,
          featuredOrder?: number | null,
          type?: string | null,
          owner?: string | null,
        },
        publicQuestionTemplate:  {
          __typename: "PublicQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type CreatePrivateQuestionTemplateMutationVariables = {
  input: CreatePrivateQuestionTemplateInput,
  condition?: ModelPrivateQuestionTemplateConditionInput | null,
};

export type CreatePrivateQuestionTemplateMutation = {
  createPrivateQuestionTemplate?:  {
    __typename: "PrivateQuestionTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelPrivateGameQuestionsConnection",
      items:  Array< {
        __typename: "PrivateGameQuestions",
        id: string,
        privateGameTemplateID: string,
        privateQuestionTemplateID: string,
        privateGameTemplate:  {
          __typename: "PrivateGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        privateQuestionTemplate:  {
          __typename: "PrivateQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type UpdatePrivateQuestionTemplateMutationVariables = {
  input: UpdatePrivateQuestionTemplateInput,
  condition?: ModelPrivateQuestionTemplateConditionInput | null,
};

export type UpdatePrivateQuestionTemplateMutation = {
  updatePrivateQuestionTemplate?:  {
    __typename: "PrivateQuestionTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelPrivateGameQuestionsConnection",
      items:  Array< {
        __typename: "PrivateGameQuestions",
        id: string,
        privateGameTemplateID: string,
        privateQuestionTemplateID: string,
        privateGameTemplate:  {
          __typename: "PrivateGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        privateQuestionTemplate:  {
          __typename: "PrivateQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type DeletePrivateQuestionTemplateMutationVariables = {
  input: DeletePrivateQuestionTemplateInput,
  condition?: ModelPrivateQuestionTemplateConditionInput | null,
};

export type DeletePrivateQuestionTemplateMutation = {
  deletePrivateQuestionTemplate?:  {
    __typename: "PrivateQuestionTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelPrivateGameQuestionsConnection",
      items:  Array< {
        __typename: "PrivateGameQuestions",
        id: string,
        privateGameTemplateID: string,
        privateQuestionTemplateID: string,
        privateGameTemplate:  {
          __typename: "PrivateGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        privateQuestionTemplate:  {
          __typename: "PrivateQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type CreateDraftQuestionTemplateMutationVariables = {
  input: CreateDraftQuestionTemplateInput,
  condition?: ModelDraftQuestionTemplateConditionInput | null,
};

export type CreateDraftQuestionTemplateMutation = {
  createDraftQuestionTemplate?:  {
    __typename: "DraftQuestionTemplate",
    id?: string | null,
    userId?: string | null,
    publicPrivateType?: string | null,
    title?: string | null,
    lowerCaseTitle?: string | null,
    version?: number | null,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelDraftGameQuestionsConnection",
      items:  Array< {
        __typename: "DraftGameQuestions",
        id: string,
        draftGameTemplateID: string,
        draftQuestionTemplateID: string,
        draftGameTemplate:  {
          __typename: "DraftGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          description?: string | null,
          lowerCaseDescription?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        draftQuestionTemplate:  {
          __typename: "DraftQuestionTemplate",
          id?: string | null,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type UpdateDraftQuestionTemplateMutationVariables = {
  input: UpdateDraftQuestionTemplateInput,
  condition?: ModelDraftQuestionTemplateConditionInput | null,
};

export type UpdateDraftQuestionTemplateMutation = {
  updateDraftQuestionTemplate?:  {
    __typename: "DraftQuestionTemplate",
    id?: string | null,
    userId?: string | null,
    publicPrivateType?: string | null,
    title?: string | null,
    lowerCaseTitle?: string | null,
    version?: number | null,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelDraftGameQuestionsConnection",
      items:  Array< {
        __typename: "DraftGameQuestions",
        id: string,
        draftGameTemplateID: string,
        draftQuestionTemplateID: string,
        draftGameTemplate:  {
          __typename: "DraftGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          description?: string | null,
          lowerCaseDescription?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        draftQuestionTemplate:  {
          __typename: "DraftQuestionTemplate",
          id?: string | null,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type DeleteDraftQuestionTemplateMutationVariables = {
  input: DeleteDraftQuestionTemplateInput,
  condition?: ModelDraftQuestionTemplateConditionInput | null,
};

export type DeleteDraftQuestionTemplateMutation = {
  deleteDraftQuestionTemplate?:  {
    __typename: "DraftQuestionTemplate",
    id?: string | null,
    userId?: string | null,
    publicPrivateType?: string | null,
    title?: string | null,
    lowerCaseTitle?: string | null,
    version?: number | null,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelDraftGameQuestionsConnection",
      items:  Array< {
        __typename: "DraftGameQuestions",
        id: string,
        draftGameTemplateID: string,
        draftQuestionTemplateID: string,
        draftGameTemplate:  {
          __typename: "DraftGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          description?: string | null,
          lowerCaseDescription?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        draftQuestionTemplate:  {
          __typename: "DraftQuestionTemplate",
          id?: string | null,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type CreateGameSessionMutationVariables = {
  input: CreateGameSessionInput,
  condition?: ModelGameSessionConditionInput | null,
};

export type CreateGameSessionMutation = {
  createGameSession?:  {
    __typename: "GameSession",
    id: string,
    classroomId?: string | null,
    gameId: string,
    startTime?: string | null,
    phaseOneTime: number,
    phaseTwoTime: number,
    teams?:  {
      __typename: "ModelTeamConnection",
      items:  Array< {
        __typename: "Team",
        id: string,
        globalStudentId?: string | null,
        name: string,
        question?:  {
          __typename: "Question",
          id: string,
          text: string,
          choices?: string | null,
          answerSettings?: string | null,
          answerData?: string | null,
          hints?: string | null,
          imageUrl?: string | null,
          instructions?: string | null,
          standard?: string | null,
          cluster?: string | null,
          domain?: string | null,
          grade?: string | null,
          order: number,
          isConfidenceEnabled: boolean,
          isShortAnswerEnabled: boolean,
          isHintEnabled: boolean,
          gameSessionId: string,
        } | null,
        teamMembers?:  {
          __typename: "ModelTeamMemberConnection",
          items:  Array< {
            __typename: "TeamMember",
            id: string,
            isFacilitator?: boolean | null,
            answers?:  {
              __typename: "ModelTeamAnswerConnection",
              items:  Array< {
                __typename: "TeamAnswer",
                id: string,
                isCorrect?: boolean | null,
                isSubmitted: boolean,
                isShortAnswerEnabled: boolean,
                currentState: GameSessionState,
                currentQuestionIndex: number,
                questionId: string,
                teamMemberAnswersId: string,
                teamAnswersId: string,
                teamName?: string | null,
                text: string,
                answer: string,
                confidenceLevel?: ConfidenceLevel | null,
                hint?: string | null,
                createdAt: string,
                updatedAt: string,
              } | null >,
              nextToken?: string | null,
            } | null,
            deviceId: string,
            createdAt: string,
            updatedAt: string,
            teamTeamMembersId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        score: number,
        selectedAvatarIndex: number,
        createdAt: string,
        updatedAt: string,
        gameSessionTeamsId?: string | null,
        teamQuestionId?: string | null,
        teamQuestionOrder?: number | null,
        teamQuestionGameSessionId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    currentQuestionIndex?: number | null,
    currentState: GameSessionState,
    gameCode: number,
    isAdvancedMode: boolean,
    imageUrl?: string | null,
    description?: string | null,
    title?: string | null,
    currentTimer?: number | null,
    studentID?: number | null,
    sessionData?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        text: string,
        choices?: string | null,
        answerSettings?: string | null,
        answerData?: string | null,
        hints?: string | null,
        imageUrl?: string | null,
        instructions?: string | null,
        standard?: string | null,
        cluster?: string | null,
        domain?: string | null,
        grade?: string | null,
        order: number,
        isConfidenceEnabled: boolean,
        isShortAnswerEnabled: boolean,
        isHintEnabled: boolean,
        gameSessionId: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateGameSessionMutationVariables = {
  input: UpdateGameSessionInput,
  condition?: ModelGameSessionConditionInput | null,
};

export type UpdateGameSessionMutation = {
  updateGameSession?:  {
    __typename: "GameSession",
    id: string,
    classroomId?: string | null,
    gameId: string,
    startTime?: string | null,
    phaseOneTime: number,
    phaseTwoTime: number,
    teams?:  {
      __typename: "ModelTeamConnection",
      items:  Array< {
        __typename: "Team",
        id: string,
        globalStudentId?: string | null,
        name: string,
        question?:  {
          __typename: "Question",
          id: string,
          text: string,
          choices?: string | null,
          answerSettings?: string | null,
          answerData?: string | null,
          hints?: string | null,
          imageUrl?: string | null,
          instructions?: string | null,
          standard?: string | null,
          cluster?: string | null,
          domain?: string | null,
          grade?: string | null,
          order: number,
          isConfidenceEnabled: boolean,
          isShortAnswerEnabled: boolean,
          isHintEnabled: boolean,
          gameSessionId: string,
        } | null,
        teamMembers?:  {
          __typename: "ModelTeamMemberConnection",
          items:  Array< {
            __typename: "TeamMember",
            id: string,
            isFacilitator?: boolean | null,
            answers?:  {
              __typename: "ModelTeamAnswerConnection",
              items:  Array< {
                __typename: "TeamAnswer",
                id: string,
                isCorrect?: boolean | null,
                isSubmitted: boolean,
                isShortAnswerEnabled: boolean,
                currentState: GameSessionState,
                currentQuestionIndex: number,
                questionId: string,
                teamMemberAnswersId: string,
                teamAnswersId: string,
                teamName?: string | null,
                text: string,
                answer: string,
                confidenceLevel?: ConfidenceLevel | null,
                hint?: string | null,
                createdAt: string,
                updatedAt: string,
              } | null >,
              nextToken?: string | null,
            } | null,
            deviceId: string,
            createdAt: string,
            updatedAt: string,
            teamTeamMembersId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        score: number,
        selectedAvatarIndex: number,
        createdAt: string,
        updatedAt: string,
        gameSessionTeamsId?: string | null,
        teamQuestionId?: string | null,
        teamQuestionOrder?: number | null,
        teamQuestionGameSessionId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    currentQuestionIndex?: number | null,
    currentState: GameSessionState,
    gameCode: number,
    isAdvancedMode: boolean,
    imageUrl?: string | null,
    description?: string | null,
    title?: string | null,
    currentTimer?: number | null,
    studentID?: number | null,
    sessionData?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        text: string,
        choices?: string | null,
        answerSettings?: string | null,
        answerData?: string | null,
        hints?: string | null,
        imageUrl?: string | null,
        instructions?: string | null,
        standard?: string | null,
        cluster?: string | null,
        domain?: string | null,
        grade?: string | null,
        order: number,
        isConfidenceEnabled: boolean,
        isShortAnswerEnabled: boolean,
        isHintEnabled: boolean,
        gameSessionId: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteGameSessionMutationVariables = {
  input: DeleteGameSessionInput,
  condition?: ModelGameSessionConditionInput | null,
};

export type DeleteGameSessionMutation = {
  deleteGameSession?:  {
    __typename: "GameSession",
    id: string,
    classroomId?: string | null,
    gameId: string,
    startTime?: string | null,
    phaseOneTime: number,
    phaseTwoTime: number,
    teams?:  {
      __typename: "ModelTeamConnection",
      items:  Array< {
        __typename: "Team",
        id: string,
        globalStudentId?: string | null,
        name: string,
        question?:  {
          __typename: "Question",
          id: string,
          text: string,
          choices?: string | null,
          answerSettings?: string | null,
          answerData?: string | null,
          hints?: string | null,
          imageUrl?: string | null,
          instructions?: string | null,
          standard?: string | null,
          cluster?: string | null,
          domain?: string | null,
          grade?: string | null,
          order: number,
          isConfidenceEnabled: boolean,
          isShortAnswerEnabled: boolean,
          isHintEnabled: boolean,
          gameSessionId: string,
        } | null,
        teamMembers?:  {
          __typename: "ModelTeamMemberConnection",
          items:  Array< {
            __typename: "TeamMember",
            id: string,
            isFacilitator?: boolean | null,
            answers?:  {
              __typename: "ModelTeamAnswerConnection",
              items:  Array< {
                __typename: "TeamAnswer",
                id: string,
                isCorrect?: boolean | null,
                isSubmitted: boolean,
                isShortAnswerEnabled: boolean,
                currentState: GameSessionState,
                currentQuestionIndex: number,
                questionId: string,
                teamMemberAnswersId: string,
                teamAnswersId: string,
                teamName?: string | null,
                text: string,
                answer: string,
                confidenceLevel?: ConfidenceLevel | null,
                hint?: string | null,
                createdAt: string,
                updatedAt: string,
              } | null >,
              nextToken?: string | null,
            } | null,
            deviceId: string,
            createdAt: string,
            updatedAt: string,
            teamTeamMembersId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        score: number,
        selectedAvatarIndex: number,
        createdAt: string,
        updatedAt: string,
        gameSessionTeamsId?: string | null,
        teamQuestionId?: string | null,
        teamQuestionOrder?: number | null,
        teamQuestionGameSessionId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    currentQuestionIndex?: number | null,
    currentState: GameSessionState,
    gameCode: number,
    isAdvancedMode: boolean,
    imageUrl?: string | null,
    description?: string | null,
    title?: string | null,
    currentTimer?: number | null,
    studentID?: number | null,
    sessionData?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        text: string,
        choices?: string | null,
        answerSettings?: string | null,
        answerData?: string | null,
        hints?: string | null,
        imageUrl?: string | null,
        instructions?: string | null,
        standard?: string | null,
        cluster?: string | null,
        domain?: string | null,
        grade?: string | null,
        order: number,
        isConfidenceEnabled: boolean,
        isShortAnswerEnabled: boolean,
        isHintEnabled: boolean,
        gameSessionId: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateQuestionMutationVariables = {
  input: CreateQuestionInput,
  condition?: ModelQuestionConditionInput | null,
};

export type CreateQuestionMutation = {
  createQuestion?:  {
    __typename: "Question",
    id: string,
    text: string,
    choices?: string | null,
    answerSettings?: string | null,
    answerData?: string | null,
    hints?: string | null,
    imageUrl?: string | null,
    instructions?: string | null,
    standard?: string | null,
    cluster?: string | null,
    domain?: string | null,
    grade?: string | null,
    order: number,
    isConfidenceEnabled: boolean,
    isShortAnswerEnabled: boolean,
    isHintEnabled: boolean,
    gameSessionId: string,
  } | null,
};

export type UpdateQuestionMutationVariables = {
  input: UpdateQuestionInput,
  condition?: ModelQuestionConditionInput | null,
};

export type UpdateQuestionMutation = {
  updateQuestion?:  {
    __typename: "Question",
    id: string,
    text: string,
    choices?: string | null,
    answerSettings?: string | null,
    answerData?: string | null,
    hints?: string | null,
    imageUrl?: string | null,
    instructions?: string | null,
    standard?: string | null,
    cluster?: string | null,
    domain?: string | null,
    grade?: string | null,
    order: number,
    isConfidenceEnabled: boolean,
    isShortAnswerEnabled: boolean,
    isHintEnabled: boolean,
    gameSessionId: string,
  } | null,
};

export type DeleteQuestionMutationVariables = {
  input: DeleteQuestionInput,
  condition?: ModelQuestionConditionInput | null,
};

export type DeleteQuestionMutation = {
  deleteQuestion?:  {
    __typename: "Question",
    id: string,
    text: string,
    choices?: string | null,
    answerSettings?: string | null,
    answerData?: string | null,
    hints?: string | null,
    imageUrl?: string | null,
    instructions?: string | null,
    standard?: string | null,
    cluster?: string | null,
    domain?: string | null,
    grade?: string | null,
    order: number,
    isConfidenceEnabled: boolean,
    isShortAnswerEnabled: boolean,
    isHintEnabled: boolean,
    gameSessionId: string,
  } | null,
};

export type CreateTeamMutationVariables = {
  input: CreateTeamInput,
  condition?: ModelTeamConditionInput | null,
};

export type CreateTeamMutation = {
  createTeam?:  {
    __typename: "Team",
    id: string,
    globalStudentId?: string | null,
    name: string,
    question?:  {
      __typename: "Question",
      id: string,
      text: string,
      choices?: string | null,
      answerSettings?: string | null,
      answerData?: string | null,
      hints?: string | null,
      imageUrl?: string | null,
      instructions?: string | null,
      standard?: string | null,
      cluster?: string | null,
      domain?: string | null,
      grade?: string | null,
      order: number,
      isConfidenceEnabled: boolean,
      isShortAnswerEnabled: boolean,
      isHintEnabled: boolean,
      gameSessionId: string,
    } | null,
    teamMembers?:  {
      __typename: "ModelTeamMemberConnection",
      items:  Array< {
        __typename: "TeamMember",
        id: string,
        isFacilitator?: boolean | null,
        answers?:  {
          __typename: "ModelTeamAnswerConnection",
          items:  Array< {
            __typename: "TeamAnswer",
            id: string,
            isCorrect?: boolean | null,
            isSubmitted: boolean,
            isShortAnswerEnabled: boolean,
            currentState: GameSessionState,
            currentQuestionIndex: number,
            questionId: string,
            teamMemberAnswersId: string,
            teamAnswersId: string,
            teamName?: string | null,
            text: string,
            answer: string,
            confidenceLevel?: ConfidenceLevel | null,
            hint?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        deviceId: string,
        createdAt: string,
        updatedAt: string,
        teamTeamMembersId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    score: number,
    selectedAvatarIndex: number,
    createdAt: string,
    updatedAt: string,
    gameSessionTeamsId?: string | null,
    teamQuestionId?: string | null,
    teamQuestionOrder?: number | null,
    teamQuestionGameSessionId?: string | null,
  } | null,
};

export type UpdateTeamMutationVariables = {
  input: UpdateTeamInput,
  condition?: ModelTeamConditionInput | null,
};

export type UpdateTeamMutation = {
  updateTeam?:  {
    __typename: "Team",
    id: string,
    globalStudentId?: string | null,
    name: string,
    question?:  {
      __typename: "Question",
      id: string,
      text: string,
      choices?: string | null,
      answerSettings?: string | null,
      answerData?: string | null,
      hints?: string | null,
      imageUrl?: string | null,
      instructions?: string | null,
      standard?: string | null,
      cluster?: string | null,
      domain?: string | null,
      grade?: string | null,
      order: number,
      isConfidenceEnabled: boolean,
      isShortAnswerEnabled: boolean,
      isHintEnabled: boolean,
      gameSessionId: string,
    } | null,
    teamMembers?:  {
      __typename: "ModelTeamMemberConnection",
      items:  Array< {
        __typename: "TeamMember",
        id: string,
        isFacilitator?: boolean | null,
        answers?:  {
          __typename: "ModelTeamAnswerConnection",
          items:  Array< {
            __typename: "TeamAnswer",
            id: string,
            isCorrect?: boolean | null,
            isSubmitted: boolean,
            isShortAnswerEnabled: boolean,
            currentState: GameSessionState,
            currentQuestionIndex: number,
            questionId: string,
            teamMemberAnswersId: string,
            teamAnswersId: string,
            teamName?: string | null,
            text: string,
            answer: string,
            confidenceLevel?: ConfidenceLevel | null,
            hint?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        deviceId: string,
        createdAt: string,
        updatedAt: string,
        teamTeamMembersId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    score: number,
    selectedAvatarIndex: number,
    createdAt: string,
    updatedAt: string,
    gameSessionTeamsId?: string | null,
    teamQuestionId?: string | null,
    teamQuestionOrder?: number | null,
    teamQuestionGameSessionId?: string | null,
  } | null,
};

export type DeleteTeamMutationVariables = {
  input: DeleteTeamInput,
  condition?: ModelTeamConditionInput | null,
};

export type DeleteTeamMutation = {
  deleteTeam?:  {
    __typename: "Team",
    id: string,
    globalStudentId?: string | null,
    name: string,
    question?:  {
      __typename: "Question",
      id: string,
      text: string,
      choices?: string | null,
      answerSettings?: string | null,
      answerData?: string | null,
      hints?: string | null,
      imageUrl?: string | null,
      instructions?: string | null,
      standard?: string | null,
      cluster?: string | null,
      domain?: string | null,
      grade?: string | null,
      order: number,
      isConfidenceEnabled: boolean,
      isShortAnswerEnabled: boolean,
      isHintEnabled: boolean,
      gameSessionId: string,
    } | null,
    teamMembers?:  {
      __typename: "ModelTeamMemberConnection",
      items:  Array< {
        __typename: "TeamMember",
        id: string,
        isFacilitator?: boolean | null,
        answers?:  {
          __typename: "ModelTeamAnswerConnection",
          items:  Array< {
            __typename: "TeamAnswer",
            id: string,
            isCorrect?: boolean | null,
            isSubmitted: boolean,
            isShortAnswerEnabled: boolean,
            currentState: GameSessionState,
            currentQuestionIndex: number,
            questionId: string,
            teamMemberAnswersId: string,
            teamAnswersId: string,
            teamName?: string | null,
            text: string,
            answer: string,
            confidenceLevel?: ConfidenceLevel | null,
            hint?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        deviceId: string,
        createdAt: string,
        updatedAt: string,
        teamTeamMembersId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    score: number,
    selectedAvatarIndex: number,
    createdAt: string,
    updatedAt: string,
    gameSessionTeamsId?: string | null,
    teamQuestionId?: string | null,
    teamQuestionOrder?: number | null,
    teamQuestionGameSessionId?: string | null,
  } | null,
};

export type CreateTeamMemberMutationVariables = {
  input: CreateTeamMemberInput,
  condition?: ModelTeamMemberConditionInput | null,
};

export type CreateTeamMemberMutation = {
  createTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    isFacilitator?: boolean | null,
    answers?:  {
      __typename: "ModelTeamAnswerConnection",
      items:  Array< {
        __typename: "TeamAnswer",
        id: string,
        isCorrect?: boolean | null,
        isSubmitted: boolean,
        isShortAnswerEnabled: boolean,
        currentState: GameSessionState,
        currentQuestionIndex: number,
        questionId: string,
        teamMemberAnswersId: string,
        teamAnswersId: string,
        teamName?: string | null,
        text: string,
        answer: string,
        confidenceLevel?: ConfidenceLevel | null,
        hint?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deviceId: string,
    createdAt: string,
    updatedAt: string,
    teamTeamMembersId?: string | null,
  } | null,
};

export type UpdateTeamMemberMutationVariables = {
  input: UpdateTeamMemberInput,
  condition?: ModelTeamMemberConditionInput | null,
};

export type UpdateTeamMemberMutation = {
  updateTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    isFacilitator?: boolean | null,
    answers?:  {
      __typename: "ModelTeamAnswerConnection",
      items:  Array< {
        __typename: "TeamAnswer",
        id: string,
        isCorrect?: boolean | null,
        isSubmitted: boolean,
        isShortAnswerEnabled: boolean,
        currentState: GameSessionState,
        currentQuestionIndex: number,
        questionId: string,
        teamMemberAnswersId: string,
        teamAnswersId: string,
        teamName?: string | null,
        text: string,
        answer: string,
        confidenceLevel?: ConfidenceLevel | null,
        hint?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deviceId: string,
    createdAt: string,
    updatedAt: string,
    teamTeamMembersId?: string | null,
  } | null,
};

export type DeleteTeamMemberMutationVariables = {
  input: DeleteTeamMemberInput,
  condition?: ModelTeamMemberConditionInput | null,
};

export type DeleteTeamMemberMutation = {
  deleteTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    isFacilitator?: boolean | null,
    answers?:  {
      __typename: "ModelTeamAnswerConnection",
      items:  Array< {
        __typename: "TeamAnswer",
        id: string,
        isCorrect?: boolean | null,
        isSubmitted: boolean,
        isShortAnswerEnabled: boolean,
        currentState: GameSessionState,
        currentQuestionIndex: number,
        questionId: string,
        teamMemberAnswersId: string,
        teamAnswersId: string,
        teamName?: string | null,
        text: string,
        answer: string,
        confidenceLevel?: ConfidenceLevel | null,
        hint?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deviceId: string,
    createdAt: string,
    updatedAt: string,
    teamTeamMembersId?: string | null,
  } | null,
};

export type CreateTeamAnswerMutationVariables = {
  input: CreateTeamAnswerInput,
  condition?: ModelTeamAnswerConditionInput | null,
};

export type CreateTeamAnswerMutation = {
  createTeamAnswer?:  {
    __typename: "TeamAnswer",
    id: string,
    isCorrect?: boolean | null,
    isSubmitted: boolean,
    isShortAnswerEnabled: boolean,
    currentState: GameSessionState,
    currentQuestionIndex: number,
    questionId: string,
    teamMemberAnswersId: string,
    teamAnswersId: string,
    teamName?: string | null,
    text: string,
    answer: string,
    confidenceLevel?: ConfidenceLevel | null,
    hint?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTeamAnswerMutationVariables = {
  input: UpdateTeamAnswerInput,
  condition?: ModelTeamAnswerConditionInput | null,
};

export type UpdateTeamAnswerMutation = {
  updateTeamAnswer?:  {
    __typename: "TeamAnswer",
    id: string,
    isCorrect?: boolean | null,
    isSubmitted: boolean,
    isShortAnswerEnabled: boolean,
    currentState: GameSessionState,
    currentQuestionIndex: number,
    questionId: string,
    teamMemberAnswersId: string,
    teamAnswersId: string,
    teamName?: string | null,
    text: string,
    answer: string,
    confidenceLevel?: ConfidenceLevel | null,
    hint?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTeamAnswerMutationVariables = {
  input: DeleteTeamAnswerInput,
  condition?: ModelTeamAnswerConditionInput | null,
};

export type DeleteTeamAnswerMutation = {
  deleteTeamAnswer?:  {
    __typename: "TeamAnswer",
    id: string,
    isCorrect?: boolean | null,
    isSubmitted: boolean,
    isShortAnswerEnabled: boolean,
    currentState: GameSessionState,
    currentQuestionIndex: number,
    questionId: string,
    teamMemberAnswersId: string,
    teamAnswersId: string,
    teamName?: string | null,
    text: string,
    answer: string,
    confidenceLevel?: ConfidenceLevel | null,
    hint?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePublicGameQuestionsMutationVariables = {
  input: CreatePublicGameQuestionsInput,
  condition?: ModelPublicGameQuestionsConditionInput | null,
};

export type CreatePublicGameQuestionsMutation = {
  createPublicGameQuestions?:  {
    __typename: "PublicGameQuestions",
    id: string,
    publicGameTemplateID: string,
    publicQuestionTemplateID: string,
    publicGameTemplate:  {
      __typename: "PublicGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      featuredGroup?: string | null,
      featuredOrder?: number | null,
      type?: string | null,
      owner?: string | null,
    },
    publicQuestionTemplate:  {
      __typename: "PublicQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdatePublicGameQuestionsMutationVariables = {
  input: UpdatePublicGameQuestionsInput,
  condition?: ModelPublicGameQuestionsConditionInput | null,
};

export type UpdatePublicGameQuestionsMutation = {
  updatePublicGameQuestions?:  {
    __typename: "PublicGameQuestions",
    id: string,
    publicGameTemplateID: string,
    publicQuestionTemplateID: string,
    publicGameTemplate:  {
      __typename: "PublicGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      featuredGroup?: string | null,
      featuredOrder?: number | null,
      type?: string | null,
      owner?: string | null,
    },
    publicQuestionTemplate:  {
      __typename: "PublicQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeletePublicGameQuestionsMutationVariables = {
  input: DeletePublicGameQuestionsInput,
  condition?: ModelPublicGameQuestionsConditionInput | null,
};

export type DeletePublicGameQuestionsMutation = {
  deletePublicGameQuestions?:  {
    __typename: "PublicGameQuestions",
    id: string,
    publicGameTemplateID: string,
    publicQuestionTemplateID: string,
    publicGameTemplate:  {
      __typename: "PublicGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      featuredGroup?: string | null,
      featuredOrder?: number | null,
      type?: string | null,
      owner?: string | null,
    },
    publicQuestionTemplate:  {
      __typename: "PublicQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreatePrivateGameQuestionsMutationVariables = {
  input: CreatePrivateGameQuestionsInput,
  condition?: ModelPrivateGameQuestionsConditionInput | null,
};

export type CreatePrivateGameQuestionsMutation = {
  createPrivateGameQuestions?:  {
    __typename: "PrivateGameQuestions",
    id: string,
    privateGameTemplateID: string,
    privateQuestionTemplateID: string,
    privateGameTemplate:  {
      __typename: "PrivateGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    privateQuestionTemplate:  {
      __typename: "PrivateQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdatePrivateGameQuestionsMutationVariables = {
  input: UpdatePrivateGameQuestionsInput,
  condition?: ModelPrivateGameQuestionsConditionInput | null,
};

export type UpdatePrivateGameQuestionsMutation = {
  updatePrivateGameQuestions?:  {
    __typename: "PrivateGameQuestions",
    id: string,
    privateGameTemplateID: string,
    privateQuestionTemplateID: string,
    privateGameTemplate:  {
      __typename: "PrivateGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    privateQuestionTemplate:  {
      __typename: "PrivateQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeletePrivateGameQuestionsMutationVariables = {
  input: DeletePrivateGameQuestionsInput,
  condition?: ModelPrivateGameQuestionsConditionInput | null,
};

export type DeletePrivateGameQuestionsMutation = {
  deletePrivateGameQuestions?:  {
    __typename: "PrivateGameQuestions",
    id: string,
    privateGameTemplateID: string,
    privateQuestionTemplateID: string,
    privateGameTemplate:  {
      __typename: "PrivateGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    privateQuestionTemplate:  {
      __typename: "PrivateQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateDraftGameQuestionsMutationVariables = {
  input: CreateDraftGameQuestionsInput,
  condition?: ModelDraftGameQuestionsConditionInput | null,
};

export type CreateDraftGameQuestionsMutation = {
  createDraftGameQuestions?:  {
    __typename: "DraftGameQuestions",
    id: string,
    draftGameTemplateID: string,
    draftQuestionTemplateID: string,
    draftGameTemplate:  {
      __typename: "DraftGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      description?: string | null,
      lowerCaseDescription?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    draftQuestionTemplate:  {
      __typename: "DraftQuestionTemplate",
      id?: string | null,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateDraftGameQuestionsMutationVariables = {
  input: UpdateDraftGameQuestionsInput,
  condition?: ModelDraftGameQuestionsConditionInput | null,
};

export type UpdateDraftGameQuestionsMutation = {
  updateDraftGameQuestions?:  {
    __typename: "DraftGameQuestions",
    id: string,
    draftGameTemplateID: string,
    draftQuestionTemplateID: string,
    draftGameTemplate:  {
      __typename: "DraftGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      description?: string | null,
      lowerCaseDescription?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    draftQuestionTemplate:  {
      __typename: "DraftQuestionTemplate",
      id?: string | null,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteDraftGameQuestionsMutationVariables = {
  input: DeleteDraftGameQuestionsInput,
  condition?: ModelDraftGameQuestionsConditionInput | null,
};

export type DeleteDraftGameQuestionsMutation = {
  deleteDraftGameQuestions?:  {
    __typename: "DraftGameQuestions",
    id: string,
    draftGameTemplateID: string,
    draftQuestionTemplateID: string,
    draftGameTemplate:  {
      __typename: "DraftGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      description?: string | null,
      lowerCaseDescription?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    draftQuestionTemplate:  {
      __typename: "DraftQuestionTemplate",
      id?: string | null,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateGameSessionFromTemplateMutationVariables = {
  input: CreateGameSessionFromTemplateInput,
};

export type CreateGameSessionFromTemplateMutation = {
  createGameSessionFromTemplate?: string | null,
};

export type TeacherIdAuthMutationVariables = {
  input: TeacherIdAuthInput,
};

export type TeacherIdAuthMutation = {
  teacherIdAuth?: string | null,
};

export type UserCleanerMutationVariables = {
  input: string,
};

export type UserCleanerMutation = {
  userCleaner?: string | null,
};

export type UploadExternalImageToS3MutationVariables = {
  input?: UploadExternalImageToS3Input | null,
};

export type UploadExternalImageToS3Mutation = {
  uploadExternalImageToS3?: string | null,
};

export type WaegenMutationVariables = {
  input?: WaeGenInput | null,
};

export type WaegenMutation = {
  waegen?: string | null,
};

export type WaeregenMutationVariables = {
  input?: WaeRegenInput | null,
};

export type WaeregenMutation = {
  waeregen?: string | null,
};

export type DeleteUnverifiedUserMutationVariables = {
  input?: DeleteUnverifiedUserInput | null,
};

export type DeleteUnverifiedUserMutation = {
  deleteUnverifiedUser?: string | null,
};

export type UpdateUserPassMutationVariables = {
  input?: UpdateUserPassInput | null,
};

export type UpdateUserPassMutation = {
  updateUserPass?: string | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    userName: string,
    dynamoId?: string | null,
    cognitoId: string,
    title?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    email: string,
    password?: string | null,
    gamesMade?: number | null,
    gamesUsed?: number | null,
    questionsMade?: number | null,
    frontIdPath?: string | null,
    backIdPath?: string | null,
    profilePicPath?: string | null,
    favoriteGameTemplateIds?: string | null,
    favoriteQuestionTemplateIds?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListUsersQueryVariables = {
  id?: string | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      userName: string,
      dynamoId?: string | null,
      cognitoId: string,
      title?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email: string,
      password?: string | null,
      gamesMade?: number | null,
      gamesUsed?: number | null,
      questionsMade?: number | null,
      frontIdPath?: string | null,
      backIdPath?: string | null,
      profilePicPath?: string | null,
      favoriteGameTemplateIds?: string | null,
      favoriteQuestionTemplateIds?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UserByUserNameQueryVariables = {
  userName: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserByUserNameQuery = {
  userByUserName?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      userName: string,
      dynamoId?: string | null,
      cognitoId: string,
      title?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email: string,
      password?: string | null,
      gamesMade?: number | null,
      gamesUsed?: number | null,
      questionsMade?: number | null,
      frontIdPath?: string | null,
      backIdPath?: string | null,
      profilePicPath?: string | null,
      favoriteGameTemplateIds?: string | null,
      favoriteQuestionTemplateIds?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UserByCognitoIdQueryVariables = {
  cognitoId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserByCognitoIdQuery = {
  userByCognitoId?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      userName: string,
      dynamoId?: string | null,
      cognitoId: string,
      title?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email: string,
      password?: string | null,
      gamesMade?: number | null,
      gamesUsed?: number | null,
      questionsMade?: number | null,
      frontIdPath?: string | null,
      backIdPath?: string | null,
      profilePicPath?: string | null,
      favoriteGameTemplateIds?: string | null,
      favoriteQuestionTemplateIds?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UserByEmailQueryVariables = {
  email: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserByEmailQuery = {
  userByEmail?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      userName: string,
      dynamoId?: string | null,
      cognitoId: string,
      title?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email: string,
      password?: string | null,
      gamesMade?: number | null,
      gamesUsed?: number | null,
      questionsMade?: number | null,
      frontIdPath?: string | null,
      backIdPath?: string | null,
      profilePicPath?: string | null,
      favoriteGameTemplateIds?: string | null,
      favoriteQuestionTemplateIds?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPublicGameTemplateQueryVariables = {
  id: string,
};

export type GetPublicGameTemplateQuery = {
  getPublicGameTemplate?:  {
    __typename: "PublicGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    description: string,
    lowerCaseDescription: string,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelPublicGameQuestionsConnection",
      items:  Array< {
        __typename: "PublicGameQuestions",
        id: string,
        publicGameTemplateID: string,
        publicQuestionTemplateID: string,
        publicGameTemplate:  {
          __typename: "PublicGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          featuredGroup?: string | null,
          featuredOrder?: number | null,
          type?: string | null,
          owner?: string | null,
        },
        publicQuestionTemplate:  {
          __typename: "PublicQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    featuredGroup?: string | null,
    featuredOrder?: number | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type ListPublicGameTemplatesQueryVariables = {
  filter?: ModelPublicGameTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPublicGameTemplatesQuery = {
  listPublicGameTemplates?:  {
    __typename: "ModelPublicGameTemplateConnection",
    items:  Array< {
      __typename: "PublicGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      featuredGroup?: string | null,
      featuredOrder?: number | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PublicGameTemplatesByUserDateQueryVariables = {
  userId: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPublicGameTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PublicGameTemplatesByUserDateQuery = {
  publicGameTemplatesByUserDate?:  {
    __typename: "ModelPublicGameTemplateConnection",
    items:  Array< {
      __typename: "PublicGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      featuredGroup?: string | null,
      featuredOrder?: number | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PublicGameTemplatesByUserPublicQuestionTemplatesCountQueryVariables = {
  userId: string,
  questionTemplatesCount?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPublicGameTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PublicGameTemplatesByUserPublicQuestionTemplatesCountQuery = {
  publicGameTemplatesByUserPublicQuestionTemplatesCount?:  {
    __typename: "ModelPublicGameTemplateConnection",
    items:  Array< {
      __typename: "PublicGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      featuredGroup?: string | null,
      featuredOrder?: number | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PublicGameTemplatesByUserGradeQueryVariables = {
  userId: string,
  grade?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPublicGameTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PublicGameTemplatesByUserGradeQuery = {
  publicGameTemplatesByUserGrade?:  {
    __typename: "ModelPublicGameTemplateConnection",
    items:  Array< {
      __typename: "PublicGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      featuredGroup?: string | null,
      featuredOrder?: number | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PublicGameTemplatesByFeaturedQueryVariables = {
  featuredGroup: string,
  featuredOrder?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPublicGameTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PublicGameTemplatesByFeaturedQuery = {
  publicGameTemplatesByFeatured?:  {
    __typename: "ModelPublicGameTemplateConnection",
    items:  Array< {
      __typename: "PublicGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      featuredGroup?: string | null,
      featuredOrder?: number | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PublicGameTemplatesByDateQueryVariables = {
  type: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPublicGameTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PublicGameTemplatesByDateQuery = {
  publicGameTemplatesByDate?:  {
    __typename: "ModelPublicGameTemplateConnection",
    items:  Array< {
      __typename: "PublicGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      featuredGroup?: string | null,
      featuredOrder?: number | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PublicGameTemplatesByGradeQueryVariables = {
  type: string,
  grade?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPublicGameTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PublicGameTemplatesByGradeQuery = {
  publicGameTemplatesByGrade?:  {
    __typename: "ModelPublicGameTemplateConnection",
    items:  Array< {
      __typename: "PublicGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      featuredGroup?: string | null,
      featuredOrder?: number | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PublicGameTemplatesByPublicQuestionTemplatesCountQueryVariables = {
  type: string,
  questionTemplatesCount?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPublicGameTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PublicGameTemplatesByPublicQuestionTemplatesCountQuery = {
  publicGameTemplatesByPublicQuestionTemplatesCount?:  {
    __typename: "ModelPublicGameTemplateConnection",
    items:  Array< {
      __typename: "PublicGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      featuredGroup?: string | null,
      featuredOrder?: number | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPrivateGameTemplateQueryVariables = {
  id: string,
};

export type GetPrivateGameTemplateQuery = {
  getPrivateGameTemplate?:  {
    __typename: "PrivateGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    description: string,
    lowerCaseDescription: string,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelPrivateGameQuestionsConnection",
      items:  Array< {
        __typename: "PrivateGameQuestions",
        id: string,
        privateGameTemplateID: string,
        privateQuestionTemplateID: string,
        privateGameTemplate:  {
          __typename: "PrivateGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        privateQuestionTemplate:  {
          __typename: "PrivateQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type ListPrivateGameTemplatesQueryVariables = {
  filter?: ModelPrivateGameTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPrivateGameTemplatesQuery = {
  listPrivateGameTemplates?:  {
    __typename: "ModelPrivateGameTemplateConnection",
    items:  Array< {
      __typename: "PrivateGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PrivateGameTemplatesByDateQueryVariables = {
  type: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPrivateGameTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PrivateGameTemplatesByDateQuery = {
  privateGameTemplatesByDate?:  {
    __typename: "ModelPrivateGameTemplateConnection",
    items:  Array< {
      __typename: "PrivateGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PrivateGameTemplatesByGradeQueryVariables = {
  type: string,
  grade?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPrivateGameTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PrivateGameTemplatesByGradeQuery = {
  privateGameTemplatesByGrade?:  {
    __typename: "ModelPrivateGameTemplateConnection",
    items:  Array< {
      __typename: "PrivateGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PrivateGameTemplatesByPrivateQuestionTemplatesCountQueryVariables = {
  type: string,
  questionTemplatesCount?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPrivateGameTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PrivateGameTemplatesByPrivateQuestionTemplatesCountQuery = {
  privateGameTemplatesByPrivateQuestionTemplatesCount?:  {
    __typename: "ModelPrivateGameTemplateConnection",
    items:  Array< {
      __typename: "PrivateGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDraftGameTemplateQueryVariables = {
  id: string,
};

export type GetDraftGameTemplateQuery = {
  getDraftGameTemplate?:  {
    __typename: "DraftGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title?: string | null,
    lowerCaseTitle?: string | null,
    version?: number | null,
    description?: string | null,
    lowerCaseDescription?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelDraftGameQuestionsConnection",
      items:  Array< {
        __typename: "DraftGameQuestions",
        id: string,
        draftGameTemplateID: string,
        draftQuestionTemplateID: string,
        draftGameTemplate:  {
          __typename: "DraftGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          description?: string | null,
          lowerCaseDescription?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        draftQuestionTemplate:  {
          __typename: "DraftQuestionTemplate",
          id?: string | null,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type ListDraftGameTemplatesQueryVariables = {
  filter?: ModelDraftGameTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDraftGameTemplatesQuery = {
  listDraftGameTemplates?:  {
    __typename: "ModelDraftGameTemplateConnection",
    items:  Array< {
      __typename: "DraftGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      description?: string | null,
      lowerCaseDescription?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DraftGameTemplatesByDateQueryVariables = {
  type: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDraftGameTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DraftGameTemplatesByDateQuery = {
  draftGameTemplatesByDate?:  {
    __typename: "ModelDraftGameTemplateConnection",
    items:  Array< {
      __typename: "DraftGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      description?: string | null,
      lowerCaseDescription?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DraftGameTemplatesByGradeQueryVariables = {
  type: string,
  grade?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDraftGameTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DraftGameTemplatesByGradeQuery = {
  draftGameTemplatesByGrade?:  {
    __typename: "ModelDraftGameTemplateConnection",
    items:  Array< {
      __typename: "DraftGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      description?: string | null,
      lowerCaseDescription?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DraftGameTemplatesByDraftQuestionTemplatesCountQueryVariables = {
  type: string,
  questionTemplatesCount?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDraftGameTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DraftGameTemplatesByDraftQuestionTemplatesCountQuery = {
  draftGameTemplatesByDraftQuestionTemplatesCount?:  {
    __typename: "ModelDraftGameTemplateConnection",
    items:  Array< {
      __typename: "DraftGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      description?: string | null,
      lowerCaseDescription?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPublicQuestionTemplateQueryVariables = {
  id: string,
};

export type GetPublicQuestionTemplateQuery = {
  getPublicQuestionTemplate?:  {
    __typename: "PublicQuestionTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelPublicGameQuestionsConnection",
      items:  Array< {
        __typename: "PublicGameQuestions",
        id: string,
        publicGameTemplateID: string,
        publicQuestionTemplateID: string,
        publicGameTemplate:  {
          __typename: "PublicGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          featuredGroup?: string | null,
          featuredOrder?: number | null,
          type?: string | null,
          owner?: string | null,
        },
        publicQuestionTemplate:  {
          __typename: "PublicQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type ListPublicQuestionTemplatesQueryVariables = {
  filter?: ModelPublicQuestionTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPublicQuestionTemplatesQuery = {
  listPublicQuestionTemplates?:  {
    __typename: "ModelPublicQuestionTemplateConnection",
    items:  Array< {
      __typename: "PublicQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PublicQuestionTemplatesByUserDateQueryVariables = {
  userId: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPublicQuestionTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PublicQuestionTemplatesByUserDateQuery = {
  publicQuestionTemplatesByUserDate?:  {
    __typename: "ModelPublicQuestionTemplateConnection",
    items:  Array< {
      __typename: "PublicQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PublicQuestionTemplatesByUserPublicGameTemplatesCountQueryVariables = {
  userId: string,
  gameTemplatesCount?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPublicQuestionTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PublicQuestionTemplatesByUserPublicGameTemplatesCountQuery = {
  publicQuestionTemplatesByUserPublicGameTemplatesCount?:  {
    __typename: "ModelPublicQuestionTemplateConnection",
    items:  Array< {
      __typename: "PublicQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PublicQuestionTemplatesByUserGradeQueryVariables = {
  userId: string,
  grade?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPublicQuestionTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PublicQuestionTemplatesByUserGradeQuery = {
  publicQuestionTemplatesByUserGrade?:  {
    __typename: "ModelPublicQuestionTemplateConnection",
    items:  Array< {
      __typename: "PublicQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PublicQuestionTemplatesByDateQueryVariables = {
  type: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPublicQuestionTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PublicQuestionTemplatesByDateQuery = {
  publicQuestionTemplatesByDate?:  {
    __typename: "ModelPublicQuestionTemplateConnection",
    items:  Array< {
      __typename: "PublicQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PublicQuestionTemplatesByGradeQueryVariables = {
  type: string,
  grade?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPublicQuestionTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PublicQuestionTemplatesByGradeQuery = {
  publicQuestionTemplatesByGrade?:  {
    __typename: "ModelPublicQuestionTemplateConnection",
    items:  Array< {
      __typename: "PublicQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PublicQuestionTemplatesByPublicGameTemplatesCountQueryVariables = {
  type: string,
  gameTemplatesCount?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPublicQuestionTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PublicQuestionTemplatesByPublicGameTemplatesCountQuery = {
  publicQuestionTemplatesByPublicGameTemplatesCount?:  {
    __typename: "ModelPublicQuestionTemplateConnection",
    items:  Array< {
      __typename: "PublicQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPrivateQuestionTemplateQueryVariables = {
  id: string,
};

export type GetPrivateQuestionTemplateQuery = {
  getPrivateQuestionTemplate?:  {
    __typename: "PrivateQuestionTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelPrivateGameQuestionsConnection",
      items:  Array< {
        __typename: "PrivateGameQuestions",
        id: string,
        privateGameTemplateID: string,
        privateQuestionTemplateID: string,
        privateGameTemplate:  {
          __typename: "PrivateGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        privateQuestionTemplate:  {
          __typename: "PrivateQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type ListPrivateQuestionTemplatesQueryVariables = {
  filter?: ModelPrivateQuestionTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPrivateQuestionTemplatesQuery = {
  listPrivateQuestionTemplates?:  {
    __typename: "ModelPrivateQuestionTemplateConnection",
    items:  Array< {
      __typename: "PrivateQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PrivateQuestionTemplatesByDateQueryVariables = {
  type: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPrivateQuestionTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PrivateQuestionTemplatesByDateQuery = {
  privateQuestionTemplatesByDate?:  {
    __typename: "ModelPrivateQuestionTemplateConnection",
    items:  Array< {
      __typename: "PrivateQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PrivateQuestionTemplatesByGradeQueryVariables = {
  type: string,
  grade?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPrivateQuestionTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PrivateQuestionTemplatesByGradeQuery = {
  privateQuestionTemplatesByGrade?:  {
    __typename: "ModelPrivateQuestionTemplateConnection",
    items:  Array< {
      __typename: "PrivateQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PrivateQuestionTemplatesByPrivateGameTemplatesCountQueryVariables = {
  type: string,
  gameTemplatesCount?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPrivateQuestionTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PrivateQuestionTemplatesByPrivateGameTemplatesCountQuery = {
  privateQuestionTemplatesByPrivateGameTemplatesCount?:  {
    __typename: "ModelPrivateQuestionTemplateConnection",
    items:  Array< {
      __typename: "PrivateQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDraftQuestionTemplateQueryVariables = {
  id: string,
};

export type GetDraftQuestionTemplateQuery = {
  getDraftQuestionTemplate?:  {
    __typename: "DraftQuestionTemplate",
    id?: string | null,
    userId?: string | null,
    publicPrivateType?: string | null,
    title?: string | null,
    lowerCaseTitle?: string | null,
    version?: number | null,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelDraftGameQuestionsConnection",
      items:  Array< {
        __typename: "DraftGameQuestions",
        id: string,
        draftGameTemplateID: string,
        draftQuestionTemplateID: string,
        draftGameTemplate:  {
          __typename: "DraftGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          description?: string | null,
          lowerCaseDescription?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        draftQuestionTemplate:  {
          __typename: "DraftQuestionTemplate",
          id?: string | null,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type ListDraftQuestionTemplatesQueryVariables = {
  filter?: ModelDraftQuestionTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDraftQuestionTemplatesQuery = {
  listDraftQuestionTemplates?:  {
    __typename: "ModelDraftQuestionTemplateConnection",
    items:  Array< {
      __typename: "DraftQuestionTemplate",
      id?: string | null,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DraftQuestionTemplatesByDateQueryVariables = {
  type: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDraftQuestionTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DraftQuestionTemplatesByDateQuery = {
  draftQuestionTemplatesByDate?:  {
    __typename: "ModelDraftQuestionTemplateConnection",
    items:  Array< {
      __typename: "DraftQuestionTemplate",
      id?: string | null,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DraftQuestionTemplatesByGradeQueryVariables = {
  type: string,
  grade?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDraftQuestionTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DraftQuestionTemplatesByGradeQuery = {
  draftQuestionTemplatesByGrade?:  {
    __typename: "ModelDraftQuestionTemplateConnection",
    items:  Array< {
      __typename: "DraftQuestionTemplate",
      id?: string | null,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DraftQuestionTemplatesByDraftGameTemplatesCountQueryVariables = {
  type: string,
  gameTemplatesCount?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDraftQuestionTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DraftQuestionTemplatesByDraftGameTemplatesCountQuery = {
  draftQuestionTemplatesByDraftGameTemplatesCount?:  {
    __typename: "ModelDraftQuestionTemplateConnection",
    items:  Array< {
      __typename: "DraftQuestionTemplate",
      id?: string | null,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetGameSessionQueryVariables = {
  id: string,
};

export type GetGameSessionQuery = {
  getGameSession?:  {
    __typename: "GameSession",
    id: string,
    classroomId?: string | null,
    gameId: string,
    startTime?: string | null,
    phaseOneTime: number,
    phaseTwoTime: number,
    teams?:  {
      __typename: "ModelTeamConnection",
      items:  Array< {
        __typename: "Team",
        id: string,
        globalStudentId?: string | null,
        name: string,
        question?:  {
          __typename: "Question",
          id: string,
          text: string,
          choices?: string | null,
          answerSettings?: string | null,
          answerData?: string | null,
          hints?: string | null,
          imageUrl?: string | null,
          instructions?: string | null,
          standard?: string | null,
          cluster?: string | null,
          domain?: string | null,
          grade?: string | null,
          order: number,
          isConfidenceEnabled: boolean,
          isShortAnswerEnabled: boolean,
          isHintEnabled: boolean,
          gameSessionId: string,
        } | null,
        teamMembers?:  {
          __typename: "ModelTeamMemberConnection",
          items:  Array< {
            __typename: "TeamMember",
            id: string,
            isFacilitator?: boolean | null,
            answers?:  {
              __typename: "ModelTeamAnswerConnection",
              items:  Array< {
                __typename: "TeamAnswer",
                id: string,
                isCorrect?: boolean | null,
                isSubmitted: boolean,
                isShortAnswerEnabled: boolean,
                currentState: GameSessionState,
                currentQuestionIndex: number,
                questionId: string,
                teamMemberAnswersId: string,
                teamAnswersId: string,
                teamName?: string | null,
                text: string,
                answer: string,
                confidenceLevel?: ConfidenceLevel | null,
                hint?: string | null,
                createdAt: string,
                updatedAt: string,
              } | null >,
              nextToken?: string | null,
            } | null,
            deviceId: string,
            createdAt: string,
            updatedAt: string,
            teamTeamMembersId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        score: number,
        selectedAvatarIndex: number,
        createdAt: string,
        updatedAt: string,
        gameSessionTeamsId?: string | null,
        teamQuestionId?: string | null,
        teamQuestionOrder?: number | null,
        teamQuestionGameSessionId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    currentQuestionIndex?: number | null,
    currentState: GameSessionState,
    gameCode: number,
    isAdvancedMode: boolean,
    imageUrl?: string | null,
    description?: string | null,
    title?: string | null,
    currentTimer?: number | null,
    studentID?: number | null,
    sessionData?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        text: string,
        choices?: string | null,
        answerSettings?: string | null,
        answerData?: string | null,
        hints?: string | null,
        imageUrl?: string | null,
        instructions?: string | null,
        standard?: string | null,
        cluster?: string | null,
        domain?: string | null,
        grade?: string | null,
        order: number,
        isConfidenceEnabled: boolean,
        isShortAnswerEnabled: boolean,
        isHintEnabled: boolean,
        gameSessionId: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListGameSessionsQueryVariables = {
  filter?: ModelGameSessionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListGameSessionsQuery = {
  listGameSessions?:  {
    __typename: "ModelGameSessionConnection",
    items:  Array< {
      __typename: "GameSession",
      id: string,
      classroomId?: string | null,
      gameId: string,
      startTime?: string | null,
      phaseOneTime: number,
      phaseTwoTime: number,
      teams?:  {
        __typename: "ModelTeamConnection",
        items:  Array< {
          __typename: "Team",
          id: string,
          globalStudentId?: string | null,
          name: string,
          question?:  {
            __typename: "Question",
            id: string,
            text: string,
            choices?: string | null,
            answerSettings?: string | null,
            answerData?: string | null,
            hints?: string | null,
            imageUrl?: string | null,
            instructions?: string | null,
            standard?: string | null,
            cluster?: string | null,
            domain?: string | null,
            grade?: string | null,
            order: number,
            isConfidenceEnabled: boolean,
            isShortAnswerEnabled: boolean,
            isHintEnabled: boolean,
            gameSessionId: string,
          } | null,
          teamMembers?:  {
            __typename: "ModelTeamMemberConnection",
            items:  Array< {
              __typename: "TeamMember",
              id: string,
              isFacilitator?: boolean | null,
              answers?:  {
                __typename: "ModelTeamAnswerConnection",
                items:  Array< {
                  __typename: "TeamAnswer",
                  id: string,
                  isCorrect?: boolean | null,
                  isSubmitted: boolean,
                  isShortAnswerEnabled: boolean,
                  currentState: GameSessionState,
                  currentQuestionIndex: number,
                  questionId: string,
                  teamMemberAnswersId: string,
                  teamAnswersId: string,
                  teamName?: string | null,
                  text: string,
                  answer: string,
                  confidenceLevel?: ConfidenceLevel | null,
                  hint?: string | null,
                  createdAt: string,
                  updatedAt: string,
                } | null >,
                nextToken?: string | null,
              } | null,
              deviceId: string,
              createdAt: string,
              updatedAt: string,
              teamTeamMembersId?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          score: number,
          selectedAvatarIndex: number,
          createdAt: string,
          updatedAt: string,
          gameSessionTeamsId?: string | null,
          teamQuestionId?: string | null,
          teamQuestionOrder?: number | null,
          teamQuestionGameSessionId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      currentQuestionIndex?: number | null,
      currentState: GameSessionState,
      gameCode: number,
      isAdvancedMode: boolean,
      imageUrl?: string | null,
      description?: string | null,
      title?: string | null,
      currentTimer?: number | null,
      studentID?: number | null,
      sessionData?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        items:  Array< {
          __typename: "Question",
          id: string,
          text: string,
          choices?: string | null,
          answerSettings?: string | null,
          answerData?: string | null,
          hints?: string | null,
          imageUrl?: string | null,
          instructions?: string | null,
          standard?: string | null,
          cluster?: string | null,
          domain?: string | null,
          grade?: string | null,
          order: number,
          isConfidenceEnabled: boolean,
          isShortAnswerEnabled: boolean,
          isHintEnabled: boolean,
          gameSessionId: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GameSessionByClassroomIdQueryVariables = {
  classroomId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelGameSessionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GameSessionByClassroomIdQuery = {
  gameSessionByClassroomId?:  {
    __typename: "ModelGameSessionConnection",
    items:  Array< {
      __typename: "GameSession",
      id: string,
      classroomId?: string | null,
      gameId: string,
      startTime?: string | null,
      phaseOneTime: number,
      phaseTwoTime: number,
      teams?:  {
        __typename: "ModelTeamConnection",
        items:  Array< {
          __typename: "Team",
          id: string,
          globalStudentId?: string | null,
          name: string,
          question?:  {
            __typename: "Question",
            id: string,
            text: string,
            choices?: string | null,
            answerSettings?: string | null,
            answerData?: string | null,
            hints?: string | null,
            imageUrl?: string | null,
            instructions?: string | null,
            standard?: string | null,
            cluster?: string | null,
            domain?: string | null,
            grade?: string | null,
            order: number,
            isConfidenceEnabled: boolean,
            isShortAnswerEnabled: boolean,
            isHintEnabled: boolean,
            gameSessionId: string,
          } | null,
          teamMembers?:  {
            __typename: "ModelTeamMemberConnection",
            items:  Array< {
              __typename: "TeamMember",
              id: string,
              isFacilitator?: boolean | null,
              answers?:  {
                __typename: "ModelTeamAnswerConnection",
                items:  Array< {
                  __typename: "TeamAnswer",
                  id: string,
                  isCorrect?: boolean | null,
                  isSubmitted: boolean,
                  isShortAnswerEnabled: boolean,
                  currentState: GameSessionState,
                  currentQuestionIndex: number,
                  questionId: string,
                  teamMemberAnswersId: string,
                  teamAnswersId: string,
                  teamName?: string | null,
                  text: string,
                  answer: string,
                  confidenceLevel?: ConfidenceLevel | null,
                  hint?: string | null,
                  createdAt: string,
                  updatedAt: string,
                } | null >,
                nextToken?: string | null,
              } | null,
              deviceId: string,
              createdAt: string,
              updatedAt: string,
              teamTeamMembersId?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          score: number,
          selectedAvatarIndex: number,
          createdAt: string,
          updatedAt: string,
          gameSessionTeamsId?: string | null,
          teamQuestionId?: string | null,
          teamQuestionOrder?: number | null,
          teamQuestionGameSessionId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      currentQuestionIndex?: number | null,
      currentState: GameSessionState,
      gameCode: number,
      isAdvancedMode: boolean,
      imageUrl?: string | null,
      description?: string | null,
      title?: string | null,
      currentTimer?: number | null,
      studentID?: number | null,
      sessionData?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        items:  Array< {
          __typename: "Question",
          id: string,
          text: string,
          choices?: string | null,
          answerSettings?: string | null,
          answerData?: string | null,
          hints?: string | null,
          imageUrl?: string | null,
          instructions?: string | null,
          standard?: string | null,
          cluster?: string | null,
          domain?: string | null,
          grade?: string | null,
          order: number,
          isConfidenceEnabled: boolean,
          isShortAnswerEnabled: boolean,
          isHintEnabled: boolean,
          gameSessionId: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GameSessionByStateQueryVariables = {
  currentState: GameSessionState,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelGameSessionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GameSessionByStateQuery = {
  gameSessionByState?:  {
    __typename: "ModelGameSessionConnection",
    items:  Array< {
      __typename: "GameSession",
      id: string,
      classroomId?: string | null,
      gameId: string,
      startTime?: string | null,
      phaseOneTime: number,
      phaseTwoTime: number,
      teams?:  {
        __typename: "ModelTeamConnection",
        items:  Array< {
          __typename: "Team",
          id: string,
          globalStudentId?: string | null,
          name: string,
          question?:  {
            __typename: "Question",
            id: string,
            text: string,
            choices?: string | null,
            answerSettings?: string | null,
            answerData?: string | null,
            hints?: string | null,
            imageUrl?: string | null,
            instructions?: string | null,
            standard?: string | null,
            cluster?: string | null,
            domain?: string | null,
            grade?: string | null,
            order: number,
            isConfidenceEnabled: boolean,
            isShortAnswerEnabled: boolean,
            isHintEnabled: boolean,
            gameSessionId: string,
          } | null,
          teamMembers?:  {
            __typename: "ModelTeamMemberConnection",
            items:  Array< {
              __typename: "TeamMember",
              id: string,
              isFacilitator?: boolean | null,
              answers?:  {
                __typename: "ModelTeamAnswerConnection",
                items:  Array< {
                  __typename: "TeamAnswer",
                  id: string,
                  isCorrect?: boolean | null,
                  isSubmitted: boolean,
                  isShortAnswerEnabled: boolean,
                  currentState: GameSessionState,
                  currentQuestionIndex: number,
                  questionId: string,
                  teamMemberAnswersId: string,
                  teamAnswersId: string,
                  teamName?: string | null,
                  text: string,
                  answer: string,
                  confidenceLevel?: ConfidenceLevel | null,
                  hint?: string | null,
                  createdAt: string,
                  updatedAt: string,
                } | null >,
                nextToken?: string | null,
              } | null,
              deviceId: string,
              createdAt: string,
              updatedAt: string,
              teamTeamMembersId?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          score: number,
          selectedAvatarIndex: number,
          createdAt: string,
          updatedAt: string,
          gameSessionTeamsId?: string | null,
          teamQuestionId?: string | null,
          teamQuestionOrder?: number | null,
          teamQuestionGameSessionId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      currentQuestionIndex?: number | null,
      currentState: GameSessionState,
      gameCode: number,
      isAdvancedMode: boolean,
      imageUrl?: string | null,
      description?: string | null,
      title?: string | null,
      currentTimer?: number | null,
      studentID?: number | null,
      sessionData?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        items:  Array< {
          __typename: "Question",
          id: string,
          text: string,
          choices?: string | null,
          answerSettings?: string | null,
          answerData?: string | null,
          hints?: string | null,
          imageUrl?: string | null,
          instructions?: string | null,
          standard?: string | null,
          cluster?: string | null,
          domain?: string | null,
          grade?: string | null,
          order: number,
          isConfidenceEnabled: boolean,
          isShortAnswerEnabled: boolean,
          isHintEnabled: boolean,
          gameSessionId: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GameSessionByCodeQueryVariables = {
  gameCode: number,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelGameSessionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GameSessionByCodeQuery = {
  gameSessionByCode?:  {
    __typename: "ModelGameSessionConnection",
    items:  Array< {
      __typename: "GameSession",
      id: string,
      classroomId?: string | null,
      gameId: string,
      startTime?: string | null,
      phaseOneTime: number,
      phaseTwoTime: number,
      teams?:  {
        __typename: "ModelTeamConnection",
        items:  Array< {
          __typename: "Team",
          id: string,
          globalStudentId?: string | null,
          name: string,
          question?:  {
            __typename: "Question",
            id: string,
            text: string,
            choices?: string | null,
            answerSettings?: string | null,
            answerData?: string | null,
            hints?: string | null,
            imageUrl?: string | null,
            instructions?: string | null,
            standard?: string | null,
            cluster?: string | null,
            domain?: string | null,
            grade?: string | null,
            order: number,
            isConfidenceEnabled: boolean,
            isShortAnswerEnabled: boolean,
            isHintEnabled: boolean,
            gameSessionId: string,
          } | null,
          teamMembers?:  {
            __typename: "ModelTeamMemberConnection",
            items:  Array< {
              __typename: "TeamMember",
              id: string,
              isFacilitator?: boolean | null,
              answers?:  {
                __typename: "ModelTeamAnswerConnection",
                items:  Array< {
                  __typename: "TeamAnswer",
                  id: string,
                  isCorrect?: boolean | null,
                  isSubmitted: boolean,
                  isShortAnswerEnabled: boolean,
                  currentState: GameSessionState,
                  currentQuestionIndex: number,
                  questionId: string,
                  teamMemberAnswersId: string,
                  teamAnswersId: string,
                  teamName?: string | null,
                  text: string,
                  answer: string,
                  confidenceLevel?: ConfidenceLevel | null,
                  hint?: string | null,
                  createdAt: string,
                  updatedAt: string,
                } | null >,
                nextToken?: string | null,
              } | null,
              deviceId: string,
              createdAt: string,
              updatedAt: string,
              teamTeamMembersId?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          score: number,
          selectedAvatarIndex: number,
          createdAt: string,
          updatedAt: string,
          gameSessionTeamsId?: string | null,
          teamQuestionId?: string | null,
          teamQuestionOrder?: number | null,
          teamQuestionGameSessionId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      currentQuestionIndex?: number | null,
      currentState: GameSessionState,
      gameCode: number,
      isAdvancedMode: boolean,
      imageUrl?: string | null,
      description?: string | null,
      title?: string | null,
      currentTimer?: number | null,
      studentID?: number | null,
      sessionData?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        items:  Array< {
          __typename: "Question",
          id: string,
          text: string,
          choices?: string | null,
          answerSettings?: string | null,
          answerData?: string | null,
          hints?: string | null,
          imageUrl?: string | null,
          instructions?: string | null,
          standard?: string | null,
          cluster?: string | null,
          domain?: string | null,
          grade?: string | null,
          order: number,
          isConfidenceEnabled: boolean,
          isShortAnswerEnabled: boolean,
          isHintEnabled: boolean,
          gameSessionId: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetQuestionQueryVariables = {
  id: string,
  order: number,
  gameSessionId: string,
};

export type GetQuestionQuery = {
  getQuestion?:  {
    __typename: "Question",
    id: string,
    text: string,
    choices?: string | null,
    answerSettings?: string | null,
    answerData?: string | null,
    hints?: string | null,
    imageUrl?: string | null,
    instructions?: string | null,
    standard?: string | null,
    cluster?: string | null,
    domain?: string | null,
    grade?: string | null,
    order: number,
    isConfidenceEnabled: boolean,
    isShortAnswerEnabled: boolean,
    isHintEnabled: boolean,
    gameSessionId: string,
  } | null,
};

export type ListQuestionsQueryVariables = {
  id?: string | null,
  orderGameSessionId?: ModelQuestionPrimaryCompositeKeyConditionInput | null,
  filter?: ModelQuestionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListQuestionsQuery = {
  listQuestions?:  {
    __typename: "ModelQuestionConnection",
    items:  Array< {
      __typename: "Question",
      id: string,
      text: string,
      choices?: string | null,
      answerSettings?: string | null,
      answerData?: string | null,
      hints?: string | null,
      imageUrl?: string | null,
      instructions?: string | null,
      standard?: string | null,
      cluster?: string | null,
      domain?: string | null,
      grade?: string | null,
      order: number,
      isConfidenceEnabled: boolean,
      isShortAnswerEnabled: boolean,
      isHintEnabled: boolean,
      gameSessionId: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTeamQueryVariables = {
  id: string,
};

export type GetTeamQuery = {
  getTeam?:  {
    __typename: "Team",
    id: string,
    globalStudentId?: string | null,
    name: string,
    question?:  {
      __typename: "Question",
      id: string,
      text: string,
      choices?: string | null,
      answerSettings?: string | null,
      answerData?: string | null,
      hints?: string | null,
      imageUrl?: string | null,
      instructions?: string | null,
      standard?: string | null,
      cluster?: string | null,
      domain?: string | null,
      grade?: string | null,
      order: number,
      isConfidenceEnabled: boolean,
      isShortAnswerEnabled: boolean,
      isHintEnabled: boolean,
      gameSessionId: string,
    } | null,
    teamMembers?:  {
      __typename: "ModelTeamMemberConnection",
      items:  Array< {
        __typename: "TeamMember",
        id: string,
        isFacilitator?: boolean | null,
        answers?:  {
          __typename: "ModelTeamAnswerConnection",
          items:  Array< {
            __typename: "TeamAnswer",
            id: string,
            isCorrect?: boolean | null,
            isSubmitted: boolean,
            isShortAnswerEnabled: boolean,
            currentState: GameSessionState,
            currentQuestionIndex: number,
            questionId: string,
            teamMemberAnswersId: string,
            teamAnswersId: string,
            teamName?: string | null,
            text: string,
            answer: string,
            confidenceLevel?: ConfidenceLevel | null,
            hint?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        deviceId: string,
        createdAt: string,
        updatedAt: string,
        teamTeamMembersId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    score: number,
    selectedAvatarIndex: number,
    createdAt: string,
    updatedAt: string,
    gameSessionTeamsId?: string | null,
    teamQuestionId?: string | null,
    teamQuestionOrder?: number | null,
    teamQuestionGameSessionId?: string | null,
  } | null,
};

export type ListTeamsQueryVariables = {
  filter?: ModelTeamFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTeamsQuery = {
  listTeams?:  {
    __typename: "ModelTeamConnection",
    items:  Array< {
      __typename: "Team",
      id: string,
      globalStudentId?: string | null,
      name: string,
      question?:  {
        __typename: "Question",
        id: string,
        text: string,
        choices?: string | null,
        answerSettings?: string | null,
        answerData?: string | null,
        hints?: string | null,
        imageUrl?: string | null,
        instructions?: string | null,
        standard?: string | null,
        cluster?: string | null,
        domain?: string | null,
        grade?: string | null,
        order: number,
        isConfidenceEnabled: boolean,
        isShortAnswerEnabled: boolean,
        isHintEnabled: boolean,
        gameSessionId: string,
      } | null,
      teamMembers?:  {
        __typename: "ModelTeamMemberConnection",
        items:  Array< {
          __typename: "TeamMember",
          id: string,
          isFacilitator?: boolean | null,
          answers?:  {
            __typename: "ModelTeamAnswerConnection",
            items:  Array< {
              __typename: "TeamAnswer",
              id: string,
              isCorrect?: boolean | null,
              isSubmitted: boolean,
              isShortAnswerEnabled: boolean,
              currentState: GameSessionState,
              currentQuestionIndex: number,
              questionId: string,
              teamMemberAnswersId: string,
              teamAnswersId: string,
              teamName?: string | null,
              text: string,
              answer: string,
              confidenceLevel?: ConfidenceLevel | null,
              hint?: string | null,
              createdAt: string,
              updatedAt: string,
            } | null >,
            nextToken?: string | null,
          } | null,
          deviceId: string,
          createdAt: string,
          updatedAt: string,
          teamTeamMembersId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      score: number,
      selectedAvatarIndex: number,
      createdAt: string,
      updatedAt: string,
      gameSessionTeamsId?: string | null,
      teamQuestionId?: string | null,
      teamQuestionOrder?: number | null,
      teamQuestionGameSessionId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TeamByGlobalStudentIdQueryVariables = {
  globalStudentId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTeamFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TeamByGlobalStudentIdQuery = {
  teamByGlobalStudentId?:  {
    __typename: "ModelTeamConnection",
    items:  Array< {
      __typename: "Team",
      id: string,
      globalStudentId?: string | null,
      name: string,
      question?:  {
        __typename: "Question",
        id: string,
        text: string,
        choices?: string | null,
        answerSettings?: string | null,
        answerData?: string | null,
        hints?: string | null,
        imageUrl?: string | null,
        instructions?: string | null,
        standard?: string | null,
        cluster?: string | null,
        domain?: string | null,
        grade?: string | null,
        order: number,
        isConfidenceEnabled: boolean,
        isShortAnswerEnabled: boolean,
        isHintEnabled: boolean,
        gameSessionId: string,
      } | null,
      teamMembers?:  {
        __typename: "ModelTeamMemberConnection",
        items:  Array< {
          __typename: "TeamMember",
          id: string,
          isFacilitator?: boolean | null,
          answers?:  {
            __typename: "ModelTeamAnswerConnection",
            items:  Array< {
              __typename: "TeamAnswer",
              id: string,
              isCorrect?: boolean | null,
              isSubmitted: boolean,
              isShortAnswerEnabled: boolean,
              currentState: GameSessionState,
              currentQuestionIndex: number,
              questionId: string,
              teamMemberAnswersId: string,
              teamAnswersId: string,
              teamName?: string | null,
              text: string,
              answer: string,
              confidenceLevel?: ConfidenceLevel | null,
              hint?: string | null,
              createdAt: string,
              updatedAt: string,
            } | null >,
            nextToken?: string | null,
          } | null,
          deviceId: string,
          createdAt: string,
          updatedAt: string,
          teamTeamMembersId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      score: number,
      selectedAvatarIndex: number,
      createdAt: string,
      updatedAt: string,
      gameSessionTeamsId?: string | null,
      teamQuestionId?: string | null,
      teamQuestionOrder?: number | null,
      teamQuestionGameSessionId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTeamMemberQueryVariables = {
  id: string,
};

export type GetTeamMemberQuery = {
  getTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    isFacilitator?: boolean | null,
    answers?:  {
      __typename: "ModelTeamAnswerConnection",
      items:  Array< {
        __typename: "TeamAnswer",
        id: string,
        isCorrect?: boolean | null,
        isSubmitted: boolean,
        isShortAnswerEnabled: boolean,
        currentState: GameSessionState,
        currentQuestionIndex: number,
        questionId: string,
        teamMemberAnswersId: string,
        teamAnswersId: string,
        teamName?: string | null,
        text: string,
        answer: string,
        confidenceLevel?: ConfidenceLevel | null,
        hint?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deviceId: string,
    createdAt: string,
    updatedAt: string,
    teamTeamMembersId?: string | null,
  } | null,
};

export type ListTeamMembersQueryVariables = {
  filter?: ModelTeamMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTeamMembersQuery = {
  listTeamMembers?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      isFacilitator?: boolean | null,
      answers?:  {
        __typename: "ModelTeamAnswerConnection",
        items:  Array< {
          __typename: "TeamAnswer",
          id: string,
          isCorrect?: boolean | null,
          isSubmitted: boolean,
          isShortAnswerEnabled: boolean,
          currentState: GameSessionState,
          currentQuestionIndex: number,
          questionId: string,
          teamMemberAnswersId: string,
          teamAnswersId: string,
          teamName?: string | null,
          text: string,
          answer: string,
          confidenceLevel?: ConfidenceLevel | null,
          hint?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deviceId: string,
      createdAt: string,
      updatedAt: string,
      teamTeamMembersId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTeamAnswerQueryVariables = {
  id: string,
};

export type GetTeamAnswerQuery = {
  getTeamAnswer?:  {
    __typename: "TeamAnswer",
    id: string,
    isCorrect?: boolean | null,
    isSubmitted: boolean,
    isShortAnswerEnabled: boolean,
    currentState: GameSessionState,
    currentQuestionIndex: number,
    questionId: string,
    teamMemberAnswersId: string,
    teamAnswersId: string,
    teamName?: string | null,
    text: string,
    answer: string,
    confidenceLevel?: ConfidenceLevel | null,
    hint?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTeamAnswersQueryVariables = {
  filter?: ModelTeamAnswerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTeamAnswersQuery = {
  listTeamAnswers?:  {
    __typename: "ModelTeamAnswerConnection",
    items:  Array< {
      __typename: "TeamAnswer",
      id: string,
      isCorrect?: boolean | null,
      isSubmitted: boolean,
      isShortAnswerEnabled: boolean,
      currentState: GameSessionState,
      currentQuestionIndex: number,
      questionId: string,
      teamMemberAnswersId: string,
      teamAnswersId: string,
      teamName?: string | null,
      text: string,
      answer: string,
      confidenceLevel?: ConfidenceLevel | null,
      hint?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPublicGameQuestionsQueryVariables = {
  id: string,
};

export type GetPublicGameQuestionsQuery = {
  getPublicGameQuestions?:  {
    __typename: "PublicGameQuestions",
    id: string,
    publicGameTemplateID: string,
    publicQuestionTemplateID: string,
    publicGameTemplate:  {
      __typename: "PublicGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      featuredGroup?: string | null,
      featuredOrder?: number | null,
      type?: string | null,
      owner?: string | null,
    },
    publicQuestionTemplate:  {
      __typename: "PublicQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListPublicGameQuestionsQueryVariables = {
  filter?: ModelPublicGameQuestionsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPublicGameQuestionsQuery = {
  listPublicGameQuestions?:  {
    __typename: "ModelPublicGameQuestionsConnection",
    items:  Array< {
      __typename: "PublicGameQuestions",
      id: string,
      publicGameTemplateID: string,
      publicQuestionTemplateID: string,
      publicGameTemplate:  {
        __typename: "PublicGameTemplate",
        id: string,
        userId?: string | null,
        publicPrivateType?: string | null,
        title: string,
        lowerCaseTitle: string,
        version: number,
        description: string,
        lowerCaseDescription: string,
        ccss?: string | null,
        ccssDescription?: string | null,
        domain?: string | null,
        cluster?: string | null,
        grade?: string | null,
        gradeFilter?: string | null,
        standard?: string | null,
        phaseOneTime?: number | null,
        phaseTwoTime?: number | null,
        imageUrl?: string | null,
        timesPlayed?: number | null,
        questionTemplates?:  {
          __typename: "ModelPublicGameQuestionsConnection",
          items:  Array< {
            __typename: "PublicGameQuestions",
            id: string,
            publicGameTemplateID: string,
            publicQuestionTemplateID: string,
            publicGameTemplate:  {
              __typename: "PublicGameTemplate",
              id: string,
              userId?: string | null,
              publicPrivateType?: string | null,
              title: string,
              lowerCaseTitle: string,
              version: number,
              description: string,
              lowerCaseDescription: string,
              ccss?: string | null,
              ccssDescription?: string | null,
              domain?: string | null,
              cluster?: string | null,
              grade?: string | null,
              gradeFilter?: string | null,
              standard?: string | null,
              phaseOneTime?: number | null,
              phaseTwoTime?: number | null,
              imageUrl?: string | null,
              timesPlayed?: number | null,
              questionTemplates?:  {
                __typename: "ModelPublicGameQuestionsConnection",
                items:  Array< {
                  __typename: "PublicGameQuestions",
                  id: string,
                  publicGameTemplateID: string,
                  publicQuestionTemplateID: string,
                  createdAt: string,
                  updatedAt: string,
                  owner?: string | null,
                } | null >,
                nextToken?: string | null,
              } | null,
              questionTemplatesCount: number,
              questionTemplatesOrder?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              featuredGroup?: string | null,
              featuredOrder?: number | null,
              type?: string | null,
              owner?: string | null,
            },
            publicQuestionTemplate:  {
              __typename: "PublicQuestionTemplate",
              id: string,
              userId?: string | null,
              publicPrivateType?: string | null,
              title: string,
              lowerCaseTitle: string,
              version: number,
              choices?: string | null,
              instructions?: string | null,
              answerSettings?: string | null,
              ccss?: string | null,
              ccssDescription?: string | null,
              domain?: string | null,
              cluster?: string | null,
              grade?: string | null,
              gradeFilter?: string | null,
              standard?: string | null,
              imageUrl?: string | null,
              timesPlayed?: number | null,
              gameTemplates?:  {
                __typename: "ModelPublicGameQuestionsConnection",
                items:  Array< {
                  __typename: "PublicGameQuestions",
                  id: string,
                  publicGameTemplateID: string,
                  publicQuestionTemplateID: string,
                  createdAt: string,
                  updatedAt: string,
                  owner?: string | null,
                } | null >,
                nextToken?: string | null,
              } | null,
              gameTemplatesCount: number,
              createdAt?: string | null,
              updatedAt?: string | null,
              type?: string | null,
              owner?: string | null,
            },
            createdAt: string,
            updatedAt: string,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        questionTemplatesCount: number,
        questionTemplatesOrder?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        featuredGroup?: string | null,
        featuredOrder?: number | null,
        type?: string | null,
        owner?: string | null,
      },
      publicQuestionTemplate:  {
        __typename: "PublicQuestionTemplate",
        id: string,
        userId?: string | null,
        publicPrivateType?: string | null,
        title: string,
        lowerCaseTitle: string,
        version: number,
        choices?: string | null,
        instructions?: string | null,
        answerSettings?: string | null,
        ccss?: string | null,
        ccssDescription?: string | null,
        domain?: string | null,
        cluster?: string | null,
        grade?: string | null,
        gradeFilter?: string | null,
        standard?: string | null,
        imageUrl?: string | null,
        timesPlayed?: number | null,
        gameTemplates?:  {
          __typename: "ModelPublicGameQuestionsConnection",
          items:  Array< {
            __typename: "PublicGameQuestions",
            id: string,
            publicGameTemplateID: string,
            publicQuestionTemplateID: string,
            publicGameTemplate:  {
              __typename: "PublicGameTemplate",
              id: string,
              userId?: string | null,
              publicPrivateType?: string | null,
              title: string,
              lowerCaseTitle: string,
              version: number,
              description: string,
              lowerCaseDescription: string,
              ccss?: string | null,
              ccssDescription?: string | null,
              domain?: string | null,
              cluster?: string | null,
              grade?: string | null,
              gradeFilter?: string | null,
              standard?: string | null,
              phaseOneTime?: number | null,
              phaseTwoTime?: number | null,
              imageUrl?: string | null,
              timesPlayed?: number | null,
              questionTemplates?:  {
                __typename: "ModelPublicGameQuestionsConnection",
                items:  Array< {
                  __typename: "PublicGameQuestions",
                  id: string,
                  publicGameTemplateID: string,
                  publicQuestionTemplateID: string,
                  createdAt: string,
                  updatedAt: string,
                  owner?: string | null,
                } | null >,
                nextToken?: string | null,
              } | null,
              questionTemplatesCount: number,
              questionTemplatesOrder?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              featuredGroup?: string | null,
              featuredOrder?: number | null,
              type?: string | null,
              owner?: string | null,
            },
            publicQuestionTemplate:  {
              __typename: "PublicQuestionTemplate",
              id: string,
              userId?: string | null,
              publicPrivateType?: string | null,
              title: string,
              lowerCaseTitle: string,
              version: number,
              choices?: string | null,
              instructions?: string | null,
              answerSettings?: string | null,
              ccss?: string | null,
              ccssDescription?: string | null,
              domain?: string | null,
              cluster?: string | null,
              grade?: string | null,
              gradeFilter?: string | null,
              standard?: string | null,
              imageUrl?: string | null,
              timesPlayed?: number | null,
              gameTemplates?:  {
                __typename: "ModelPublicGameQuestionsConnection",
                items:  Array< {
                  __typename: "PublicGameQuestions",
                  id: string,
                  publicGameTemplateID: string,
                  publicQuestionTemplateID: string,
                  createdAt: string,
                  updatedAt: string,
                  owner?: string | null,
                } | null >,
                nextToken?: string | null,
              } | null,
              gameTemplatesCount: number,
              createdAt?: string | null,
              updatedAt?: string | null,
              type?: string | null,
              owner?: string | null,
            },
            createdAt: string,
            updatedAt: string,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gameTemplatesCount: number,
        createdAt?: string | null,
        updatedAt?: string | null,
        type?: string | null,
        owner?: string | null,
      },
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPrivateGameQuestionsQueryVariables = {
  id: string,
};

export type GetPrivateGameQuestionsQuery = {
  getPrivateGameQuestions?:  {
    __typename: "PrivateGameQuestions",
    id: string,
    privateGameTemplateID: string,
    privateQuestionTemplateID: string,
    privateGameTemplate:  {
      __typename: "PrivateGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    privateQuestionTemplate:  {
      __typename: "PrivateQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListPrivateGameQuestionsQueryVariables = {
  filter?: ModelPrivateGameQuestionsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPrivateGameQuestionsQuery = {
  listPrivateGameQuestions?:  {
    __typename: "ModelPrivateGameQuestionsConnection",
    items:  Array< {
      __typename: "PrivateGameQuestions",
      id: string,
      privateGameTemplateID: string,
      privateQuestionTemplateID: string,
      privateGameTemplate:  {
        __typename: "PrivateGameTemplate",
        id: string,
        userId?: string | null,
        publicPrivateType?: string | null,
        title: string,
        lowerCaseTitle: string,
        version: number,
        description: string,
        lowerCaseDescription: string,
        ccss?: string | null,
        ccssDescription?: string | null,
        domain?: string | null,
        cluster?: string | null,
        grade?: string | null,
        gradeFilter?: string | null,
        standard?: string | null,
        phaseOneTime?: number | null,
        phaseTwoTime?: number | null,
        imageUrl?: string | null,
        timesPlayed?: number | null,
        questionTemplates?:  {
          __typename: "ModelPrivateGameQuestionsConnection",
          items:  Array< {
            __typename: "PrivateGameQuestions",
            id: string,
            privateGameTemplateID: string,
            privateQuestionTemplateID: string,
            privateGameTemplate:  {
              __typename: "PrivateGameTemplate",
              id: string,
              userId?: string | null,
              publicPrivateType?: string | null,
              title: string,
              lowerCaseTitle: string,
              version: number,
              description: string,
              lowerCaseDescription: string,
              ccss?: string | null,
              ccssDescription?: string | null,
              domain?: string | null,
              cluster?: string | null,
              grade?: string | null,
              gradeFilter?: string | null,
              standard?: string | null,
              phaseOneTime?: number | null,
              phaseTwoTime?: number | null,
              imageUrl?: string | null,
              timesPlayed?: number | null,
              questionTemplates?:  {
                __typename: "ModelPrivateGameQuestionsConnection",
                items:  Array< {
                  __typename: "PrivateGameQuestions",
                  id: string,
                  privateGameTemplateID: string,
                  privateQuestionTemplateID: string,
                  createdAt: string,
                  updatedAt: string,
                  owner?: string | null,
                } | null >,
                nextToken?: string | null,
              } | null,
              questionTemplatesCount: number,
              questionTemplatesOrder?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              type?: string | null,
              owner?: string | null,
            },
            privateQuestionTemplate:  {
              __typename: "PrivateQuestionTemplate",
              id: string,
              userId?: string | null,
              publicPrivateType?: string | null,
              title: string,
              lowerCaseTitle: string,
              version: number,
              choices?: string | null,
              instructions?: string | null,
              answerSettings?: string | null,
              ccss?: string | null,
              ccssDescription?: string | null,
              domain?: string | null,
              cluster?: string | null,
              grade?: string | null,
              gradeFilter?: string | null,
              standard?: string | null,
              imageUrl?: string | null,
              timesPlayed?: number | null,
              gameTemplates?:  {
                __typename: "ModelPrivateGameQuestionsConnection",
                items:  Array< {
                  __typename: "PrivateGameQuestions",
                  id: string,
                  privateGameTemplateID: string,
                  privateQuestionTemplateID: string,
                  createdAt: string,
                  updatedAt: string,
                  owner?: string | null,
                } | null >,
                nextToken?: string | null,
              } | null,
              gameTemplatesCount: number,
              createdAt?: string | null,
              updatedAt?: string | null,
              type?: string | null,
              owner?: string | null,
            },
            createdAt: string,
            updatedAt: string,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        questionTemplatesCount: number,
        questionTemplatesOrder?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        type?: string | null,
        owner?: string | null,
      },
      privateQuestionTemplate:  {
        __typename: "PrivateQuestionTemplate",
        id: string,
        userId?: string | null,
        publicPrivateType?: string | null,
        title: string,
        lowerCaseTitle: string,
        version: number,
        choices?: string | null,
        instructions?: string | null,
        answerSettings?: string | null,
        ccss?: string | null,
        ccssDescription?: string | null,
        domain?: string | null,
        cluster?: string | null,
        grade?: string | null,
        gradeFilter?: string | null,
        standard?: string | null,
        imageUrl?: string | null,
        timesPlayed?: number | null,
        gameTemplates?:  {
          __typename: "ModelPrivateGameQuestionsConnection",
          items:  Array< {
            __typename: "PrivateGameQuestions",
            id: string,
            privateGameTemplateID: string,
            privateQuestionTemplateID: string,
            privateGameTemplate:  {
              __typename: "PrivateGameTemplate",
              id: string,
              userId?: string | null,
              publicPrivateType?: string | null,
              title: string,
              lowerCaseTitle: string,
              version: number,
              description: string,
              lowerCaseDescription: string,
              ccss?: string | null,
              ccssDescription?: string | null,
              domain?: string | null,
              cluster?: string | null,
              grade?: string | null,
              gradeFilter?: string | null,
              standard?: string | null,
              phaseOneTime?: number | null,
              phaseTwoTime?: number | null,
              imageUrl?: string | null,
              timesPlayed?: number | null,
              questionTemplates?:  {
                __typename: "ModelPrivateGameQuestionsConnection",
                items:  Array< {
                  __typename: "PrivateGameQuestions",
                  id: string,
                  privateGameTemplateID: string,
                  privateQuestionTemplateID: string,
                  createdAt: string,
                  updatedAt: string,
                  owner?: string | null,
                } | null >,
                nextToken?: string | null,
              } | null,
              questionTemplatesCount: number,
              questionTemplatesOrder?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              type?: string | null,
              owner?: string | null,
            },
            privateQuestionTemplate:  {
              __typename: "PrivateQuestionTemplate",
              id: string,
              userId?: string | null,
              publicPrivateType?: string | null,
              title: string,
              lowerCaseTitle: string,
              version: number,
              choices?: string | null,
              instructions?: string | null,
              answerSettings?: string | null,
              ccss?: string | null,
              ccssDescription?: string | null,
              domain?: string | null,
              cluster?: string | null,
              grade?: string | null,
              gradeFilter?: string | null,
              standard?: string | null,
              imageUrl?: string | null,
              timesPlayed?: number | null,
              gameTemplates?:  {
                __typename: "ModelPrivateGameQuestionsConnection",
                items:  Array< {
                  __typename: "PrivateGameQuestions",
                  id: string,
                  privateGameTemplateID: string,
                  privateQuestionTemplateID: string,
                  createdAt: string,
                  updatedAt: string,
                  owner?: string | null,
                } | null >,
                nextToken?: string | null,
              } | null,
              gameTemplatesCount: number,
              createdAt?: string | null,
              updatedAt?: string | null,
              type?: string | null,
              owner?: string | null,
            },
            createdAt: string,
            updatedAt: string,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gameTemplatesCount: number,
        createdAt?: string | null,
        updatedAt?: string | null,
        type?: string | null,
        owner?: string | null,
      },
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDraftGameQuestionsQueryVariables = {
  id: string,
};

export type GetDraftGameQuestionsQuery = {
  getDraftGameQuestions?:  {
    __typename: "DraftGameQuestions",
    id: string,
    draftGameTemplateID: string,
    draftQuestionTemplateID: string,
    draftGameTemplate:  {
      __typename: "DraftGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      description?: string | null,
      lowerCaseDescription?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    draftQuestionTemplate:  {
      __typename: "DraftQuestionTemplate",
      id?: string | null,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListDraftGameQuestionsQueryVariables = {
  filter?: ModelDraftGameQuestionsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDraftGameQuestionsQuery = {
  listDraftGameQuestions?:  {
    __typename: "ModelDraftGameQuestionsConnection",
    items:  Array< {
      __typename: "DraftGameQuestions",
      id: string,
      draftGameTemplateID: string,
      draftQuestionTemplateID: string,
      draftGameTemplate:  {
        __typename: "DraftGameTemplate",
        id: string,
        userId?: string | null,
        publicPrivateType?: string | null,
        title?: string | null,
        lowerCaseTitle?: string | null,
        version?: number | null,
        description?: string | null,
        lowerCaseDescription?: string | null,
        ccss?: string | null,
        ccssDescription?: string | null,
        domain?: string | null,
        cluster?: string | null,
        grade?: string | null,
        gradeFilter?: string | null,
        standard?: string | null,
        phaseOneTime?: number | null,
        phaseTwoTime?: number | null,
        imageUrl?: string | null,
        timesPlayed?: number | null,
        questionTemplates?:  {
          __typename: "ModelDraftGameQuestionsConnection",
          items:  Array< {
            __typename: "DraftGameQuestions",
            id: string,
            draftGameTemplateID: string,
            draftQuestionTemplateID: string,
            draftGameTemplate:  {
              __typename: "DraftGameTemplate",
              id: string,
              userId?: string | null,
              publicPrivateType?: string | null,
              title?: string | null,
              lowerCaseTitle?: string | null,
              version?: number | null,
              description?: string | null,
              lowerCaseDescription?: string | null,
              ccss?: string | null,
              ccssDescription?: string | null,
              domain?: string | null,
              cluster?: string | null,
              grade?: string | null,
              gradeFilter?: string | null,
              standard?: string | null,
              phaseOneTime?: number | null,
              phaseTwoTime?: number | null,
              imageUrl?: string | null,
              timesPlayed?: number | null,
              questionTemplates?:  {
                __typename: "ModelDraftGameQuestionsConnection",
                items:  Array< {
                  __typename: "DraftGameQuestions",
                  id: string,
                  draftGameTemplateID: string,
                  draftQuestionTemplateID: string,
                  createdAt: string,
                  updatedAt: string,
                  owner?: string | null,
                } | null >,
                nextToken?: string | null,
              } | null,
              questionTemplatesCount: number,
              questionTemplatesOrder?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              type?: string | null,
              owner?: string | null,
            },
            draftQuestionTemplate:  {
              __typename: "DraftQuestionTemplate",
              id?: string | null,
              userId?: string | null,
              publicPrivateType?: string | null,
              title?: string | null,
              lowerCaseTitle?: string | null,
              version?: number | null,
              choices?: string | null,
              instructions?: string | null,
              answerSettings?: string | null,
              ccss?: string | null,
              ccssDescription?: string | null,
              domain?: string | null,
              cluster?: string | null,
              grade?: string | null,
              gradeFilter?: string | null,
              standard?: string | null,
              imageUrl?: string | null,
              timesPlayed?: number | null,
              gameTemplates?:  {
                __typename: "ModelDraftGameQuestionsConnection",
                items:  Array< {
                  __typename: "DraftGameQuestions",
                  id: string,
                  draftGameTemplateID: string,
                  draftQuestionTemplateID: string,
                  createdAt: string,
                  updatedAt: string,
                  owner?: string | null,
                } | null >,
                nextToken?: string | null,
              } | null,
              gameTemplatesCount: number,
              createdAt?: string | null,
              updatedAt?: string | null,
              type?: string | null,
              owner?: string | null,
            },
            createdAt: string,
            updatedAt: string,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        questionTemplatesCount: number,
        questionTemplatesOrder?: string | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        type?: string | null,
        owner?: string | null,
      },
      draftQuestionTemplate:  {
        __typename: "DraftQuestionTemplate",
        id?: string | null,
        userId?: string | null,
        publicPrivateType?: string | null,
        title?: string | null,
        lowerCaseTitle?: string | null,
        version?: number | null,
        choices?: string | null,
        instructions?: string | null,
        answerSettings?: string | null,
        ccss?: string | null,
        ccssDescription?: string | null,
        domain?: string | null,
        cluster?: string | null,
        grade?: string | null,
        gradeFilter?: string | null,
        standard?: string | null,
        imageUrl?: string | null,
        timesPlayed?: number | null,
        gameTemplates?:  {
          __typename: "ModelDraftGameQuestionsConnection",
          items:  Array< {
            __typename: "DraftGameQuestions",
            id: string,
            draftGameTemplateID: string,
            draftQuestionTemplateID: string,
            draftGameTemplate:  {
              __typename: "DraftGameTemplate",
              id: string,
              userId?: string | null,
              publicPrivateType?: string | null,
              title?: string | null,
              lowerCaseTitle?: string | null,
              version?: number | null,
              description?: string | null,
              lowerCaseDescription?: string | null,
              ccss?: string | null,
              ccssDescription?: string | null,
              domain?: string | null,
              cluster?: string | null,
              grade?: string | null,
              gradeFilter?: string | null,
              standard?: string | null,
              phaseOneTime?: number | null,
              phaseTwoTime?: number | null,
              imageUrl?: string | null,
              timesPlayed?: number | null,
              questionTemplates?:  {
                __typename: "ModelDraftGameQuestionsConnection",
                items:  Array< {
                  __typename: "DraftGameQuestions",
                  id: string,
                  draftGameTemplateID: string,
                  draftQuestionTemplateID: string,
                  createdAt: string,
                  updatedAt: string,
                  owner?: string | null,
                } | null >,
                nextToken?: string | null,
              } | null,
              questionTemplatesCount: number,
              questionTemplatesOrder?: string | null,
              createdAt?: string | null,
              updatedAt?: string | null,
              type?: string | null,
              owner?: string | null,
            },
            draftQuestionTemplate:  {
              __typename: "DraftQuestionTemplate",
              id?: string | null,
              userId?: string | null,
              publicPrivateType?: string | null,
              title?: string | null,
              lowerCaseTitle?: string | null,
              version?: number | null,
              choices?: string | null,
              instructions?: string | null,
              answerSettings?: string | null,
              ccss?: string | null,
              ccssDescription?: string | null,
              domain?: string | null,
              cluster?: string | null,
              grade?: string | null,
              gradeFilter?: string | null,
              standard?: string | null,
              imageUrl?: string | null,
              timesPlayed?: number | null,
              gameTemplates?:  {
                __typename: "ModelDraftGameQuestionsConnection",
                items:  Array< {
                  __typename: "DraftGameQuestions",
                  id: string,
                  draftGameTemplateID: string,
                  draftQuestionTemplateID: string,
                  createdAt: string,
                  updatedAt: string,
                  owner?: string | null,
                } | null >,
                nextToken?: string | null,
              } | null,
              gameTemplatesCount: number,
              createdAt?: string | null,
              updatedAt?: string | null,
              type?: string | null,
              owner?: string | null,
            },
            createdAt: string,
            updatedAt: string,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        gameTemplatesCount: number,
        createdAt?: string | null,
        updatedAt?: string | null,
        type?: string | null,
        owner?: string | null,
      },
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  owner?: string | null,
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    id: string,
    userName: string,
    dynamoId?: string | null,
    cognitoId: string,
    title?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    email: string,
    password?: string | null,
    gamesMade?: number | null,
    gamesUsed?: number | null,
    questionsMade?: number | null,
    frontIdPath?: string | null,
    backIdPath?: string | null,
    profilePicPath?: string | null,
    favoriteGameTemplateIds?: string | null,
    favoriteQuestionTemplateIds?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  owner?: string | null,
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    id: string,
    userName: string,
    dynamoId?: string | null,
    cognitoId: string,
    title?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    email: string,
    password?: string | null,
    gamesMade?: number | null,
    gamesUsed?: number | null,
    questionsMade?: number | null,
    frontIdPath?: string | null,
    backIdPath?: string | null,
    profilePicPath?: string | null,
    favoriteGameTemplateIds?: string | null,
    favoriteQuestionTemplateIds?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  owner?: string | null,
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    id: string,
    userName: string,
    dynamoId?: string | null,
    cognitoId: string,
    title?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    email: string,
    password?: string | null,
    gamesMade?: number | null,
    gamesUsed?: number | null,
    questionsMade?: number | null,
    frontIdPath?: string | null,
    backIdPath?: string | null,
    profilePicPath?: string | null,
    favoriteGameTemplateIds?: string | null,
    favoriteQuestionTemplateIds?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreatePublicGameTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionPublicGameTemplateFilterInput | null,
  owner?: string | null,
};

export type OnCreatePublicGameTemplateSubscription = {
  onCreatePublicGameTemplate?:  {
    __typename: "PublicGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    description: string,
    lowerCaseDescription: string,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelPublicGameQuestionsConnection",
      items:  Array< {
        __typename: "PublicGameQuestions",
        id: string,
        publicGameTemplateID: string,
        publicQuestionTemplateID: string,
        publicGameTemplate:  {
          __typename: "PublicGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          featuredGroup?: string | null,
          featuredOrder?: number | null,
          type?: string | null,
          owner?: string | null,
        },
        publicQuestionTemplate:  {
          __typename: "PublicQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    featuredGroup?: string | null,
    featuredOrder?: number | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type OnUpdatePublicGameTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionPublicGameTemplateFilterInput | null,
  owner?: string | null,
};

export type OnUpdatePublicGameTemplateSubscription = {
  onUpdatePublicGameTemplate?:  {
    __typename: "PublicGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    description: string,
    lowerCaseDescription: string,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelPublicGameQuestionsConnection",
      items:  Array< {
        __typename: "PublicGameQuestions",
        id: string,
        publicGameTemplateID: string,
        publicQuestionTemplateID: string,
        publicGameTemplate:  {
          __typename: "PublicGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          featuredGroup?: string | null,
          featuredOrder?: number | null,
          type?: string | null,
          owner?: string | null,
        },
        publicQuestionTemplate:  {
          __typename: "PublicQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    featuredGroup?: string | null,
    featuredOrder?: number | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type OnDeletePublicGameTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionPublicGameTemplateFilterInput | null,
  owner?: string | null,
};

export type OnDeletePublicGameTemplateSubscription = {
  onDeletePublicGameTemplate?:  {
    __typename: "PublicGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    description: string,
    lowerCaseDescription: string,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelPublicGameQuestionsConnection",
      items:  Array< {
        __typename: "PublicGameQuestions",
        id: string,
        publicGameTemplateID: string,
        publicQuestionTemplateID: string,
        publicGameTemplate:  {
          __typename: "PublicGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          featuredGroup?: string | null,
          featuredOrder?: number | null,
          type?: string | null,
          owner?: string | null,
        },
        publicQuestionTemplate:  {
          __typename: "PublicQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    featuredGroup?: string | null,
    featuredOrder?: number | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type OnCreatePrivateGameTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionPrivateGameTemplateFilterInput | null,
  owner?: string | null,
};

export type OnCreatePrivateGameTemplateSubscription = {
  onCreatePrivateGameTemplate?:  {
    __typename: "PrivateGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    description: string,
    lowerCaseDescription: string,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelPrivateGameQuestionsConnection",
      items:  Array< {
        __typename: "PrivateGameQuestions",
        id: string,
        privateGameTemplateID: string,
        privateQuestionTemplateID: string,
        privateGameTemplate:  {
          __typename: "PrivateGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        privateQuestionTemplate:  {
          __typename: "PrivateQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type OnUpdatePrivateGameTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionPrivateGameTemplateFilterInput | null,
  owner?: string | null,
};

export type OnUpdatePrivateGameTemplateSubscription = {
  onUpdatePrivateGameTemplate?:  {
    __typename: "PrivateGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    description: string,
    lowerCaseDescription: string,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelPrivateGameQuestionsConnection",
      items:  Array< {
        __typename: "PrivateGameQuestions",
        id: string,
        privateGameTemplateID: string,
        privateQuestionTemplateID: string,
        privateGameTemplate:  {
          __typename: "PrivateGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        privateQuestionTemplate:  {
          __typename: "PrivateQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type OnDeletePrivateGameTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionPrivateGameTemplateFilterInput | null,
  owner?: string | null,
};

export type OnDeletePrivateGameTemplateSubscription = {
  onDeletePrivateGameTemplate?:  {
    __typename: "PrivateGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    description: string,
    lowerCaseDescription: string,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelPrivateGameQuestionsConnection",
      items:  Array< {
        __typename: "PrivateGameQuestions",
        id: string,
        privateGameTemplateID: string,
        privateQuestionTemplateID: string,
        privateGameTemplate:  {
          __typename: "PrivateGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        privateQuestionTemplate:  {
          __typename: "PrivateQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type OnCreateDraftGameTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionDraftGameTemplateFilterInput | null,
  owner?: string | null,
};

export type OnCreateDraftGameTemplateSubscription = {
  onCreateDraftGameTemplate?:  {
    __typename: "DraftGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title?: string | null,
    lowerCaseTitle?: string | null,
    version?: number | null,
    description?: string | null,
    lowerCaseDescription?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelDraftGameQuestionsConnection",
      items:  Array< {
        __typename: "DraftGameQuestions",
        id: string,
        draftGameTemplateID: string,
        draftQuestionTemplateID: string,
        draftGameTemplate:  {
          __typename: "DraftGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          description?: string | null,
          lowerCaseDescription?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        draftQuestionTemplate:  {
          __typename: "DraftQuestionTemplate",
          id?: string | null,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type OnUpdateDraftGameTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionDraftGameTemplateFilterInput | null,
  owner?: string | null,
};

export type OnUpdateDraftGameTemplateSubscription = {
  onUpdateDraftGameTemplate?:  {
    __typename: "DraftGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title?: string | null,
    lowerCaseTitle?: string | null,
    version?: number | null,
    description?: string | null,
    lowerCaseDescription?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelDraftGameQuestionsConnection",
      items:  Array< {
        __typename: "DraftGameQuestions",
        id: string,
        draftGameTemplateID: string,
        draftQuestionTemplateID: string,
        draftGameTemplate:  {
          __typename: "DraftGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          description?: string | null,
          lowerCaseDescription?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        draftQuestionTemplate:  {
          __typename: "DraftQuestionTemplate",
          id?: string | null,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type OnDeleteDraftGameTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionDraftGameTemplateFilterInput | null,
  owner?: string | null,
};

export type OnDeleteDraftGameTemplateSubscription = {
  onDeleteDraftGameTemplate?:  {
    __typename: "DraftGameTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title?: string | null,
    lowerCaseTitle?: string | null,
    version?: number | null,
    description?: string | null,
    lowerCaseDescription?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    phaseOneTime?: number | null,
    phaseTwoTime?: number | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    questionTemplates?:  {
      __typename: "ModelDraftGameQuestionsConnection",
      items:  Array< {
        __typename: "DraftGameQuestions",
        id: string,
        draftGameTemplateID: string,
        draftQuestionTemplateID: string,
        draftGameTemplate:  {
          __typename: "DraftGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          description?: string | null,
          lowerCaseDescription?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        draftQuestionTemplate:  {
          __typename: "DraftQuestionTemplate",
          id?: string | null,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    questionTemplatesCount: number,
    questionTemplatesOrder?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type OnCreatePublicQuestionTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionPublicQuestionTemplateFilterInput | null,
  owner?: string | null,
};

export type OnCreatePublicQuestionTemplateSubscription = {
  onCreatePublicQuestionTemplate?:  {
    __typename: "PublicQuestionTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelPublicGameQuestionsConnection",
      items:  Array< {
        __typename: "PublicGameQuestions",
        id: string,
        publicGameTemplateID: string,
        publicQuestionTemplateID: string,
        publicGameTemplate:  {
          __typename: "PublicGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          featuredGroup?: string | null,
          featuredOrder?: number | null,
          type?: string | null,
          owner?: string | null,
        },
        publicQuestionTemplate:  {
          __typename: "PublicQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type OnUpdatePublicQuestionTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionPublicQuestionTemplateFilterInput | null,
  owner?: string | null,
};

export type OnUpdatePublicQuestionTemplateSubscription = {
  onUpdatePublicQuestionTemplate?:  {
    __typename: "PublicQuestionTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelPublicGameQuestionsConnection",
      items:  Array< {
        __typename: "PublicGameQuestions",
        id: string,
        publicGameTemplateID: string,
        publicQuestionTemplateID: string,
        publicGameTemplate:  {
          __typename: "PublicGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          featuredGroup?: string | null,
          featuredOrder?: number | null,
          type?: string | null,
          owner?: string | null,
        },
        publicQuestionTemplate:  {
          __typename: "PublicQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type OnDeletePublicQuestionTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionPublicQuestionTemplateFilterInput | null,
  owner?: string | null,
};

export type OnDeletePublicQuestionTemplateSubscription = {
  onDeletePublicQuestionTemplate?:  {
    __typename: "PublicQuestionTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelPublicGameQuestionsConnection",
      items:  Array< {
        __typename: "PublicGameQuestions",
        id: string,
        publicGameTemplateID: string,
        publicQuestionTemplateID: string,
        publicGameTemplate:  {
          __typename: "PublicGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          featuredGroup?: string | null,
          featuredOrder?: number | null,
          type?: string | null,
          owner?: string | null,
        },
        publicQuestionTemplate:  {
          __typename: "PublicQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPublicGameQuestionsConnection",
            items:  Array< {
              __typename: "PublicGameQuestions",
              id: string,
              publicGameTemplateID: string,
              publicQuestionTemplateID: string,
              publicGameTemplate:  {
                __typename: "PublicGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                featuredGroup?: string | null,
                featuredOrder?: number | null,
                type?: string | null,
                owner?: string | null,
              },
              publicQuestionTemplate:  {
                __typename: "PublicQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPublicGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type OnCreatePrivateQuestionTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionPrivateQuestionTemplateFilterInput | null,
  owner?: string | null,
};

export type OnCreatePrivateQuestionTemplateSubscription = {
  onCreatePrivateQuestionTemplate?:  {
    __typename: "PrivateQuestionTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelPrivateGameQuestionsConnection",
      items:  Array< {
        __typename: "PrivateGameQuestions",
        id: string,
        privateGameTemplateID: string,
        privateQuestionTemplateID: string,
        privateGameTemplate:  {
          __typename: "PrivateGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        privateQuestionTemplate:  {
          __typename: "PrivateQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type OnUpdatePrivateQuestionTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionPrivateQuestionTemplateFilterInput | null,
  owner?: string | null,
};

export type OnUpdatePrivateQuestionTemplateSubscription = {
  onUpdatePrivateQuestionTemplate?:  {
    __typename: "PrivateQuestionTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelPrivateGameQuestionsConnection",
      items:  Array< {
        __typename: "PrivateGameQuestions",
        id: string,
        privateGameTemplateID: string,
        privateQuestionTemplateID: string,
        privateGameTemplate:  {
          __typename: "PrivateGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        privateQuestionTemplate:  {
          __typename: "PrivateQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type OnDeletePrivateQuestionTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionPrivateQuestionTemplateFilterInput | null,
  owner?: string | null,
};

export type OnDeletePrivateQuestionTemplateSubscription = {
  onDeletePrivateQuestionTemplate?:  {
    __typename: "PrivateQuestionTemplate",
    id: string,
    userId?: string | null,
    publicPrivateType?: string | null,
    title: string,
    lowerCaseTitle: string,
    version: number,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelPrivateGameQuestionsConnection",
      items:  Array< {
        __typename: "PrivateGameQuestions",
        id: string,
        privateGameTemplateID: string,
        privateQuestionTemplateID: string,
        privateGameTemplate:  {
          __typename: "PrivateGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          description: string,
          lowerCaseDescription: string,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        privateQuestionTemplate:  {
          __typename: "PrivateQuestionTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title: string,
          lowerCaseTitle: string,
          version: number,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelPrivateGameQuestionsConnection",
            items:  Array< {
              __typename: "PrivateGameQuestions",
              id: string,
              privateGameTemplateID: string,
              privateQuestionTemplateID: string,
              privateGameTemplate:  {
                __typename: "PrivateGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                description: string,
                lowerCaseDescription: string,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              privateQuestionTemplate:  {
                __typename: "PrivateQuestionTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title: string,
                lowerCaseTitle: string,
                version: number,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelPrivateGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type OnCreateDraftQuestionTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionDraftQuestionTemplateFilterInput | null,
  owner?: string | null,
};

export type OnCreateDraftQuestionTemplateSubscription = {
  onCreateDraftQuestionTemplate?:  {
    __typename: "DraftQuestionTemplate",
    id?: string | null,
    userId?: string | null,
    publicPrivateType?: string | null,
    title?: string | null,
    lowerCaseTitle?: string | null,
    version?: number | null,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelDraftGameQuestionsConnection",
      items:  Array< {
        __typename: "DraftGameQuestions",
        id: string,
        draftGameTemplateID: string,
        draftQuestionTemplateID: string,
        draftGameTemplate:  {
          __typename: "DraftGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          description?: string | null,
          lowerCaseDescription?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        draftQuestionTemplate:  {
          __typename: "DraftQuestionTemplate",
          id?: string | null,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type OnUpdateDraftQuestionTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionDraftQuestionTemplateFilterInput | null,
  owner?: string | null,
};

export type OnUpdateDraftQuestionTemplateSubscription = {
  onUpdateDraftQuestionTemplate?:  {
    __typename: "DraftQuestionTemplate",
    id?: string | null,
    userId?: string | null,
    publicPrivateType?: string | null,
    title?: string | null,
    lowerCaseTitle?: string | null,
    version?: number | null,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelDraftGameQuestionsConnection",
      items:  Array< {
        __typename: "DraftGameQuestions",
        id: string,
        draftGameTemplateID: string,
        draftQuestionTemplateID: string,
        draftGameTemplate:  {
          __typename: "DraftGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          description?: string | null,
          lowerCaseDescription?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        draftQuestionTemplate:  {
          __typename: "DraftQuestionTemplate",
          id?: string | null,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type OnDeleteDraftQuestionTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionDraftQuestionTemplateFilterInput | null,
  owner?: string | null,
};

export type OnDeleteDraftQuestionTemplateSubscription = {
  onDeleteDraftQuestionTemplate?:  {
    __typename: "DraftQuestionTemplate",
    id?: string | null,
    userId?: string | null,
    publicPrivateType?: string | null,
    title?: string | null,
    lowerCaseTitle?: string | null,
    version?: number | null,
    choices?: string | null,
    instructions?: string | null,
    answerSettings?: string | null,
    ccss?: string | null,
    ccssDescription?: string | null,
    domain?: string | null,
    cluster?: string | null,
    grade?: string | null,
    gradeFilter?: string | null,
    standard?: string | null,
    imageUrl?: string | null,
    timesPlayed?: number | null,
    gameTemplates?:  {
      __typename: "ModelDraftGameQuestionsConnection",
      items:  Array< {
        __typename: "DraftGameQuestions",
        id: string,
        draftGameTemplateID: string,
        draftQuestionTemplateID: string,
        draftGameTemplate:  {
          __typename: "DraftGameTemplate",
          id: string,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          description?: string | null,
          lowerCaseDescription?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          phaseOneTime?: number | null,
          phaseTwoTime?: number | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          questionTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          questionTemplatesCount: number,
          questionTemplatesOrder?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        draftQuestionTemplate:  {
          __typename: "DraftQuestionTemplate",
          id?: string | null,
          userId?: string | null,
          publicPrivateType?: string | null,
          title?: string | null,
          lowerCaseTitle?: string | null,
          version?: number | null,
          choices?: string | null,
          instructions?: string | null,
          answerSettings?: string | null,
          ccss?: string | null,
          ccssDescription?: string | null,
          domain?: string | null,
          cluster?: string | null,
          grade?: string | null,
          gradeFilter?: string | null,
          standard?: string | null,
          imageUrl?: string | null,
          timesPlayed?: number | null,
          gameTemplates?:  {
            __typename: "ModelDraftGameQuestionsConnection",
            items:  Array< {
              __typename: "DraftGameQuestions",
              id: string,
              draftGameTemplateID: string,
              draftQuestionTemplateID: string,
              draftGameTemplate:  {
                __typename: "DraftGameTemplate",
                id: string,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                description?: string | null,
                lowerCaseDescription?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                phaseOneTime?: number | null,
                phaseTwoTime?: number | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                questionTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                questionTemplatesCount: number,
                questionTemplatesOrder?: string | null,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              draftQuestionTemplate:  {
                __typename: "DraftQuestionTemplate",
                id?: string | null,
                userId?: string | null,
                publicPrivateType?: string | null,
                title?: string | null,
                lowerCaseTitle?: string | null,
                version?: number | null,
                choices?: string | null,
                instructions?: string | null,
                answerSettings?: string | null,
                ccss?: string | null,
                ccssDescription?: string | null,
                domain?: string | null,
                cluster?: string | null,
                grade?: string | null,
                gradeFilter?: string | null,
                standard?: string | null,
                imageUrl?: string | null,
                timesPlayed?: number | null,
                gameTemplates?:  {
                  __typename: "ModelDraftGameQuestionsConnection",
                  nextToken?: string | null,
                } | null,
                gameTemplatesCount: number,
                createdAt?: string | null,
                updatedAt?: string | null,
                type?: string | null,
                owner?: string | null,
              },
              createdAt: string,
              updatedAt: string,
              owner?: string | null,
            } | null >,
            nextToken?: string | null,
          } | null,
          gameTemplatesCount: number,
          createdAt?: string | null,
          updatedAt?: string | null,
          type?: string | null,
          owner?: string | null,
        },
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    gameTemplatesCount: number,
    createdAt?: string | null,
    updatedAt?: string | null,
    type?: string | null,
    owner?: string | null,
  } | null,
};

export type OnCreateGameSessionSubscriptionVariables = {
  filter?: ModelSubscriptionGameSessionFilterInput | null,
};

export type OnCreateGameSessionSubscription = {
  onCreateGameSession?:  {
    __typename: "GameSession",
    id: string,
    classroomId?: string | null,
    gameId: string,
    startTime?: string | null,
    phaseOneTime: number,
    phaseTwoTime: number,
    teams?:  {
      __typename: "ModelTeamConnection",
      items:  Array< {
        __typename: "Team",
        id: string,
        globalStudentId?: string | null,
        name: string,
        question?:  {
          __typename: "Question",
          id: string,
          text: string,
          choices?: string | null,
          answerSettings?: string | null,
          answerData?: string | null,
          hints?: string | null,
          imageUrl?: string | null,
          instructions?: string | null,
          standard?: string | null,
          cluster?: string | null,
          domain?: string | null,
          grade?: string | null,
          order: number,
          isConfidenceEnabled: boolean,
          isShortAnswerEnabled: boolean,
          isHintEnabled: boolean,
          gameSessionId: string,
        } | null,
        teamMembers?:  {
          __typename: "ModelTeamMemberConnection",
          items:  Array< {
            __typename: "TeamMember",
            id: string,
            isFacilitator?: boolean | null,
            answers?:  {
              __typename: "ModelTeamAnswerConnection",
              items:  Array< {
                __typename: "TeamAnswer",
                id: string,
                isCorrect?: boolean | null,
                isSubmitted: boolean,
                isShortAnswerEnabled: boolean,
                currentState: GameSessionState,
                currentQuestionIndex: number,
                questionId: string,
                teamMemberAnswersId: string,
                teamAnswersId: string,
                teamName?: string | null,
                text: string,
                answer: string,
                confidenceLevel?: ConfidenceLevel | null,
                hint?: string | null,
                createdAt: string,
                updatedAt: string,
              } | null >,
              nextToken?: string | null,
            } | null,
            deviceId: string,
            createdAt: string,
            updatedAt: string,
            teamTeamMembersId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        score: number,
        selectedAvatarIndex: number,
        createdAt: string,
        updatedAt: string,
        gameSessionTeamsId?: string | null,
        teamQuestionId?: string | null,
        teamQuestionOrder?: number | null,
        teamQuestionGameSessionId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    currentQuestionIndex?: number | null,
    currentState: GameSessionState,
    gameCode: number,
    isAdvancedMode: boolean,
    imageUrl?: string | null,
    description?: string | null,
    title?: string | null,
    currentTimer?: number | null,
    studentID?: number | null,
    sessionData?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        text: string,
        choices?: string | null,
        answerSettings?: string | null,
        answerData?: string | null,
        hints?: string | null,
        imageUrl?: string | null,
        instructions?: string | null,
        standard?: string | null,
        cluster?: string | null,
        domain?: string | null,
        grade?: string | null,
        order: number,
        isConfidenceEnabled: boolean,
        isShortAnswerEnabled: boolean,
        isHintEnabled: boolean,
        gameSessionId: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateGameSessionSubscriptionVariables = {
  filter?: ModelSubscriptionGameSessionFilterInput | null,
};

export type OnUpdateGameSessionSubscription = {
  onUpdateGameSession?:  {
    __typename: "GameSession",
    id: string,
    classroomId?: string | null,
    gameId: string,
    startTime?: string | null,
    phaseOneTime: number,
    phaseTwoTime: number,
    teams?:  {
      __typename: "ModelTeamConnection",
      items:  Array< {
        __typename: "Team",
        id: string,
        globalStudentId?: string | null,
        name: string,
        question?:  {
          __typename: "Question",
          id: string,
          text: string,
          choices?: string | null,
          answerSettings?: string | null,
          answerData?: string | null,
          hints?: string | null,
          imageUrl?: string | null,
          instructions?: string | null,
          standard?: string | null,
          cluster?: string | null,
          domain?: string | null,
          grade?: string | null,
          order: number,
          isConfidenceEnabled: boolean,
          isShortAnswerEnabled: boolean,
          isHintEnabled: boolean,
          gameSessionId: string,
        } | null,
        teamMembers?:  {
          __typename: "ModelTeamMemberConnection",
          items:  Array< {
            __typename: "TeamMember",
            id: string,
            isFacilitator?: boolean | null,
            answers?:  {
              __typename: "ModelTeamAnswerConnection",
              items:  Array< {
                __typename: "TeamAnswer",
                id: string,
                isCorrect?: boolean | null,
                isSubmitted: boolean,
                isShortAnswerEnabled: boolean,
                currentState: GameSessionState,
                currentQuestionIndex: number,
                questionId: string,
                teamMemberAnswersId: string,
                teamAnswersId: string,
                teamName?: string | null,
                text: string,
                answer: string,
                confidenceLevel?: ConfidenceLevel | null,
                hint?: string | null,
                createdAt: string,
                updatedAt: string,
              } | null >,
              nextToken?: string | null,
            } | null,
            deviceId: string,
            createdAt: string,
            updatedAt: string,
            teamTeamMembersId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        score: number,
        selectedAvatarIndex: number,
        createdAt: string,
        updatedAt: string,
        gameSessionTeamsId?: string | null,
        teamQuestionId?: string | null,
        teamQuestionOrder?: number | null,
        teamQuestionGameSessionId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    currentQuestionIndex?: number | null,
    currentState: GameSessionState,
    gameCode: number,
    isAdvancedMode: boolean,
    imageUrl?: string | null,
    description?: string | null,
    title?: string | null,
    currentTimer?: number | null,
    studentID?: number | null,
    sessionData?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        text: string,
        choices?: string | null,
        answerSettings?: string | null,
        answerData?: string | null,
        hints?: string | null,
        imageUrl?: string | null,
        instructions?: string | null,
        standard?: string | null,
        cluster?: string | null,
        domain?: string | null,
        grade?: string | null,
        order: number,
        isConfidenceEnabled: boolean,
        isShortAnswerEnabled: boolean,
        isHintEnabled: boolean,
        gameSessionId: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteGameSessionSubscriptionVariables = {
  filter?: ModelSubscriptionGameSessionFilterInput | null,
};

export type OnDeleteGameSessionSubscription = {
  onDeleteGameSession?:  {
    __typename: "GameSession",
    id: string,
    classroomId?: string | null,
    gameId: string,
    startTime?: string | null,
    phaseOneTime: number,
    phaseTwoTime: number,
    teams?:  {
      __typename: "ModelTeamConnection",
      items:  Array< {
        __typename: "Team",
        id: string,
        globalStudentId?: string | null,
        name: string,
        question?:  {
          __typename: "Question",
          id: string,
          text: string,
          choices?: string | null,
          answerSettings?: string | null,
          answerData?: string | null,
          hints?: string | null,
          imageUrl?: string | null,
          instructions?: string | null,
          standard?: string | null,
          cluster?: string | null,
          domain?: string | null,
          grade?: string | null,
          order: number,
          isConfidenceEnabled: boolean,
          isShortAnswerEnabled: boolean,
          isHintEnabled: boolean,
          gameSessionId: string,
        } | null,
        teamMembers?:  {
          __typename: "ModelTeamMemberConnection",
          items:  Array< {
            __typename: "TeamMember",
            id: string,
            isFacilitator?: boolean | null,
            answers?:  {
              __typename: "ModelTeamAnswerConnection",
              items:  Array< {
                __typename: "TeamAnswer",
                id: string,
                isCorrect?: boolean | null,
                isSubmitted: boolean,
                isShortAnswerEnabled: boolean,
                currentState: GameSessionState,
                currentQuestionIndex: number,
                questionId: string,
                teamMemberAnswersId: string,
                teamAnswersId: string,
                teamName?: string | null,
                text: string,
                answer: string,
                confidenceLevel?: ConfidenceLevel | null,
                hint?: string | null,
                createdAt: string,
                updatedAt: string,
              } | null >,
              nextToken?: string | null,
            } | null,
            deviceId: string,
            createdAt: string,
            updatedAt: string,
            teamTeamMembersId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        score: number,
        selectedAvatarIndex: number,
        createdAt: string,
        updatedAt: string,
        gameSessionTeamsId?: string | null,
        teamQuestionId?: string | null,
        teamQuestionOrder?: number | null,
        teamQuestionGameSessionId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    currentQuestionIndex?: number | null,
    currentState: GameSessionState,
    gameCode: number,
    isAdvancedMode: boolean,
    imageUrl?: string | null,
    description?: string | null,
    title?: string | null,
    currentTimer?: number | null,
    studentID?: number | null,
    sessionData?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        text: string,
        choices?: string | null,
        answerSettings?: string | null,
        answerData?: string | null,
        hints?: string | null,
        imageUrl?: string | null,
        instructions?: string | null,
        standard?: string | null,
        cluster?: string | null,
        domain?: string | null,
        grade?: string | null,
        order: number,
        isConfidenceEnabled: boolean,
        isShortAnswerEnabled: boolean,
        isHintEnabled: boolean,
        gameSessionId: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTeamSubscriptionVariables = {
  filter?: ModelSubscriptionTeamFilterInput | null,
};

export type OnCreateTeamSubscription = {
  onCreateTeam?:  {
    __typename: "Team",
    id: string,
    globalStudentId?: string | null,
    name: string,
    question?:  {
      __typename: "Question",
      id: string,
      text: string,
      choices?: string | null,
      answerSettings?: string | null,
      answerData?: string | null,
      hints?: string | null,
      imageUrl?: string | null,
      instructions?: string | null,
      standard?: string | null,
      cluster?: string | null,
      domain?: string | null,
      grade?: string | null,
      order: number,
      isConfidenceEnabled: boolean,
      isShortAnswerEnabled: boolean,
      isHintEnabled: boolean,
      gameSessionId: string,
    } | null,
    teamMembers?:  {
      __typename: "ModelTeamMemberConnection",
      items:  Array< {
        __typename: "TeamMember",
        id: string,
        isFacilitator?: boolean | null,
        answers?:  {
          __typename: "ModelTeamAnswerConnection",
          items:  Array< {
            __typename: "TeamAnswer",
            id: string,
            isCorrect?: boolean | null,
            isSubmitted: boolean,
            isShortAnswerEnabled: boolean,
            currentState: GameSessionState,
            currentQuestionIndex: number,
            questionId: string,
            teamMemberAnswersId: string,
            teamAnswersId: string,
            teamName?: string | null,
            text: string,
            answer: string,
            confidenceLevel?: ConfidenceLevel | null,
            hint?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        deviceId: string,
        createdAt: string,
        updatedAt: string,
        teamTeamMembersId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    score: number,
    selectedAvatarIndex: number,
    createdAt: string,
    updatedAt: string,
    gameSessionTeamsId?: string | null,
    teamQuestionId?: string | null,
    teamQuestionOrder?: number | null,
    teamQuestionGameSessionId?: string | null,
  } | null,
};

export type OnUpdateTeamSubscriptionVariables = {
  filter?: ModelSubscriptionTeamFilterInput | null,
};

export type OnUpdateTeamSubscription = {
  onUpdateTeam?:  {
    __typename: "Team",
    id: string,
    globalStudentId?: string | null,
    name: string,
    question?:  {
      __typename: "Question",
      id: string,
      text: string,
      choices?: string | null,
      answerSettings?: string | null,
      answerData?: string | null,
      hints?: string | null,
      imageUrl?: string | null,
      instructions?: string | null,
      standard?: string | null,
      cluster?: string | null,
      domain?: string | null,
      grade?: string | null,
      order: number,
      isConfidenceEnabled: boolean,
      isShortAnswerEnabled: boolean,
      isHintEnabled: boolean,
      gameSessionId: string,
    } | null,
    teamMembers?:  {
      __typename: "ModelTeamMemberConnection",
      items:  Array< {
        __typename: "TeamMember",
        id: string,
        isFacilitator?: boolean | null,
        answers?:  {
          __typename: "ModelTeamAnswerConnection",
          items:  Array< {
            __typename: "TeamAnswer",
            id: string,
            isCorrect?: boolean | null,
            isSubmitted: boolean,
            isShortAnswerEnabled: boolean,
            currentState: GameSessionState,
            currentQuestionIndex: number,
            questionId: string,
            teamMemberAnswersId: string,
            teamAnswersId: string,
            teamName?: string | null,
            text: string,
            answer: string,
            confidenceLevel?: ConfidenceLevel | null,
            hint?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        deviceId: string,
        createdAt: string,
        updatedAt: string,
        teamTeamMembersId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    score: number,
    selectedAvatarIndex: number,
    createdAt: string,
    updatedAt: string,
    gameSessionTeamsId?: string | null,
    teamQuestionId?: string | null,
    teamQuestionOrder?: number | null,
    teamQuestionGameSessionId?: string | null,
  } | null,
};

export type OnDeleteTeamSubscriptionVariables = {
  filter?: ModelSubscriptionTeamFilterInput | null,
};

export type OnDeleteTeamSubscription = {
  onDeleteTeam?:  {
    __typename: "Team",
    id: string,
    globalStudentId?: string | null,
    name: string,
    question?:  {
      __typename: "Question",
      id: string,
      text: string,
      choices?: string | null,
      answerSettings?: string | null,
      answerData?: string | null,
      hints?: string | null,
      imageUrl?: string | null,
      instructions?: string | null,
      standard?: string | null,
      cluster?: string | null,
      domain?: string | null,
      grade?: string | null,
      order: number,
      isConfidenceEnabled: boolean,
      isShortAnswerEnabled: boolean,
      isHintEnabled: boolean,
      gameSessionId: string,
    } | null,
    teamMembers?:  {
      __typename: "ModelTeamMemberConnection",
      items:  Array< {
        __typename: "TeamMember",
        id: string,
        isFacilitator?: boolean | null,
        answers?:  {
          __typename: "ModelTeamAnswerConnection",
          items:  Array< {
            __typename: "TeamAnswer",
            id: string,
            isCorrect?: boolean | null,
            isSubmitted: boolean,
            isShortAnswerEnabled: boolean,
            currentState: GameSessionState,
            currentQuestionIndex: number,
            questionId: string,
            teamMemberAnswersId: string,
            teamAnswersId: string,
            teamName?: string | null,
            text: string,
            answer: string,
            confidenceLevel?: ConfidenceLevel | null,
            hint?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        deviceId: string,
        createdAt: string,
        updatedAt: string,
        teamTeamMembersId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    score: number,
    selectedAvatarIndex: number,
    createdAt: string,
    updatedAt: string,
    gameSessionTeamsId?: string | null,
    teamQuestionId?: string | null,
    teamQuestionOrder?: number | null,
    teamQuestionGameSessionId?: string | null,
  } | null,
};

export type OnCreateTeamMemberSubscriptionVariables = {
  filter?: ModelSubscriptionTeamMemberFilterInput | null,
};

export type OnCreateTeamMemberSubscription = {
  onCreateTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    isFacilitator?: boolean | null,
    answers?:  {
      __typename: "ModelTeamAnswerConnection",
      items:  Array< {
        __typename: "TeamAnswer",
        id: string,
        isCorrect?: boolean | null,
        isSubmitted: boolean,
        isShortAnswerEnabled: boolean,
        currentState: GameSessionState,
        currentQuestionIndex: number,
        questionId: string,
        teamMemberAnswersId: string,
        teamAnswersId: string,
        teamName?: string | null,
        text: string,
        answer: string,
        confidenceLevel?: ConfidenceLevel | null,
        hint?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deviceId: string,
    createdAt: string,
    updatedAt: string,
    teamTeamMembersId?: string | null,
  } | null,
};

export type OnUpdateTeamMemberSubscriptionVariables = {
  filter?: ModelSubscriptionTeamMemberFilterInput | null,
};

export type OnUpdateTeamMemberSubscription = {
  onUpdateTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    isFacilitator?: boolean | null,
    answers?:  {
      __typename: "ModelTeamAnswerConnection",
      items:  Array< {
        __typename: "TeamAnswer",
        id: string,
        isCorrect?: boolean | null,
        isSubmitted: boolean,
        isShortAnswerEnabled: boolean,
        currentState: GameSessionState,
        currentQuestionIndex: number,
        questionId: string,
        teamMemberAnswersId: string,
        teamAnswersId: string,
        teamName?: string | null,
        text: string,
        answer: string,
        confidenceLevel?: ConfidenceLevel | null,
        hint?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deviceId: string,
    createdAt: string,
    updatedAt: string,
    teamTeamMembersId?: string | null,
  } | null,
};

export type OnDeleteTeamMemberSubscriptionVariables = {
  filter?: ModelSubscriptionTeamMemberFilterInput | null,
};

export type OnDeleteTeamMemberSubscription = {
  onDeleteTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    isFacilitator?: boolean | null,
    answers?:  {
      __typename: "ModelTeamAnswerConnection",
      items:  Array< {
        __typename: "TeamAnswer",
        id: string,
        isCorrect?: boolean | null,
        isSubmitted: boolean,
        isShortAnswerEnabled: boolean,
        currentState: GameSessionState,
        currentQuestionIndex: number,
        questionId: string,
        teamMemberAnswersId: string,
        teamAnswersId: string,
        teamName?: string | null,
        text: string,
        answer: string,
        confidenceLevel?: ConfidenceLevel | null,
        hint?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deviceId: string,
    createdAt: string,
    updatedAt: string,
    teamTeamMembersId?: string | null,
  } | null,
};

export type OnCreateTeamAnswerSubscriptionVariables = {
  filter?: ModelSubscriptionTeamAnswerFilterInput | null,
};

export type OnCreateTeamAnswerSubscription = {
  onCreateTeamAnswer?:  {
    __typename: "TeamAnswer",
    id: string,
    isCorrect?: boolean | null,
    isSubmitted: boolean,
    isShortAnswerEnabled: boolean,
    currentState: GameSessionState,
    currentQuestionIndex: number,
    questionId: string,
    teamMemberAnswersId: string,
    teamAnswersId: string,
    teamName?: string | null,
    text: string,
    answer: string,
    confidenceLevel?: ConfidenceLevel | null,
    hint?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTeamAnswerSubscriptionVariables = {
  filter?: ModelSubscriptionTeamAnswerFilterInput | null,
};

export type OnUpdateTeamAnswerSubscription = {
  onUpdateTeamAnswer?:  {
    __typename: "TeamAnswer",
    id: string,
    isCorrect?: boolean | null,
    isSubmitted: boolean,
    isShortAnswerEnabled: boolean,
    currentState: GameSessionState,
    currentQuestionIndex: number,
    questionId: string,
    teamMemberAnswersId: string,
    teamAnswersId: string,
    teamName?: string | null,
    text: string,
    answer: string,
    confidenceLevel?: ConfidenceLevel | null,
    hint?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteTeamAnswerSubscriptionVariables = {
  filter?: ModelSubscriptionTeamAnswerFilterInput | null,
};

export type OnDeleteTeamAnswerSubscription = {
  onDeleteTeamAnswer?:  {
    __typename: "TeamAnswer",
    id: string,
    isCorrect?: boolean | null,
    isSubmitted: boolean,
    isShortAnswerEnabled: boolean,
    currentState: GameSessionState,
    currentQuestionIndex: number,
    questionId: string,
    teamMemberAnswersId: string,
    teamAnswersId: string,
    teamName?: string | null,
    text: string,
    answer: string,
    confidenceLevel?: ConfidenceLevel | null,
    hint?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePublicGameQuestionsSubscriptionVariables = {
  filter?: ModelSubscriptionPublicGameQuestionsFilterInput | null,
  owner?: string | null,
};

export type OnCreatePublicGameQuestionsSubscription = {
  onCreatePublicGameQuestions?:  {
    __typename: "PublicGameQuestions",
    id: string,
    publicGameTemplateID: string,
    publicQuestionTemplateID: string,
    publicGameTemplate:  {
      __typename: "PublicGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      featuredGroup?: string | null,
      featuredOrder?: number | null,
      type?: string | null,
      owner?: string | null,
    },
    publicQuestionTemplate:  {
      __typename: "PublicQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdatePublicGameQuestionsSubscriptionVariables = {
  filter?: ModelSubscriptionPublicGameQuestionsFilterInput | null,
  owner?: string | null,
};

export type OnUpdatePublicGameQuestionsSubscription = {
  onUpdatePublicGameQuestions?:  {
    __typename: "PublicGameQuestions",
    id: string,
    publicGameTemplateID: string,
    publicQuestionTemplateID: string,
    publicGameTemplate:  {
      __typename: "PublicGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      featuredGroup?: string | null,
      featuredOrder?: number | null,
      type?: string | null,
      owner?: string | null,
    },
    publicQuestionTemplate:  {
      __typename: "PublicQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeletePublicGameQuestionsSubscriptionVariables = {
  filter?: ModelSubscriptionPublicGameQuestionsFilterInput | null,
  owner?: string | null,
};

export type OnDeletePublicGameQuestionsSubscription = {
  onDeletePublicGameQuestions?:  {
    __typename: "PublicGameQuestions",
    id: string,
    publicGameTemplateID: string,
    publicQuestionTemplateID: string,
    publicGameTemplate:  {
      __typename: "PublicGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      featuredGroup?: string | null,
      featuredOrder?: number | null,
      type?: string | null,
      owner?: string | null,
    },
    publicQuestionTemplate:  {
      __typename: "PublicQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPublicGameQuestionsConnection",
        items:  Array< {
          __typename: "PublicGameQuestions",
          id: string,
          publicGameTemplateID: string,
          publicQuestionTemplateID: string,
          publicGameTemplate:  {
            __typename: "PublicGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            featuredGroup?: string | null,
            featuredOrder?: number | null,
            type?: string | null,
            owner?: string | null,
          },
          publicQuestionTemplate:  {
            __typename: "PublicQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPublicGameQuestionsConnection",
              items:  Array< {
                __typename: "PublicGameQuestions",
                id: string,
                publicGameTemplateID: string,
                publicQuestionTemplateID: string,
                publicGameTemplate:  {
                  __typename: "PublicGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  featuredGroup?: string | null,
                  featuredOrder?: number | null,
                  type?: string | null,
                  owner?: string | null,
                },
                publicQuestionTemplate:  {
                  __typename: "PublicQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreatePrivateGameQuestionsSubscriptionVariables = {
  filter?: ModelSubscriptionPrivateGameQuestionsFilterInput | null,
  owner?: string | null,
};

export type OnCreatePrivateGameQuestionsSubscription = {
  onCreatePrivateGameQuestions?:  {
    __typename: "PrivateGameQuestions",
    id: string,
    privateGameTemplateID: string,
    privateQuestionTemplateID: string,
    privateGameTemplate:  {
      __typename: "PrivateGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    privateQuestionTemplate:  {
      __typename: "PrivateQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdatePrivateGameQuestionsSubscriptionVariables = {
  filter?: ModelSubscriptionPrivateGameQuestionsFilterInput | null,
  owner?: string | null,
};

export type OnUpdatePrivateGameQuestionsSubscription = {
  onUpdatePrivateGameQuestions?:  {
    __typename: "PrivateGameQuestions",
    id: string,
    privateGameTemplateID: string,
    privateQuestionTemplateID: string,
    privateGameTemplate:  {
      __typename: "PrivateGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    privateQuestionTemplate:  {
      __typename: "PrivateQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeletePrivateGameQuestionsSubscriptionVariables = {
  filter?: ModelSubscriptionPrivateGameQuestionsFilterInput | null,
  owner?: string | null,
};

export type OnDeletePrivateGameQuestionsSubscription = {
  onDeletePrivateGameQuestions?:  {
    __typename: "PrivateGameQuestions",
    id: string,
    privateGameTemplateID: string,
    privateQuestionTemplateID: string,
    privateGameTemplate:  {
      __typename: "PrivateGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      description: string,
      lowerCaseDescription: string,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    privateQuestionTemplate:  {
      __typename: "PrivateQuestionTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title: string,
      lowerCaseTitle: string,
      version: number,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelPrivateGameQuestionsConnection",
        items:  Array< {
          __typename: "PrivateGameQuestions",
          id: string,
          privateGameTemplateID: string,
          privateQuestionTemplateID: string,
          privateGameTemplate:  {
            __typename: "PrivateGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            description: string,
            lowerCaseDescription: string,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          privateQuestionTemplate:  {
            __typename: "PrivateQuestionTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title: string,
            lowerCaseTitle: string,
            version: number,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelPrivateGameQuestionsConnection",
              items:  Array< {
                __typename: "PrivateGameQuestions",
                id: string,
                privateGameTemplateID: string,
                privateQuestionTemplateID: string,
                privateGameTemplate:  {
                  __typename: "PrivateGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  description: string,
                  lowerCaseDescription: string,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                privateQuestionTemplate:  {
                  __typename: "PrivateQuestionTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title: string,
                  lowerCaseTitle: string,
                  version: number,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateDraftGameQuestionsSubscriptionVariables = {
  filter?: ModelSubscriptionDraftGameQuestionsFilterInput | null,
  owner?: string | null,
};

export type OnCreateDraftGameQuestionsSubscription = {
  onCreateDraftGameQuestions?:  {
    __typename: "DraftGameQuestions",
    id: string,
    draftGameTemplateID: string,
    draftQuestionTemplateID: string,
    draftGameTemplate:  {
      __typename: "DraftGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      description?: string | null,
      lowerCaseDescription?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    draftQuestionTemplate:  {
      __typename: "DraftQuestionTemplate",
      id?: string | null,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateDraftGameQuestionsSubscriptionVariables = {
  filter?: ModelSubscriptionDraftGameQuestionsFilterInput | null,
  owner?: string | null,
};

export type OnUpdateDraftGameQuestionsSubscription = {
  onUpdateDraftGameQuestions?:  {
    __typename: "DraftGameQuestions",
    id: string,
    draftGameTemplateID: string,
    draftQuestionTemplateID: string,
    draftGameTemplate:  {
      __typename: "DraftGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      description?: string | null,
      lowerCaseDescription?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    draftQuestionTemplate:  {
      __typename: "DraftQuestionTemplate",
      id?: string | null,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteDraftGameQuestionsSubscriptionVariables = {
  filter?: ModelSubscriptionDraftGameQuestionsFilterInput | null,
  owner?: string | null,
};

export type OnDeleteDraftGameQuestionsSubscription = {
  onDeleteDraftGameQuestions?:  {
    __typename: "DraftGameQuestions",
    id: string,
    draftGameTemplateID: string,
    draftQuestionTemplateID: string,
    draftGameTemplate:  {
      __typename: "DraftGameTemplate",
      id: string,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      description?: string | null,
      lowerCaseDescription?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      phaseOneTime?: number | null,
      phaseTwoTime?: number | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      questionTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      questionTemplatesCount: number,
      questionTemplatesOrder?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    draftQuestionTemplate:  {
      __typename: "DraftQuestionTemplate",
      id?: string | null,
      userId?: string | null,
      publicPrivateType?: string | null,
      title?: string | null,
      lowerCaseTitle?: string | null,
      version?: number | null,
      choices?: string | null,
      instructions?: string | null,
      answerSettings?: string | null,
      ccss?: string | null,
      ccssDescription?: string | null,
      domain?: string | null,
      cluster?: string | null,
      grade?: string | null,
      gradeFilter?: string | null,
      standard?: string | null,
      imageUrl?: string | null,
      timesPlayed?: number | null,
      gameTemplates?:  {
        __typename: "ModelDraftGameQuestionsConnection",
        items:  Array< {
          __typename: "DraftGameQuestions",
          id: string,
          draftGameTemplateID: string,
          draftQuestionTemplateID: string,
          draftGameTemplate:  {
            __typename: "DraftGameTemplate",
            id: string,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            description?: string | null,
            lowerCaseDescription?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            phaseOneTime?: number | null,
            phaseTwoTime?: number | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            questionTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            questionTemplatesCount: number,
            questionTemplatesOrder?: string | null,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          draftQuestionTemplate:  {
            __typename: "DraftQuestionTemplate",
            id?: string | null,
            userId?: string | null,
            publicPrivateType?: string | null,
            title?: string | null,
            lowerCaseTitle?: string | null,
            version?: number | null,
            choices?: string | null,
            instructions?: string | null,
            answerSettings?: string | null,
            ccss?: string | null,
            ccssDescription?: string | null,
            domain?: string | null,
            cluster?: string | null,
            grade?: string | null,
            gradeFilter?: string | null,
            standard?: string | null,
            imageUrl?: string | null,
            timesPlayed?: number | null,
            gameTemplates?:  {
              __typename: "ModelDraftGameQuestionsConnection",
              items:  Array< {
                __typename: "DraftGameQuestions",
                id: string,
                draftGameTemplateID: string,
                draftQuestionTemplateID: string,
                draftGameTemplate:  {
                  __typename: "DraftGameTemplate",
                  id: string,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  description?: string | null,
                  lowerCaseDescription?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  phaseOneTime?: number | null,
                  phaseTwoTime?: number | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  questionTemplatesCount: number,
                  questionTemplatesOrder?: string | null,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                draftQuestionTemplate:  {
                  __typename: "DraftQuestionTemplate",
                  id?: string | null,
                  userId?: string | null,
                  publicPrivateType?: string | null,
                  title?: string | null,
                  lowerCaseTitle?: string | null,
                  version?: number | null,
                  choices?: string | null,
                  instructions?: string | null,
                  answerSettings?: string | null,
                  ccss?: string | null,
                  ccssDescription?: string | null,
                  domain?: string | null,
                  cluster?: string | null,
                  grade?: string | null,
                  gradeFilter?: string | null,
                  standard?: string | null,
                  imageUrl?: string | null,
                  timesPlayed?: number | null,
                  gameTemplatesCount: number,
                  createdAt?: string | null,
                  updatedAt?: string | null,
                  type?: string | null,
                  owner?: string | null,
                },
                createdAt: string,
                updatedAt: string,
                owner?: string | null,
              } | null >,
              nextToken?: string | null,
            } | null,
            gameTemplatesCount: number,
            createdAt?: string | null,
            updatedAt?: string | null,
            type?: string | null,
            owner?: string | null,
          },
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      gameTemplatesCount: number,
      createdAt?: string | null,
      updatedAt?: string | null,
      type?: string | null,
      owner?: string | null,
    },
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnGameSessionUpdatedByIdSubscriptionVariables = {
  id: string,
};

export type OnGameSessionUpdatedByIdSubscription = {
  onGameSessionUpdatedById?:  {
    __typename: "GameSession",
    id: string,
    classroomId?: string | null,
    gameId: string,
    startTime?: string | null,
    phaseOneTime: number,
    phaseTwoTime: number,
    teams?:  {
      __typename: "ModelTeamConnection",
      items:  Array< {
        __typename: "Team",
        id: string,
        globalStudentId?: string | null,
        name: string,
        question?:  {
          __typename: "Question",
          id: string,
          text: string,
          choices?: string | null,
          answerSettings?: string | null,
          answerData?: string | null,
          hints?: string | null,
          imageUrl?: string | null,
          instructions?: string | null,
          standard?: string | null,
          cluster?: string | null,
          domain?: string | null,
          grade?: string | null,
          order: number,
          isConfidenceEnabled: boolean,
          isShortAnswerEnabled: boolean,
          isHintEnabled: boolean,
          gameSessionId: string,
        } | null,
        teamMembers?:  {
          __typename: "ModelTeamMemberConnection",
          items:  Array< {
            __typename: "TeamMember",
            id: string,
            isFacilitator?: boolean | null,
            answers?:  {
              __typename: "ModelTeamAnswerConnection",
              items:  Array< {
                __typename: "TeamAnswer",
                id: string,
                isCorrect?: boolean | null,
                isSubmitted: boolean,
                isShortAnswerEnabled: boolean,
                currentState: GameSessionState,
                currentQuestionIndex: number,
                questionId: string,
                teamMemberAnswersId: string,
                teamAnswersId: string,
                teamName?: string | null,
                text: string,
                answer: string,
                confidenceLevel?: ConfidenceLevel | null,
                hint?: string | null,
                createdAt: string,
                updatedAt: string,
              } | null >,
              nextToken?: string | null,
            } | null,
            deviceId: string,
            createdAt: string,
            updatedAt: string,
            teamTeamMembersId?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        score: number,
        selectedAvatarIndex: number,
        createdAt: string,
        updatedAt: string,
        gameSessionTeamsId?: string | null,
        teamQuestionId?: string | null,
        teamQuestionOrder?: number | null,
        teamQuestionGameSessionId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    currentQuestionIndex?: number | null,
    currentState: GameSessionState,
    gameCode: number,
    isAdvancedMode: boolean,
    imageUrl?: string | null,
    description?: string | null,
    title?: string | null,
    currentTimer?: number | null,
    studentID?: number | null,
    sessionData?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        text: string,
        choices?: string | null,
        answerSettings?: string | null,
        answerData?: string | null,
        hints?: string | null,
        imageUrl?: string | null,
        instructions?: string | null,
        standard?: string | null,
        cluster?: string | null,
        domain?: string | null,
        grade?: string | null,
        order: number,
        isConfidenceEnabled: boolean,
        isShortAnswerEnabled: boolean,
        isHintEnabled: boolean,
        gameSessionId: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnTeamMemberUpdateByTeamIdSubscriptionVariables = {
  teamTeamMembersId: string,
};

export type OnTeamMemberUpdateByTeamIdSubscription = {
  onTeamMemberUpdateByTeamId?:  {
    __typename: "TeamMember",
    id: string,
    isFacilitator?: boolean | null,
    answers?:  {
      __typename: "ModelTeamAnswerConnection",
      items:  Array< {
        __typename: "TeamAnswer",
        id: string,
        isCorrect?: boolean | null,
        isSubmitted: boolean,
        isShortAnswerEnabled: boolean,
        currentState: GameSessionState,
        currentQuestionIndex: number,
        questionId: string,
        teamMemberAnswersId: string,
        teamAnswersId: string,
        teamName?: string | null,
        text: string,
        answer: string,
        confidenceLevel?: ConfidenceLevel | null,
        hint?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deviceId: string,
    createdAt: string,
    updatedAt: string,
    teamTeamMembersId?: string | null,
  } | null,
};

export type OnTeamCreateByGameSessionIdSubscriptionVariables = {
  gameSessionTeamsId: string,
};

export type OnTeamCreateByGameSessionIdSubscription = {
  onTeamCreateByGameSessionId?:  {
    __typename: "Team",
    id: string,
    globalStudentId?: string | null,
    name: string,
    question?:  {
      __typename: "Question",
      id: string,
      text: string,
      choices?: string | null,
      answerSettings?: string | null,
      answerData?: string | null,
      hints?: string | null,
      imageUrl?: string | null,
      instructions?: string | null,
      standard?: string | null,
      cluster?: string | null,
      domain?: string | null,
      grade?: string | null,
      order: number,
      isConfidenceEnabled: boolean,
      isShortAnswerEnabled: boolean,
      isHintEnabled: boolean,
      gameSessionId: string,
    } | null,
    teamMembers?:  {
      __typename: "ModelTeamMemberConnection",
      items:  Array< {
        __typename: "TeamMember",
        id: string,
        isFacilitator?: boolean | null,
        answers?:  {
          __typename: "ModelTeamAnswerConnection",
          items:  Array< {
            __typename: "TeamAnswer",
            id: string,
            isCorrect?: boolean | null,
            isSubmitted: boolean,
            isShortAnswerEnabled: boolean,
            currentState: GameSessionState,
            currentQuestionIndex: number,
            questionId: string,
            teamMemberAnswersId: string,
            teamAnswersId: string,
            teamName?: string | null,
            text: string,
            answer: string,
            confidenceLevel?: ConfidenceLevel | null,
            hint?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        deviceId: string,
        createdAt: string,
        updatedAt: string,
        teamTeamMembersId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    score: number,
    selectedAvatarIndex: number,
    createdAt: string,
    updatedAt: string,
    gameSessionTeamsId?: string | null,
    teamQuestionId?: string | null,
    teamQuestionOrder?: number | null,
    teamQuestionGameSessionId?: string | null,
  } | null,
};

export type OnTeamDeleteByGameSessionIdSubscriptionVariables = {
  gameSessionTeamsId: string,
};

export type OnTeamDeleteByGameSessionIdSubscription = {
  onTeamDeleteByGameSessionId?:  {
    __typename: "Team",
    id: string,
    globalStudentId?: string | null,
    name: string,
    question?:  {
      __typename: "Question",
      id: string,
      text: string,
      choices?: string | null,
      answerSettings?: string | null,
      answerData?: string | null,
      hints?: string | null,
      imageUrl?: string | null,
      instructions?: string | null,
      standard?: string | null,
      cluster?: string | null,
      domain?: string | null,
      grade?: string | null,
      order: number,
      isConfidenceEnabled: boolean,
      isShortAnswerEnabled: boolean,
      isHintEnabled: boolean,
      gameSessionId: string,
    } | null,
    teamMembers?:  {
      __typename: "ModelTeamMemberConnection",
      items:  Array< {
        __typename: "TeamMember",
        id: string,
        isFacilitator?: boolean | null,
        answers?:  {
          __typename: "ModelTeamAnswerConnection",
          items:  Array< {
            __typename: "TeamAnswer",
            id: string,
            isCorrect?: boolean | null,
            isSubmitted: boolean,
            isShortAnswerEnabled: boolean,
            currentState: GameSessionState,
            currentQuestionIndex: number,
            questionId: string,
            teamMemberAnswersId: string,
            teamAnswersId: string,
            teamName?: string | null,
            text: string,
            answer: string,
            confidenceLevel?: ConfidenceLevel | null,
            hint?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        deviceId: string,
        createdAt: string,
        updatedAt: string,
        teamTeamMembersId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    score: number,
    selectedAvatarIndex: number,
    createdAt: string,
    updatedAt: string,
    gameSessionTeamsId?: string | null,
    teamQuestionId?: string | null,
    teamQuestionOrder?: number | null,
    teamQuestionGameSessionId?: string | null,
  } | null,
};

export type OnTeamUpdateByGameSessionIdSubscriptionVariables = {
  gameSessionTeamsId: string,
};

export type OnTeamUpdateByGameSessionIdSubscription = {
  onTeamUpdateByGameSessionId?:  {
    __typename: "Team",
    id: string,
    globalStudentId?: string | null,
    name: string,
    question?:  {
      __typename: "Question",
      id: string,
      text: string,
      choices?: string | null,
      answerSettings?: string | null,
      answerData?: string | null,
      hints?: string | null,
      imageUrl?: string | null,
      instructions?: string | null,
      standard?: string | null,
      cluster?: string | null,
      domain?: string | null,
      grade?: string | null,
      order: number,
      isConfidenceEnabled: boolean,
      isShortAnswerEnabled: boolean,
      isHintEnabled: boolean,
      gameSessionId: string,
    } | null,
    teamMembers?:  {
      __typename: "ModelTeamMemberConnection",
      items:  Array< {
        __typename: "TeamMember",
        id: string,
        isFacilitator?: boolean | null,
        answers?:  {
          __typename: "ModelTeamAnswerConnection",
          items:  Array< {
            __typename: "TeamAnswer",
            id: string,
            isCorrect?: boolean | null,
            isSubmitted: boolean,
            isShortAnswerEnabled: boolean,
            currentState: GameSessionState,
            currentQuestionIndex: number,
            questionId: string,
            teamMemberAnswersId: string,
            teamAnswersId: string,
            teamName?: string | null,
            text: string,
            answer: string,
            confidenceLevel?: ConfidenceLevel | null,
            hint?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        deviceId: string,
        createdAt: string,
        updatedAt: string,
        teamTeamMembersId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    score: number,
    selectedAvatarIndex: number,
    createdAt: string,
    updatedAt: string,
    gameSessionTeamsId?: string | null,
    teamQuestionId?: string | null,
    teamQuestionOrder?: number | null,
    teamQuestionGameSessionId?: string | null,
  } | null,
};
